import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule, EventEmitter, Output, forwardRef, ViewChild, Directive, HostListener, Self, Optional, Inject, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { v4 } from 'uuid';
import * as i3 from '@angular/forms';
import { FormsModule, UntypedFormControl, ReactiveFormsModule, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import * as i2 from 'ng-click-outside';
import { ClickOutsideModule } from 'ng-click-outside';
import { Litepicker } from 'litepicker';
import 'litepicker/dist/plugins/ranges';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i2$1 from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import * as i3$1 from 'angular2-multiselect-dropdown';
import { AngularMultiSelect, AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import * as i5 from '@iharbeck/ngx-virtual-scroller';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import * as i1$2 from '@angular/cdk/layout';
import { AgGridModule } from 'ag-grid-angular';
import * as i2$2 from 'ngx-chips';
import { TagInputComponent, TagInputModule } from 'ngx-chips';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

const _c0$g = ["*"];
class ApplicationMenuComponent {
    constructor() {
        this.menuItems = [];
    }
}
ApplicationMenuComponent.ɵfac = function ApplicationMenuComponent_Factory(t) { return new (t || ApplicationMenuComponent)(); };
ApplicationMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ApplicationMenuComponent, selectors: [["application-menu"]], inputs: { menuItems: "menuItems" }, ngContentSelectors: _c0$g, decls: 2, vars: 0, consts: [[1, "application-menu"]], template: function ApplicationMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } }, styles: ["button[disabled]{pointer-events:none}.application-menu{width:100%;height:50px;background-color:#fff;display:flex;position:relative;font-family:Roboto;color:#9f9f9f;z-index:2}.application-menu i{font-size:18px}.application-menu .icon-current-state{position:relative;display:flex;flex-direction:column;align-items:center}.application-menu .active-circle{height:9px;width:9px;position:absolute;bottom:-5px;right:-5px;background-color:#4bc36b;border-radius:50%;display:inline-block;border:1px solid white}.application-menu .menu-content-group{display:flex;border-right:1px solid #E3E3E3}.application-menu .menu-content-group .menu-item button{border-right:none}.application-menu .menu-content-group.menu-content-group-right{margin-left:auto;border-right:none}.application-menu .menu-content-group.menu-content-group-right .menu-item button{border-left:1px solid #E3E3E3}.application-menu .menu-item{display:flex;align-content:center;justify-content:center}.application-menu .menu-item.action button i{margin-right:0}.application-menu .menu-item.active button{background:#CCCCCC}.application-menu .menu-item button{border:none;height:50px;margin:0;text-transform:none;border-right:1px solid #E3E3E3;color:#5c5c5c;font-size:14px;font-family:Roboto;font-weight:400;line-height:1.4;display:flex;align-content:center;align-items:center}.application-menu .menu-item button:hover{background-color:#f9f9f9}.application-menu .menu-item button>i{margin-right:10px}.theme-default .application-menu .menu-item button:focus,.theme-default .application-menu .menu-item button:active{color:rgba(var(--default-primary),.9)}.theme-x-pick .application-menu .menu-item button:focus,.theme-x-pick .application-menu .menu-item button:active{color:rgba(var(--xpick-primary),.9)}.theme-ai-studio .application-menu .menu-item button:focus,.theme-ai-studio .application-menu .menu-item button:active{color:rgba(var(--aistudio-primary),.9)}.theme-frontline-creator .application-menu .menu-item button:focus,.theme-frontline-creator .application-menu .menu-item button:active{color:rgba(var(--creator-primary),.9)}.theme-x-make .application-menu .menu-item button:focus,.theme-x-make .application-menu .menu-item button:active{color:rgba(var(--xmake-primary),.9)}.theme-spatial .application-menu .menu-item button:focus,.theme-spatial .application-menu .menu-item button:active{color:rgba(var(--spatial-primary),.9)}.theme-admin .application-menu .menu-item button:focus,.theme-admin .application-menu .menu-item button:active{color:rgba(var(--admin-secondary),.9)}.theme-x-assist .application-menu .menu-item button:focus,.theme-x-assist .application-menu .menu-item button:active{color:rgba(var(--xassist-secondary),.9)}.theme-x-inspect .application-menu .menu-item button:focus,.theme-x-inspect .application-menu .menu-item button:active{color:rgba(var(--xinspect-primary),.9)}.application-menu .menu-item button:active{box-shadow:inset 0 0 6px #ccc}.application-menu .menu-item button p{margin-bottom:0}.application-menu .menu-item.menu-item-tile-no-click{flex-direction:column;padding:15px}.application-menu .menu-item.menu-item-tile{flex-direction:column}.application-menu .menu-item.menu-item-tile button{display:flex;flex-direction:column;align-items:flex-start;height:100%;padding:15px;text-align:left;letter-spacing:0;align-items:stretch}.application-menu .menu-item.menu-item-tile button:hover{background-color:#eceff1}.application-menu .menu-item.menu-item-tile button .menu-item-visual{width:155px;height:100px;background-color:#fff;display:flex;align-content:center;justify-content:center;align-items:center;margin-bottom:15px}.application-menu .menu-item.menu-item-tile button .menu-item-visual i{font-size:3em}.application-menu .menu-item.recent-images{flex:2}.application-menu .menu-item.recent-images .recent-images-wrapper{display:flex;overflow-x:auto;overflow-y:hidden}.application-menu .menu-item.recent-images .image-wrapper2{height:100px;margin-right:15px}.application-menu .menu-item.recent-images .image-wrapper2 img{height:100%;width:auto}.application-menu .menu-item.menu-item-dropdown{height:50px}.application-menu .menu-item.menu-item-dropdown.small{position:relative}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper{display:flex}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper button.selected-option{border-right:none;padding-right:7.5px}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper button.selected-option:hover+.expand-dropdown{background-color:#f9f9f9}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown{padding-left:5px}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper{left:0;background-color:#f9f9f9;z-index:1;position:absolute;display:block;top:50px;width:100%;box-shadow:0 6px 12px #9f9f9f80}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper .menu-item{width:100%}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper .menu-item button{width:100%;border-right:none}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper.full-width{width:100%;display:flex;flex-direction:row;overflow:hidden}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper.full-width .menu-item{width:auto}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApplicationMenuComponent, [{
        type: Component,
        args: [{ selector: 'application-menu', encapsulation: ViewEncapsulation.None, template: "<div class=\"application-menu\"><ng-content></ng-content></div>\n", styles: ["button[disabled]{pointer-events:none}.application-menu{width:100%;height:50px;background-color:#fff;display:flex;position:relative;font-family:Roboto;color:#9f9f9f;z-index:2}.application-menu i{font-size:18px}.application-menu .icon-current-state{position:relative;display:flex;flex-direction:column;align-items:center}.application-menu .active-circle{height:9px;width:9px;position:absolute;bottom:-5px;right:-5px;background-color:#4bc36b;border-radius:50%;display:inline-block;border:1px solid white}.application-menu .menu-content-group{display:flex;border-right:1px solid #E3E3E3}.application-menu .menu-content-group .menu-item button{border-right:none}.application-menu .menu-content-group.menu-content-group-right{margin-left:auto;border-right:none}.application-menu .menu-content-group.menu-content-group-right .menu-item button{border-left:1px solid #E3E3E3}.application-menu .menu-item{display:flex;align-content:center;justify-content:center}.application-menu .menu-item.action button i{margin-right:0}.application-menu .menu-item.active button{background:#CCCCCC}.application-menu .menu-item button{border:none;height:50px;margin:0;text-transform:none;border-right:1px solid #E3E3E3;color:#5c5c5c;font-size:14px;font-family:Roboto;font-weight:400;line-height:1.4;display:flex;align-content:center;align-items:center}.application-menu .menu-item button:hover{background-color:#f9f9f9}.application-menu .menu-item button>i{margin-right:10px}.theme-default .application-menu .menu-item button:focus,.theme-default .application-menu .menu-item button:active{color:rgba(var(--default-primary),.9)}.theme-x-pick .application-menu .menu-item button:focus,.theme-x-pick .application-menu .menu-item button:active{color:rgba(var(--xpick-primary),.9)}.theme-ai-studio .application-menu .menu-item button:focus,.theme-ai-studio .application-menu .menu-item button:active{color:rgba(var(--aistudio-primary),.9)}.theme-frontline-creator .application-menu .menu-item button:focus,.theme-frontline-creator .application-menu .menu-item button:active{color:rgba(var(--creator-primary),.9)}.theme-x-make .application-menu .menu-item button:focus,.theme-x-make .application-menu .menu-item button:active{color:rgba(var(--xmake-primary),.9)}.theme-spatial .application-menu .menu-item button:focus,.theme-spatial .application-menu .menu-item button:active{color:rgba(var(--spatial-primary),.9)}.theme-admin .application-menu .menu-item button:focus,.theme-admin .application-menu .menu-item button:active{color:rgba(var(--admin-secondary),.9)}.theme-x-assist .application-menu .menu-item button:focus,.theme-x-assist .application-menu .menu-item button:active{color:rgba(var(--xassist-secondary),.9)}.theme-x-inspect .application-menu .menu-item button:focus,.theme-x-inspect .application-menu .menu-item button:active{color:rgba(var(--xinspect-primary),.9)}.application-menu .menu-item button:active{box-shadow:inset 0 0 6px #ccc}.application-menu .menu-item button p{margin-bottom:0}.application-menu .menu-item.menu-item-tile-no-click{flex-direction:column;padding:15px}.application-menu .menu-item.menu-item-tile{flex-direction:column}.application-menu .menu-item.menu-item-tile button{display:flex;flex-direction:column;align-items:flex-start;height:100%;padding:15px;text-align:left;letter-spacing:0;align-items:stretch}.application-menu .menu-item.menu-item-tile button:hover{background-color:#eceff1}.application-menu .menu-item.menu-item-tile button .menu-item-visual{width:155px;height:100px;background-color:#fff;display:flex;align-content:center;justify-content:center;align-items:center;margin-bottom:15px}.application-menu .menu-item.menu-item-tile button .menu-item-visual i{font-size:3em}.application-menu .menu-item.recent-images{flex:2}.application-menu .menu-item.recent-images .recent-images-wrapper{display:flex;overflow-x:auto;overflow-y:hidden}.application-menu .menu-item.recent-images .image-wrapper2{height:100px;margin-right:15px}.application-menu .menu-item.recent-images .image-wrapper2 img{height:100%;width:auto}.application-menu .menu-item.menu-item-dropdown{height:50px}.application-menu .menu-item.menu-item-dropdown.small{position:relative}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper{display:flex}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper button.selected-option{border-right:none;padding-right:7.5px}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper button.selected-option:hover+.expand-dropdown{background-color:#f9f9f9}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown{padding-left:5px}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper{left:0;background-color:#f9f9f9;z-index:1;position:absolute;display:block;top:50px;width:100%;box-shadow:0 6px 12px #9f9f9f80}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper .menu-item{width:100%}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper .menu-item button{width:100%;border-right:none}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper.full-width{width:100%;display:flex;flex-direction:row;overflow:hidden}.application-menu .menu-item.menu-item-dropdown .dropdown-button-wrapper .expand-dropdown .dropdown-content-wrapper.full-width .menu-item{width:auto}\n"] }]
    }], null, { menuItems: [{
            type: Input
        }] }); })();

class ApplicationMenuModule {
}
ApplicationMenuModule.ɵfac = function ApplicationMenuModule_Factory(t) { return new (t || ApplicationMenuModule)(); };
ApplicationMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ApplicationMenuModule });
ApplicationMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApplicationMenuModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ApplicationMenuComponent,
                ],
                exports: [
                    ApplicationMenuComponent,
                ],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ApplicationMenuModule, { declarations: [ApplicationMenuComponent], imports: [CommonModule], exports: [ApplicationMenuComponent] }); })();

function ButtonPrimaryComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("icon icon-", ctx_r0.icon, "");
} }
function ButtonPrimaryComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
} }
class ButtonPrimaryComponent {
    constructor() {
        this.icon = '';
        this.text = '';
        this.disabled = false;
    }
}
ButtonPrimaryComponent.ɵfac = function ButtonPrimaryComponent_Factory(t) { return new (t || ButtonPrimaryComponent)(); };
ButtonPrimaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonPrimaryComponent, selectors: [["button-primary"]], inputs: { icon: "icon", text: "text", disabled: "disabled" }, decls: 3, vars: 3, consts: [[1, "button", "button-primary", 3, "disabled"], [3, "class", 4, "ngIf"], [4, "ngIf"]], template: function ButtonPrimaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵtemplate(1, ButtonPrimaryComponent_i_1_Template, 1, 3, "i", 1);
        i0.ɵɵtemplate(2, ButtonPrimaryComponent_span_2_Template, 2, 1, "span", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.icon !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.text !== undefined);
    } }, dependencies: [i1.NgIf], styles: ["*[_nghost-%COMP%]{pointer-events:none}*[_nghost-%COMP%]   button[_ngcontent-%COMP%]{pointer-events:auto}*[_nghost-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], *[_nghost-%COMP%]   button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonPrimaryComponent, [{
        type: Component,
        args: [{ selector: 'button-primary', template: "<button class=\"button button-primary\" [disabled]=\"disabled\">\n\t<i *ngIf=\"icon !== undefined\" class=\"icon icon-{{icon}}\"></i>\n\t<span *ngIf=\"text !== undefined\">\n        {{text}}\n    </span>\n</button>\n", styles: [":host(*){pointer-events:none}:host(*) button{pointer-events:auto}:host(*) button span,:host(*) button i{pointer-events:none}\n"] }]
    }], null, { icon: [{
            type: Input
        }], text: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class ButtonPrimaryModule {
}
ButtonPrimaryModule.ɵfac = function ButtonPrimaryModule_Factory(t) { return new (t || ButtonPrimaryModule)(); };
ButtonPrimaryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ButtonPrimaryModule });
ButtonPrimaryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonPrimaryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ButtonPrimaryComponent,
                ],
                exports: [
                    ButtonPrimaryComponent,
                ],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ButtonPrimaryModule, { declarations: [ButtonPrimaryComponent], imports: [CommonModule], exports: [ButtonPrimaryComponent] }); })();

function ButtonQuaternaryComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("icon icon-", ctx_r0.icon, "");
} }
function ButtonQuaternaryComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
} }
class ButtonQuaternaryComponent {
    constructor() {
        this.icon = '';
        this.text = '';
        this.disabled = false;
    }
}
ButtonQuaternaryComponent.ɵfac = function ButtonQuaternaryComponent_Factory(t) { return new (t || ButtonQuaternaryComponent)(); };
ButtonQuaternaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonQuaternaryComponent, selectors: [["button-quaternary"]], inputs: { icon: "icon", text: "text", disabled: "disabled" }, decls: 3, vars: 3, consts: [[1, "button", "button-quaternary", 3, "disabled"], [3, "class", 4, "ngIf"], [4, "ngIf"]], template: function ButtonQuaternaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵtemplate(1, ButtonQuaternaryComponent_i_1_Template, 1, 3, "i", 1);
        i0.ɵɵtemplate(2, ButtonQuaternaryComponent_span_2_Template, 2, 1, "span", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.icon !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.text !== undefined);
    } }, dependencies: [i1.NgIf], styles: ["*[_nghost-%COMP%]{pointer-events:none}*[_nghost-%COMP%]   button[_ngcontent-%COMP%]{pointer-events:auto}*[_nghost-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], *[_nghost-%COMP%]   button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonQuaternaryComponent, [{
        type: Component,
        args: [{ selector: 'button-quaternary', template: "<button class=\"button button-quaternary\" [disabled]=\"disabled\">\n\t<i *ngIf=\"icon !== undefined\" class=\"icon icon-{{icon}}\"></i>\n\t<span *ngIf=\"text !== undefined\">\n        {{text}}\n    </span>\n</button>\n", styles: [":host(*){pointer-events:none}:host(*) button{pointer-events:auto}:host(*) button span,:host(*) button i{pointer-events:none}\n"] }]
    }], null, { icon: [{
            type: Input
        }], text: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class ButtonQuaternaryModule {
}
ButtonQuaternaryModule.ɵfac = function ButtonQuaternaryModule_Factory(t) { return new (t || ButtonQuaternaryModule)(); };
ButtonQuaternaryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ButtonQuaternaryModule });
ButtonQuaternaryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonQuaternaryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ButtonQuaternaryComponent,
                ],
                exports: [
                    ButtonQuaternaryComponent,
                ],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ButtonQuaternaryModule, { declarations: [ButtonQuaternaryComponent], imports: [CommonModule], exports: [ButtonQuaternaryComponent] }); })();

function ButtonSecondaryComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("icon icon-", ctx_r0.icon, "");
} }
function ButtonSecondaryComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
} }
class ButtonSecondaryComponent {
    constructor() {
        this.icon = '';
        this.text = '';
        this.disabled = false;
    }
}
ButtonSecondaryComponent.ɵfac = function ButtonSecondaryComponent_Factory(t) { return new (t || ButtonSecondaryComponent)(); };
ButtonSecondaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonSecondaryComponent, selectors: [["button-secondary"]], inputs: { icon: "icon", text: "text", disabled: "disabled" }, decls: 3, vars: 3, consts: [[1, "button", "button-secondary", 3, "disabled"], [3, "class", 4, "ngIf"], [4, "ngIf"]], template: function ButtonSecondaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵtemplate(1, ButtonSecondaryComponent_i_1_Template, 1, 3, "i", 1);
        i0.ɵɵtemplate(2, ButtonSecondaryComponent_span_2_Template, 2, 1, "span", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.icon !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.text !== undefined);
    } }, dependencies: [i1.NgIf], styles: ["*[_nghost-%COMP%]{pointer-events:none}*[_nghost-%COMP%]   button[_ngcontent-%COMP%]{pointer-events:auto}*[_nghost-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], *[_nghost-%COMP%]   button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonSecondaryComponent, [{
        type: Component,
        args: [{ selector: 'button-secondary', template: "<button class=\"button button-secondary\" [disabled]=\"disabled\">\n\t<i *ngIf=\"icon !== undefined\" class=\"icon icon-{{icon}}\"></i>\n\t<span *ngIf=\"text !== undefined\">\n        {{text}}\n    </span>\n</button>\n", styles: [":host(*){pointer-events:none}:host(*) button{pointer-events:auto}:host(*) button span,:host(*) button i{pointer-events:none}\n"] }]
    }], null, { icon: [{
            type: Input
        }], text: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class ButtonSecondaryModule {
}
ButtonSecondaryModule.ɵfac = function ButtonSecondaryModule_Factory(t) { return new (t || ButtonSecondaryModule)(); };
ButtonSecondaryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ButtonSecondaryModule });
ButtonSecondaryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonSecondaryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ButtonSecondaryComponent,
                ],
                exports: [
                    ButtonSecondaryComponent,
                ],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ButtonSecondaryModule, { declarations: [ButtonSecondaryComponent], imports: [CommonModule], exports: [ButtonSecondaryComponent] }); })();

function CheckBoxComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.label);
} }
class CheckBoxComponent {
    constructor() {
        /** @type {boolean} */
        this.isDisabled = false;
        /** @type {string} */
        this.label = '';
        /** @type {string} */
        this.id = '';
        /** @type {Function} */
        this.onChange = new EventEmitter();
    }
    updateValue(event) {
        this.checked = event.srcElement.checked;
        this.onChange.emit(this.checked);
    }
    ngOnInit() {
        if (!this.id) {
            this.id = v4();
        }
    }
}
CheckBoxComponent.ɵfac = function CheckBoxComponent_Factory(t) { return new (t || CheckBoxComponent)(); };
CheckBoxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckBoxComponent, selectors: [["checkbox"]], inputs: { isDisabled: "isDisabled", label: "label", id: "id", checked: "checked" }, outputs: { onChange: "onChange" }, decls: 4, vars: 6, consts: [[1, "form-check"], ["type", "checkbox", "label", "label", 3, "id", "name", "ngModel", "ngModelChange", "change"], [3, "for"], [4, "ngIf"]], template: function CheckBoxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "input", 1);
        i0.ɵɵlistener("ngModelChange", function CheckBoxComponent_Template_input_ngModelChange_1_listener($event) { return ctx.checked = $event; })("change", function CheckBoxComponent_Template_input_change_1_listener($event) { return ctx.updateValue($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "label", 2);
        i0.ɵɵtemplate(3, CheckBoxComponent_span_3_Template, 2, 1, "span", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("id", ctx.id);
        i0.ɵɵpropertyInterpolate("name", ctx.id);
        i0.ɵɵproperty("ngModel", ctx.checked);
        i0.ɵɵattribute("cy-data", ctx.id);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("for", ctx.id);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.label !== undefined);
    } }, dependencies: [i1.NgIf, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel], styles: [".form-check input[type=checkbox]{z-index:1;cursor:pointer;width:16px;height:16px;opacity:1;position:relative;top:4px}.theme-default .form-check input[type=checkbox]{accent-color:var(--default-secondary);border-color:var(--default-secondary)}.theme-x-pick .form-check input[type=checkbox]{accent-color:var(--xpick-secondary);border-color:var(--xpick-secondary)}.theme-ai-studio .form-check input[type=checkbox]{accent-color:var(--aistudio-secondary);border-color:var(--aistudio-secondary)}.theme-frontline-creator .form-check input[type=checkbox]{accent-color:var(--creator-secondary);border-color:var(--creator-secondary)}.theme-x-make .form-check input[type=checkbox]{accent-color:var(--xmake-secondary);border-color:var(--xmake-secondary)}.theme-spatial .form-check input[type=checkbox]{accent-color:var(--spatial-secondary);border-color:var(--spatial-secondary)}.theme-admin .form-check input[type=checkbox]{accent-color:var(--admin-secondary);border-color:var(--admin-secondary)}.theme-x-assist .form-check input[type=checkbox]{accent-color:var(--xassist-secondary);border-color:var(--xassist-secondary)}.theme-x-inspect .form-check input[type=checkbox]{accent-color:var(--xinspect-secondary);border-color:var(--xinspect-secondary)}.form-check label{margin-left:10px!important}.form-check label:before,.form-check label:after{display:none!important}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckBoxComponent, [{
        type: Component,
        args: [{ selector: 'checkbox', encapsulation: ViewEncapsulation.None, template: "<div class=\"form-check\">\n    <input\n        type=\"checkbox\"\n        id=\"{{id}}\"\n        name=\"{{id}}\"\n\t\t[attr.cy-data]=\"id\"\n        [(ngModel)]=\"checked\"\n        (change)=\"updateValue($event)\"\n        label=\"label\"\n     />\n    <label for=\"{{id}}\">\n        <span *ngIf=\"label !== undefined\" >{{label}}</span>\n    </label>\n</div>\n", styles: [".form-check input[type=checkbox]{z-index:1;cursor:pointer;width:16px;height:16px;opacity:1;position:relative;top:4px}.theme-default .form-check input[type=checkbox]{accent-color:var(--default-secondary);border-color:var(--default-secondary)}.theme-x-pick .form-check input[type=checkbox]{accent-color:var(--xpick-secondary);border-color:var(--xpick-secondary)}.theme-ai-studio .form-check input[type=checkbox]{accent-color:var(--aistudio-secondary);border-color:var(--aistudio-secondary)}.theme-frontline-creator .form-check input[type=checkbox]{accent-color:var(--creator-secondary);border-color:var(--creator-secondary)}.theme-x-make .form-check input[type=checkbox]{accent-color:var(--xmake-secondary);border-color:var(--xmake-secondary)}.theme-spatial .form-check input[type=checkbox]{accent-color:var(--spatial-secondary);border-color:var(--spatial-secondary)}.theme-admin .form-check input[type=checkbox]{accent-color:var(--admin-secondary);border-color:var(--admin-secondary)}.theme-x-assist .form-check input[type=checkbox]{accent-color:var(--xassist-secondary);border-color:var(--xassist-secondary)}.theme-x-inspect .form-check input[type=checkbox]{accent-color:var(--xinspect-secondary);border-color:var(--xinspect-secondary)}.form-check label{margin-left:10px!important}.form-check label:before,.form-check label:after{display:none!important}\n"] }]
    }], null, { isDisabled: [{
            type: Input
        }], label: [{
            type: Input
        }], id: [{
            type: Input
        }], onChange: [{
            type: Output
        }], checked: [{
            type: Input
        }] }); })();

class CheckboxModule {
}
CheckboxModule.ɵfac = function CheckboxModule_Factory(t) { return new (t || CheckboxModule)(); };
CheckboxModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CheckboxModule });
CheckboxModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CheckBoxComponent,
                ],
                exports: [
                    CheckBoxComponent,
                ],
                imports: [
                    CommonModule,
                    FormsModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CheckboxModule, { declarations: [CheckBoxComponent], imports: [CommonModule,
        FormsModule], exports: [CheckBoxComponent] }); })();

function ButtonSecondaryDropdownComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("icon icon-", ctx_r0.icon, "");
} }
function ButtonSecondaryDropdownComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
} }
function ButtonSecondaryDropdownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("clickOutside", function ButtonSecondaryDropdownComponent_div_3_Template_div_clickOutside_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onClickedOutside()); });
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("emitOnBlur", true);
} }
const _c0$f = ["*"];
class ButtonSecondaryDropdownComponent {
    constructor() {
        this.icon = '';
        this.text = '';
        this.disabled = false;
        this.showDropdown = false;
    }
    onClickedOutside() {
        if (this.showDropdown) {
            this.showDropdown = !this.showDropdown;
        }
    }
}
ButtonSecondaryDropdownComponent.ɵfac = function ButtonSecondaryDropdownComponent_Factory(t) { return new (t || ButtonSecondaryDropdownComponent)(); };
ButtonSecondaryDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonSecondaryDropdownComponent, selectors: [["button-secondary-dropdown"]], inputs: { icon: "icon", text: "text", disabled: "disabled" }, ngContentSelectors: _c0$f, decls: 4, vars: 4, consts: [[1, "callout-anchor", "button", "button-secondary", "button-secondary-dropdown-trigger", 3, "disabled", "click"], [3, "class", 4, "ngIf"], [4, "ngIf"], ["class", "callout-container medium", 3, "emitOnBlur", "clickOutside", 4, "ngIf"], [1, "callout-container", "medium", 3, "emitOnBlur", "clickOutside"]], template: function ButtonSecondaryDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function ButtonSecondaryDropdownComponent_Template_button_click_0_listener($event) { ctx.showDropdown = !ctx.showDropdown; return $event.stopPropagation(); });
        i0.ɵɵtemplate(1, ButtonSecondaryDropdownComponent_i_1_Template, 1, 3, "i", 1);
        i0.ɵɵtemplate(2, ButtonSecondaryDropdownComponent_span_2_Template, 2, 1, "span", 2);
        i0.ɵɵtemplate(3, ButtonSecondaryDropdownComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.icon !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.text !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showDropdown);
    } }, dependencies: [i1.NgIf, i2.ClickOutsideDirective], styles: ["[_nghost-%COMP%]{pointer-events:none}[_nghost-%COMP%]     button span{pointer-events:none}[_nghost-%COMP%]     button i{pointer-events:none}button[_ngcontent-%COMP%]{pointer-events:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonSecondaryDropdownComponent, [{
        type: Component,
        args: [{ selector: 'button-secondary-dropdown', template: "<button (click)=\"showDropdown = !showDropdown; $event.stopPropagation()\"\n        class=\"callout-anchor button button-secondary button-secondary-dropdown-trigger\"\n        [disabled]=\"disabled\">\n    <i  *ngIf=\"icon !== undefined\" class=\"icon icon-{{icon}}\"></i>\n    <span *ngIf=\"text !== undefined\">\n            {{text}}\n    </span>\n    <div *ngIf=\"showDropdown\"\n         (clickOutside)=\"onClickedOutside()\"\n         [emitOnBlur]=\"true\"\n         class=\"callout-container medium\">\n        <ng-content></ng-content>\n    </div>\n</button>\n", styles: [":host{pointer-events:none}:host /deep/ button span{pointer-events:none}:host /deep/ button i{pointer-events:none}button{pointer-events:auto}\n"] }]
    }], null, { icon: [{
            type: Input
        }], text: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class ButtonSecondaryDropdownModule {
}
ButtonSecondaryDropdownModule.ɵfac = function ButtonSecondaryDropdownModule_Factory(t) { return new (t || ButtonSecondaryDropdownModule)(); };
ButtonSecondaryDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ButtonSecondaryDropdownModule });
ButtonSecondaryDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ClickOutsideModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonSecondaryDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ButtonSecondaryDropdownComponent,
                ],
                exports: [
                    ButtonSecondaryDropdownComponent,
                ],
                imports: [
                    CommonModule,
                    ClickOutsideModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ButtonSecondaryDropdownModule, { declarations: [ButtonSecondaryDropdownComponent], imports: [CommonModule,
        ClickOutsideModule], exports: [ButtonSecondaryDropdownComponent] }); })();

function ShareButtonComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 3);
    i0.ɵɵelement(2, "i", 4);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r0.getMailToContent(), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.shareMailText);
} }
function ShareButtonComponent_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 5);
    i0.ɵɵlistener("click", function ShareButtonComponent_li_4_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.shareWhatsapp()); });
    i0.ɵɵelement(2, "i", 6);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.shareWhatsappText);
} }
class ShareButtonComponent {
    constructor() {
        this.whatsappUrl = 'https://web.whatsapp.com/send?text=';
        this.id = '';
        this.text = '';
        this.disabled = false;
        this.enableMail = false;
        this.shareMailText = '';
        this.enableWhatsapp = false;
        this.shareWhatsappText = '';
        this.content = '';
    }
    shareWhatsapp() {
        let shareUrl = this.whatsappUrl + encodeURI(this.content);
        window.open(shareUrl, '_blank');
    }
    getMailToContent() {
        return 'mailto:?subject=' + encodeURI(this.content);
    }
}
ShareButtonComponent.ɵfac = function ShareButtonComponent_Factory(t) { return new (t || ShareButtonComponent)(); };
ShareButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShareButtonComponent, selectors: [["share-button"]], inputs: { id: "id", text: "text", disabled: "disabled", enableMail: "enableMail", shareMailText: "shareMailText", enableWhatsapp: "enableWhatsapp", shareWhatsappText: "shareWhatsappText", content: "content" }, decls: 5, vars: 6, consts: [[1, "share-button"], [1, "btn-right", 3, "icon", "id", "text", "disabled"], [4, "ngIf"], [3, "href"], [1, "icon", "icon-Email"], [3, "click"], [1, "icon", "icon-whatsapp"]], template: function ShareButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button-secondary-dropdown", 1)(2, "ul");
        i0.ɵɵtemplate(3, ShareButtonComponent_li_3_Template, 5, 2, "li", 2);
        i0.ɵɵtemplate(4, ShareButtonComponent_li_4_Template, 5, 1, "li", 2);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("icon", "share-alt")("id", ctx.id)("text", ctx.text)("disabled", ctx.disabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.enableMail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enableWhatsapp);
    } }, dependencies: [i1.NgIf, ButtonSecondaryDropdownComponent], styles: ["i[_ngcontent-%COMP%]{padding-left:2%;padding-right:2%;font-size:16px}span[_ngcontent-%COMP%]{font-size:14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShareButtonComponent, [{
        type: Component,
        args: [{ selector: 'share-button', template: "<div class=\"share-button\">\n\t<button-secondary-dropdown\n\t\t[icon]=\"'share-alt'\"\n\t\tclass=\"btn-right\"\n\t\t[id]=\"id\"\n\t\t[text]=\"text\"\n\t\t[disabled]=\"disabled\">\n\t\t<ul>\n\t\t\t<li *ngIf=\"enableMail\">\n\t\t\t\t<a [href]=\"getMailToContent()\">\n\t\t\t\t\t<i class=\"icon icon-Email\"></i>\n\t\t\t\t\t<span>{{shareMailText}}</span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li *ngIf=\"enableWhatsapp\">\n\t\t\t\t<a (click)=\"shareWhatsapp()\">\n\t\t\t\t\t<i class=\"icon icon-whatsapp\"></i>\n\t\t\t\t\t<span>{{shareWhatsappText}}</span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</button-secondary-dropdown>\n</div>\n", styles: ["i{padding-left:2%;padding-right:2%;font-size:16px}span{font-size:14px}\n"] }]
    }], function () { return []; }, { id: [{
            type: Input
        }], text: [{
            type: Input
        }], disabled: [{
            type: Input
        }], enableMail: [{
            type: Input
        }], shareMailText: [{
            type: Input
        }], enableWhatsapp: [{
            type: Input
        }], shareWhatsappText: [{
            type: Input
        }], content: [{
            type: Input
        }] }); })();

class ShareButtonModule {
}
ShareButtonModule.ɵfac = function ShareButtonModule_Factory(t) { return new (t || ShareButtonModule)(); };
ShareButtonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ShareButtonModule });
ShareButtonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ButtonSecondaryDropdownModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShareButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ShareButtonComponent,
                ],
                exports: [
                    ShareButtonComponent,
                ],
                imports: [
                    CommonModule,
                    ButtonSecondaryDropdownModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ShareButtonModule, { declarations: [ShareButtonComponent], imports: [CommonModule,
        ButtonSecondaryDropdownModule], exports: [ShareButtonComponent] }); })();

const _c0$e = function (a0, a1) { return { "icon-th-large": a0, "icon-minus-circle-solid": a1 }; };
function DatasetSliderComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 6);
    i0.ɵɵlistener("click", function DatasetSliderComponent_i_1_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.zoomIn()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c0$e, ctx_r0.grid, !ctx_r0.grid));
} }
const _c1$8 = function (a0, a1) { return { "icon-th": a0, "icon-plus-circle-solid": a1 }; };
function DatasetSliderComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 7);
    i0.ɵɵlistener("click", function DatasetSliderComponent_i_5_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.zoomOut()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1$8, ctx_r2.grid, !ctx_r2.grid));
} }
class DatasetSliderComponent {
    constructor() {
        this.value = 0;
        this.valueChange = new EventEmitter();
        this.min = 0;
        this.max = 0;
        this.step = 0;
        this.grid = true;
        this.showIcon = true;
        this.onValueUpdate = new EventEmitter();
        this.sliderControl = new UntypedFormControl();
    }
    ngOnInit() {
        this.sliderControl.setValue(this.value);
    }
    onChange($event) {
        this.value = +$event.target.value; // make sure it is a number
        this.valueChange.emit(this.value);
        this.onValueUpdate.emit(this.value);
    }
    zoomOut() {
        if (this.value < this.max) {
            this.value += this.step;
            this.value = this.value > this.max ? this.max : this.value;
            this.onValueUpdate.emit(this.value);
        }
    }
    zoomIn() {
        if (this.value > this.min) {
            this.value -= this.step;
            this.value = this.value < this.min ? this.min : this.value;
            this.onValueUpdate.emit(this.value);
        }
    }
}
DatasetSliderComponent.ɵfac = function DatasetSliderComponent_Factory(t) { return new (t || DatasetSliderComponent)(); };
DatasetSliderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatasetSliderComponent, selectors: [["dataset-slider"]], inputs: { value: "value", min: "min", max: "max", step: "step", grid: "grid", showIcon: "showIcon" }, outputs: { valueChange: "valueChange", onValueUpdate: "onValueUpdate" }, decls: 6, vars: 7, consts: [[1, "range-slider-wrapper"], ["class", "range-slider-icon-left icon icon-2x", 3, "ngClass", "click", 4, "ngIf"], [1, "range-slider"], ["type", "range", 1, "range-slider-range", 3, "formControl", "value", "min", "max", "step", "input"], ["datasetSlider", ""], ["class", "range-slider-icon-right icon icon-2x", 3, "ngClass", "click", 4, "ngIf"], [1, "range-slider-icon-left", "icon", "icon-2x", 3, "ngClass", "click"], [1, "range-slider-icon-right", "icon", "icon-2x", 3, "ngClass", "click"]], template: function DatasetSliderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DatasetSliderComponent_i_1_Template, 1, 4, "i", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "input", 3, 4);
        i0.ɵɵlistener("input", function DatasetSliderComponent_Template_input_input_3_listener($event) { return ctx.onChange($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(5, DatasetSliderComponent_i_5_Template, 1, 4, "i", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showIcon);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("value", ctx.value);
        i0.ɵɵpropertyInterpolate("min", ctx.min);
        i0.ɵɵpropertyInterpolate("max", ctx.max);
        i0.ɵɵpropertyInterpolate("step", ctx.step);
        i0.ɵɵproperty("formControl", ctx.sliderControl);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showIcon);
    } }, dependencies: [i1.NgClass, i1.NgIf, i3.DefaultValueAccessor, i3.RangeValueAccessor, i3.NgControlStatus, i3.FormControlDirective], styles: [".range-slider-wrapper .icon{cursor:pointer}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatasetSliderComponent, [{
        type: Component,
        args: [{ selector: 'dataset-slider', encapsulation: ViewEncapsulation.None, template: "<div class=\"range-slider-wrapper\">\n    <i *ngIf=\"showIcon\"\n\t   class=\"range-slider-icon-left icon icon-2x\"\n\t   (click)=\"zoomIn()\"\n\t   [ngClass]=\"{'icon-th-large': grid, 'icon-minus-circle-solid': !grid }\"></i>\n    <div class=\"range-slider\">\n        <input #datasetSlider\n               [formControl]=\"sliderControl\"\n               class=\"range-slider-range\"\n               type=\"range\"\n               value=\"{{value}}\"\n               min=\"{{min}}\"\n               max=\"{{max}}\"\n               step=\"{{step}}\"\n               (input)=\"onChange($event)\">\n    </div>\n    <i *ngIf=\"showIcon\"\n\t   class=\"range-slider-icon-right icon icon-2x\"\n\t   (click)=\"zoomOut()\"\n\t   [ngClass]=\"{'icon-th': grid, 'icon-plus-circle-solid': !grid }\"></i>\n</div>\n", styles: [".range-slider-wrapper .icon{cursor:pointer}\n"] }]
    }], function () { return []; }, { value: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], step: [{
            type: Input
        }], grid: [{
            type: Input
        }], showIcon: [{
            type: Input
        }], onValueUpdate: [{
            type: Output
        }] }); })();

class DatasetSliderModule {
}
DatasetSliderModule.ɵfac = function DatasetSliderModule_Factory(t) { return new (t || DatasetSliderModule)(); };
DatasetSliderModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DatasetSliderModule });
DatasetSliderModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ReactiveFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatasetSliderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DatasetSliderComponent,
                ],
                exports: [
                    DatasetSliderComponent,
                ],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DatasetSliderModule, { declarations: [DatasetSliderComponent], imports: [CommonModule,
        ReactiveFormsModule], exports: [DatasetSliderComponent] }); })();

const _c0$d = ["dateRange"];
const _c1$7 = ["plannedDate"];
const _c2$4 = ["parentDiv"];
function DateRangeComponent_i_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 9);
    i0.ɵɵlistener("click", function DateRangeComponent_i_9_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.removeInput()); });
    i0.ɵɵelementEnd();
} }
const DATE_RANGE_DEFAULT_OPTIONS = {
    singleMode: false,
    resetButton: false
};
class DateRangeComponent {
    constructor() {
        this.id = '';
        this.label = '';
        this.placeholder = "Select date range...";
        this.options = {
            singleMode: false
        };
        this.removeBtn = false;
        this.ngModelChange = new EventEmitter();
        this.dateRangeChangeCallBack = new EventEmitter();
        this.datePickerInput = null;
        this.pickerElementRendered = false;
        this._disabled = false;
        this._lang = '';
        this.onChange = (value) => { };
        this.onTouched = () => { };
    }
    set lang(value) {
        this._lang = value ? value.replace('_', "-") : "en-US";
        if (this.pickerElementRendered) {
            this.setupLitePicker();
        }
    }
    set ranges(value) {
        this._ranges = value;
    }
    ;
    set disabled(value) {
        this._disabled = value !== false;
    }
    ngOnChanges() {
        this.options = {
            ...DATE_RANGE_DEFAULT_OPTIONS,
            ...this.options,
        };
    }
    ngOnInit() {
        this._inputValue = this.ngModel;
        if (!this.id) {
            this.id = v4();
        }
    }
    ngOnDestroy() {
        if (this.datePickerInput) {
            this.datePickerInput.destroy();
        }
    }
    // workaround to wait for view
    ngAfterViewInit() {
        if (this.pickerElementRendered) {
            return;
        }
        if (this.datePickerEl) {
            this.pickerElementRendered = true;
            this.setupLitePicker(this.datePickerEl.nativeElement);
        }
    }
    setupLitePicker(el) {
        if (!el) {
            return;
        }
        let config = {
            element: el,
            parentEl: this.parentDiv.nativeElement,
            lang: this._lang == "" ? 'en-US' : this._lang,
            ranges: {
                customRanges: this._ranges
            },
            setup: (picker) => {
                picker.on('clear:selection', () => {
                    this.updateValue(undefined);
                });
                picker.on('selected', (date1, date2) => {
                    if (this.options.singleMode) {
                        this.ngModel = this.dayjs(date1.toJSDate());
                    }
                    else {
                        this.ngModel = {
                            startDate: this.dayjs(date1.toJSDate()).hour(0).minute(0).second(0),
                            endDate: this.dayjs(date2.toJSDate()).hour(23).minute(59).second(59)
                        };
                    }
                    this.updateValue(this.ngModel);
                });
            }
        };
        if (this._ranges) {
            config.plugins = ['ranges'];
            config.ranges.customRanges = this._ranges;
        }
        if (!this.datePickerInput) {
            this.datePickerInput = new Litepicker(config);
            this.datePickerInput.setOptions(this.options);
            if (this._inputValue) {
                if (this.options.singleMode && this._inputValue.startDate) {
                    console.log("Single Mode");
                    this.datePickerInput.setDate(this._inputValue.startDate);
                }
                else if (!this.options.singleMode && this._inputValue.startDate && this._inputValue.endDate) {
                    console.log("Not Single Mode");
                    this.datePickerInput.setDateRange(this._inputValue.startDate, this._inputValue.endDate);
                }
            }
        }
    }
    updateValue(value) {
        this.ngModel = value;
        this.ngModelChange.emit(this.ngModel);
        this.dateRangeChangeCallBack.emit();
        this.onChange(this.ngModel);
        this.onTouched();
    }
    updatePicker() {
        if (this.ngModel === null) {
            this.datePickerInput?.clearSelection();
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
    }
    writeValue(obj) {
        this.ngModel = obj;
        this.updatePicker();
    }
    removeInput() {
        this.ngModel = null;
        this.updatePicker();
    }
}
DateRangeComponent.ɵfac = function DateRangeComponent_Factory(t) { return new (t || DateRangeComponent)(); };
DateRangeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DateRangeComponent, selectors: [["date-range"]], viewQuery: function DateRangeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$d, 5);
        i0.ɵɵviewQuery(_c1$7, 5);
        i0.ɵɵviewQuery(_c2$4, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dateRangeEl = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePickerEl = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.parentDiv = _t.first);
    } }, inputs: { ngModel: "ngModel", id: "id", label: "label", placeholder: "placeholder", options: "options", dayjs: "dayjs", removeBtn: "removeBtn", lang: "lang", ranges: "ranges", disabled: "disabled" }, outputs: { ngModelChange: "ngModelChange", dateRangeChangeCallBack: "dateRangeChangeCallBack" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DateRangeComponent),
                multi: true
            }
        ]), i0.ɵɵNgOnChangesFeature], decls: 10, vars: 8, consts: [["id", "date-range", 1, "form-field"], ["dateRange", ""], [1, "form-field-control"], [1, "form-field-label", 3, "for"], ["readonly", "readonly", "name", "datePicker", "type", "text", 1, "form-field-input", 3, "id", "disabled", "placeholder"], ["plannedDate", ""], ["id", "parentDiv"], ["parentDiv", ""], ["class", "icon icon-times removeBtn", 3, "click", 4, "ngIf"], [1, "icon", "icon-times", "removeBtn", 3, "click"]], template: function DateRangeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2)(3, "label", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "input", 4, 5)(7, "div", 6, 7);
        i0.ɵɵtemplate(9, DateRangeComponent_i_9_Template, 1, 0, "i", 8);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵclassProp("form-field-is-filled", ctx.ngModel !== null);
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("for", ctx.id);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.label);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("id", ctx.id);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        i0.ɵɵproperty("disabled", ctx._disabled);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.removeBtn && ctx.ngModel);
    } }, dependencies: [i1.NgIf], styles: ["#date-range{overflow:visible!important}#date-range #parentDiv{position:relative}#date-range #parentDiv .litepicker{position:absolute;top:0!important;left:0!important}#date-range #parentDiv button{text-transform:capitalize!important}.removeBtn{position:absolute;cursor:pointer;top:10px;right:0;padding:0 2px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangeComponent, [{
        type: Component,
        args: [{ selector: 'date-range', encapsulation: ViewEncapsulation.None, providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DateRangeComponent),
                        multi: true
                    }
                ], template: "<div #dateRange\n\t id=\"date-range\" class=\"form-field\"\n\t [class.form-field-is-filled]=\"ngModel !== null\">\n    <div class=\"form-field-control\">\n        <label for=\"{{id}}\" class=\"form-field-label\">{{label}}</label>\n        <input #plannedDate\n               id=\"{{id}}\"\n\t\t\t   [disabled]=\"_disabled\"\n               readonly=\"readonly\"\n               name=\"datePicker\"\n               class=\"form-field-input\"\n\t\t\t   placeholder=\"{{ placeholder }}\"\n               type=\"text\">\n        <div #parentDiv id=\"parentDiv\"></div>\n\n\t\t<i *ngIf=\"removeBtn && ngModel\" class=\"icon icon-times removeBtn\" (click)=\"removeInput()\"></i>\n\t</div>\n</div>\n", styles: ["#date-range{overflow:visible!important}#date-range #parentDiv{position:relative}#date-range #parentDiv .litepicker{position:absolute;top:0!important;left:0!important}#date-range #parentDiv button{text-transform:capitalize!important}.removeBtn{position:absolute;cursor:pointer;top:10px;right:0;padding:0 2px}\n"] }]
    }], function () { return []; }, { ngModel: [{
            type: Input
        }], id: [{
            type: Input
        }], label: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], options: [{
            type: Input
        }], dayjs: [{
            type: Input
        }], removeBtn: [{
            type: Input
        }], lang: [{
            type: Input
        }], ranges: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], dateRangeChangeCallBack: [{
            type: Output
        }], dateRangeEl: [{
            type: ViewChild,
            args: ['dateRange']
        }], datePickerEl: [{
            type: ViewChild,
            args: ['plannedDate']
        }], parentDiv: [{
            type: ViewChild,
            args: ['parentDiv']
        }], disabled: [{
            type: Input
        }] }); })();

class DateRangeModule {
}
DateRangeModule.ɵfac = function DateRangeModule_Factory(t) { return new (t || DateRangeModule)(); };
DateRangeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DateRangeModule });
DateRangeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ReactiveFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DateRangeComponent,
                ],
                exports: [
                    DateRangeComponent,
                ],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DateRangeModule, { declarations: [DateRangeComponent], imports: [CommonModule,
        ReactiveFormsModule], exports: [DateRangeComponent] }); })();

class FormFieldInputDirective {
    constructor(element, ngControl) {
        this.element = element;
        this.ngControl = ngControl;
        this.focus = false;
        //adding class if input is filled or focused
        const isFormFieldTextarea = element.nativeElement.closest('.form-field-text-area');
        if (this.ctrl && (!this.ctrl.value || this.ctrl.value.length == 0)) {
            element.nativeElement.closest('.form-field').classList.remove('form-field-is-filled');
            // If it is a formFieldTextArea, keep the form-is-filled class
            isFormFieldTextarea === undefined ? element.nativeElement.closest('.form-field').classList.remove('form-field-is-filled') : undefined;
        }
        else {
            element.nativeElement.closest('.form-field').classList.add('form-field-is-filled');
        }
        element.nativeElement.addEventListener('animationstart', this.onAnimationStart, false);
    }
    set ngModel(value) {
        if (value) {
            if (value)
                this.setFilled(this.element, true);
            return;
        }
    }
    ;
    get ctrl() {
        return this.ngControl.control;
    }
    ngAfterViewInit() {
        if (this.focus) {
            this.element.nativeElement.focus();
        }
    }
    ngOnInit() {
    }
    // Host Listeners
    onFocus() {
        this.setActive(this.element, true);
    }
    onBlur() {
        this.setActive(this.element, false);
        if (this.element.nativeElement.required) {
            this.setErrorClassToParent(this.element, this.element.nativeElement.value === '');
        }
    }
    onAnimationStart(target, animationName) {
        switch (animationName) {
            case 'onAutoFillStart':
            // $(target).parents('.form-field').addClass('form-field-is-autofilled');
            // return this.onAutoFillStart(target);
            case 'onAutoFillCancel':
            // $(target).parents('.form-field').removeClass('form-field-is-autofilled');
            // return this.onAutoFillCancel(target);
        }
    }
    // sets the active class of an formFieldInput
    setActive(element, active) {
        const formField = element.nativeElement.closest('.form-field');
        if (active) {
            formField.classList.add('form-field-is-active');
        }
        else {
            formField.classList.remove('form-field-is-active');
            if (this.ctrl) {
                (this.ctrl.value === '' && element.nativeElement.placeholder === '') || this.ctrl.value == null ?
                    formField.classList.remove('form-field-is-filled') :
                    formField.classList.add('form-field-is-filled');
            }
        }
    }
    // sets the filled class of an formFieldInput
    setFilled(element, filled) {
        const formField = element.nativeElement.closest('.form-field');
        if (filled) {
            formField.classList.add('form-field-is-filled');
        }
        else {
            formField.classList.remove('form-field-is-filled');
            if (this.ctrl) {
                this.ctrl.value === '' && element.nativeElement.placeholder === '' ?
                    formField.classList.remove('form-field-is-filled') :
                    formField.classList.add('form-field-is-filled');
            }
        }
    }
    setErrorClassToParent(element, hasError) {
        const formField = element.nativeElement.closest('.form-field');
        if (hasError) {
            formField.classList.add('form-field-has-error');
        }
        else {
            formField.classList.remove('form-field-has-error');
        }
    }
}
FormFieldInputDirective.ɵfac = function FormFieldInputDirective_Factory(t) { return new (t || FormFieldInputDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.NgControl)); };
FormFieldInputDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FormFieldInputDirective, selectors: [["", "form-field-input", ""]], hostBindings: function FormFieldInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("focus", function FormFieldInputDirective_focus_HostBindingHandler() { return ctx.onFocus(); })("blur", function FormFieldInputDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { ngModel: "ngModel", focus: "focus" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldInputDirective, [{
        type: Directive,
        args: [{
                // selector: '.form-field-input'
                selector: '[form-field-input]'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i3.NgControl }]; }, { ngModel: [{
            type: Input
        }], focus: [{
            type: Input
        }], onFocus: [{
            type: HostListener,
            args: ["focus"]
        }], onBlur: [{
            type: HostListener,
            args: ["blur"]
        }] }); })();

function DateTimeComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 5);
    i0.ɵɵlistener("click", function DateTimeComponent_i_5_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeInput()); });
    i0.ɵɵelementEnd();
} }
const _c0$c = function (a0) { return { "form-field-is-disabled": a0 }; };
const _c1$6 = function () { return { standalone: true }; };
class DateTimeComponent {
    constructor(control) {
        this.control = control;
        this.ngModelChange = new EventEmitter();
        this.inputDatetimeFormat = "F j, Y, H:i";
        this.hourStep = 1;
        this.minuteStep = 15;
        this.secondStep = 30;
        this.seconds = true;
        this.locale = "";
        this.placeholder = "Select date...";
        this.isDisabled = false;
        this.removeBtn = false;
        this.minDate = "";
        this.minTime = "";
        this.meridian = false;
        this.mode = "single"; //"single", "multiple", "range", or "date"
        this.elementId = "";
        this.label = "";
        this.config = {};
        this.initialValue = new Date();
        this.required = false;
        this.flatpickr = null;
        this.onChangeFn = (_) => {
        };
        this.onTouchedFn = () => {
        };
        this.control && (this.control.valueAccessor = this);
    }
    ngOnInit() {
        if (!this.elementId) {
            this.elementId = v4();
        }
    }
    ngAfterViewInit() {
        this.config.enableTime = true;
        this.config.enableSeconds = this.seconds;
        if (this.notBeforeNow) {
            this.config.minDate = "today";
            this.initialValue = this.getNextAvailableIntervalTimestamp();
            this.minTime = this.formatTimestamp(this.initialValue);
            this.config.minTime = this.formatTimestamp(this.initialValue);
        }
        else {
            if (this.minDate)
                this.config.minDate = this.minDate;
            if (this.minTime)
                this.config.minTime = this.minTime;
        }
        this.config.mode = this.mode;
        this.config.hourIncrement = this.hourStep;
        this.config.minuteIncrement = this.minuteStep;
        this.config.time_24hr = this.meridian;
        this.config.altInput = true;
        this.config.altFormat = this.inputDatetimeFormat;
        this.config.dateFormat = "Z";
        this.config.onChange = (selectedDates) => {
            if (selectedDates && selectedDates.length > 0) {
                const dateToday = new Date().getDate();
                const selectedDate = selectedDates[0].getDate();
                if (selectedDate === dateToday) {
                    this.flatpickr.config.minTime = this.minTime;
                    // If current selected time before minTime, set the time to minTime
                    const selectedTime = selectedDates[0].getHours() + ":" + selectedDates[0].getMinutes();
                    if (selectedTime < this.minTime) {
                        this.minTime = this.formatTimestamp(this.initialValue);
                        let minDate = new Date();
                        let timeParts = this.minTime.split(":");
                        minDate.setHours(Number(timeParts[0]));
                        minDate.setMinutes(Number(timeParts[1]));
                        this.flatpickr.setDate(minDate);
                    }
                }
                else if (selectedDate > dateToday) {
                    this.flatpickr.config.minTime = null;
                }
            }
        };
        this.flatpickr = flatpickr("#" + this.elementId, this.config);
        this.flatpickr.setDate(this.initialValue, true, this.inputDatetimeFormat);
        window.setTimeout(() => {
            this.ngModelChange.emit(this.initialValue);
        }, 300);
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    writeValue(obj) {
        this.ngModel = obj;
    }
    onChange() {
        this.onChangeFn(this.ngModel);
        this.ngModelChange.emit(this.ngModel);
    }
    getNextAvailableIntervalTimestamp() {
        const currentTime = new Date();
        // Calculate the minutes remaining until the next interval
        const remainingMinutes = this.minuteStep - (currentTime.getMinutes() % this.minuteStep);
        // Calculate the timestamp of the next interval
        return new Date(currentTime.getTime() + remainingMinutes * 60000);
    }
    formatTimestamp(datetime) {
        // Format the next interval as a time string (HH:MM)
        return datetime.getHours().toString().padStart(2, '0') + ':' +
            datetime.getMinutes().toString().padStart(2, '0');
    }
    removeInput() {
        this.flatpickr.clear();
        this.ngModel = "";
    }
}
DateTimeComponent.ɵfac = function DateTimeComponent_Factory(t) { return new (t || DateTimeComponent)(i0.ɵɵdirectiveInject(NgControl, 10)); };
DateTimeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DateTimeComponent, selectors: [["date-time"]], inputs: { ngModel: "ngModel", inputDatetimeFormat: "inputDatetimeFormat", hourStep: "hourStep", minuteStep: "minuteStep", secondStep: "secondStep", seconds: "seconds", locale: "locale", placeholder: "placeholder", isDisabled: "isDisabled", removeBtn: "removeBtn", minDate: "minDate", minTime: "minTime", notBeforeNow: "notBeforeNow", meridian: "meridian", mode: "mode", elementId: "elementId", label: "label", config: "config", initialValue: "initialValue", required: "required" }, outputs: { ngModelChange: "ngModelChange" }, decls: 6, vars: 13, consts: [[1, "form-field", 3, "ngClass"], [1, "form-field-control"], [1, "form-field-label", 3, "for"], ["form-field-input", "", 1, "form-field-input", 3, "placeholder", "id", "required", "disabled", "ngModel", "ngModelOptions", "ngModelChange", "input", "change", "blur"], ["class", "icon icon-times removeBtn", 3, "click", 4, "ngIf"], [1, "icon", "icon-times", "removeBtn", 3, "click"]], template: function DateTimeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 3);
        i0.ɵɵlistener("ngModelChange", function DateTimeComponent_Template_input_ngModelChange_4_listener($event) { return ctx.ngModel = $event; })("input", function DateTimeComponent_Template_input_input_4_listener() { return ctx.onChange(); })("change", function DateTimeComponent_Template_input_change_4_listener() { return ctx.onChange(); })("blur", function DateTimeComponent_Template_input_blur_4_listener() { return ctx.onTouchedFn(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, DateTimeComponent_i_5_Template, 1, 0, "i", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0$c, ctx.isDisabled));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", ctx.elementId);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("placeholder", ctx.placeholder)("id", ctx.elementId)("required", ctx.required)("disabled", ctx.isDisabled)("ngModel", ctx.ngModel)("ngModelOptions", i0.ɵɵpureFunction0(12, _c1$6));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.removeBtn && ctx.ngModel);
    } }, dependencies: [i1.NgClass, i1.NgIf, i3.DefaultValueAccessor, i3.NgControlStatus, i3.RequiredValidator, i3.NgModel, FormFieldInputDirective], styles: [".flatpickr-current-month .numInputWrapper{position:absolute;top:22.5%;right:25%;width:25%}.removeBtn{position:absolute;cursor:pointer;top:10px;right:0;padding:0 2px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateTimeComponent, [{
        type: Component,
        args: [{ selector: "date-time", encapsulation: ViewEncapsulation.None, template: "<div class=\"form-field\" [ngClass]=\"{ 'form-field-is-disabled': isDisabled }\">\n    <div class=\"form-field-control\">\n        <label [for]=\"elementId\" class=\"form-field-label\">\n            {{label}}\n        </label>\n        <input\n\t\t\t[placeholder]=\"placeholder\"\n            form-field-input\n            class=\"form-field-input\"\n            [id]=\"elementId\"\n            [required]=\"required\"\n            [disabled]=\"isDisabled\"\n            [(ngModel)]=\"ngModel\"\n            [ngModelOptions]=\"{standalone: true}\"\n            (input)=\"onChange()\"\n            (change)=\"onChange()\"\n            (blur)=\"onTouchedFn()\"\n        />\n\n\t\t<i *ngIf=\"removeBtn && ngModel\" class=\"icon icon-times removeBtn\" (click)=\"removeInput()\"></i>\n    </div>\n</div>\n", styles: [".flatpickr-current-month .numInputWrapper{position:absolute;top:22.5%;right:25%;width:25%}.removeBtn{position:absolute;cursor:pointer;top:10px;right:0;padding:0 2px}\n"] }]
    }], function () { return [{ type: i3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }, {
                type: Inject,
                args: [NgControl]
            }] }]; }, { ngModel: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], inputDatetimeFormat: [{
            type: Input
        }], hourStep: [{
            type: Input
        }], minuteStep: [{
            type: Input
        }], secondStep: [{
            type: Input
        }], seconds: [{
            type: Input
        }], locale: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], removeBtn: [{
            type: Input
        }], minDate: [{
            type: Input
        }], minTime: [{
            type: Input
        }], notBeforeNow: [{
            type: Input
        }], meridian: [{
            type: Input
        }], mode: [{
            type: Input
        }], elementId: [{
            type: Input
        }], label: [{
            type: Input
        }], config: [{
            type: Input
        }], initialValue: [{
            type: Input
        }], required: [{
            type: Input
        }] }); })();

class FormFieldInputModule {
}
FormFieldInputModule.ɵfac = function FormFieldInputModule_Factory(t) { return new (t || FormFieldInputModule)(); };
FormFieldInputModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormFieldInputModule });
FormFieldInputModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        OverlayModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldInputModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormFieldInputDirective,
                ],
                exports: [
                    FormFieldInputDirective,
                ],
                imports: [
                    CommonModule,
                    OverlayModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormFieldInputModule, { declarations: [FormFieldInputDirective], imports: [CommonModule,
        OverlayModule], exports: [FormFieldInputDirective] }); })();

class DateTimeModule {
}
DateTimeModule.ɵfac = function DateTimeModule_Factory(t) { return new (t || DateTimeModule)(); };
DateTimeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DateTimeModule });
DateTimeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormFieldInputModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateTimeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DateTimeComponent,
                ],
                exports: [
                    DateTimeComponent,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    FormFieldInputModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DateTimeModule, { declarations: [DateTimeComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormFieldInputModule], exports: [DateTimeComponent] }); })();

function LightboxComponent_img_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.imgSrc, i0.ɵɵsanitizeUrl);
} }
class LightboxDirective {
    constructor(el, overlay) {
        this.el = el;
        this.overlay = overlay;
        this.singleClick = false;
    }
    buildLightboxOverlay(imgSrc) {
        let config = new OverlayConfig();
        config.positionStrategy = this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically();
        config.hasBackdrop = true;
        config.backdropClass = 'lightbox-backdrop';
        let overlayRef = this.overlay.create(config);
        overlayRef.backdropClick().subscribe(() => {
            overlayRef.dispose();
        });
        const overlayContainer = overlayRef.overlayElement.closest(".cdk-overlay-container");
        if (overlayContainer) {
            overlayContainer.style.backgroundColor = "rgba(0, 0, 0, .8)";
        }
        else {
            console.error("Cannot find overlay container, lightbox background color will not appear.");
        }
        let ref = overlayRef.attach(new ComponentPortal(LightboxComponent));
        ref.instance.imgSrc = imgSrc;
    }
    onLightboxClick(event, imgSrc) {
        if (imgSrc) {
            if (event.ctrlKey) {
                // needed if image is base64
                let w = window.open('about:blank');
                let image = new Image();
                image.src = imgSrc;
                w?.document.write(image.outerHTML);
            }
            else {
                this.buildLightboxOverlay(imgSrc);
            }
        }
        else {
            console.error("Cannot build lightbox overlay, image src is null.");
        }
    }
    onDblClick(event) {
        if (!this.singleClick) {
            this.onLightboxClick(event, this.el.nativeElement.src);
        }
    }
    onClick(event) {
        if (this.singleClick) {
            this.onLightboxClick(event, this.el.nativeElement.src);
        }
    }
}
LightboxDirective.ɵfac = function LightboxDirective_Factory(t) { return new (t || LightboxDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.Overlay)); };
LightboxDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: LightboxDirective, selectors: [["", "lightbox", ""]], hostBindings: function LightboxDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("dblclick", function LightboxDirective_dblclick_HostBindingHandler($event) { return ctx.onDblClick($event); })("click", function LightboxDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { singleClick: "singleClick" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LightboxDirective, [{
        type: Directive,
        args: [{
                selector: '[lightbox]',
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1$1.Overlay }]; }, { singleClick: [{
            type: Input
        }], onDblClick: [{
            type: HostListener,
            args: ['dblclick', ['$event']]
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
class LightboxComponent {
    constructor() {
        this.imgSrc = '';
    }
}
LightboxComponent.ɵfac = function LightboxComponent_Factory(t) { return new (t || LightboxComponent)(); };
LightboxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LightboxComponent, selectors: [["ng-component"]], inputs: { imgSrc: "imgSrc" }, decls: 1, vars: 1, consts: [["class", "lightbox-image", "alt", "lightbox-img", 3, "src", 4, "ngIf"], ["alt", "lightbox-img", 1, "lightbox-image", 3, "src"]], template: function LightboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LightboxComponent_img_0_Template, 1, 1, "img", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.imgSrc);
    } }, dependencies: [i1.NgIf], styles: [".lightbox-image[_ngcontent-%COMP%]{max-width:90vw}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LightboxComponent, [{
        type: Component,
        args: [{ template: `<img *ngIf="imgSrc" class="lightbox-image" [src]="imgSrc" alt="lightbox-img">`, styles: [".lightbox-image{max-width:90vw}\n"] }]
    }], null, { imgSrc: [{
            type: Input
        }] }); })();

class LightboxModule {
}
LightboxModule.ɵfac = function LightboxModule_Factory(t) { return new (t || LightboxModule)(); };
LightboxModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LightboxModule });
LightboxModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LightboxModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LightboxDirective,
                    LightboxComponent,
                ],
                exports: [
                    LightboxDirective,
                    LightboxComponent,
                ],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    FormsModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LightboxModule, { declarations: [LightboxDirective,
        LightboxComponent], imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule], exports: [LightboxDirective,
        LightboxComponent] }); })();

class TableScrollDirective {
    constructor(elRef) {
        this.elRef = elRef;
        this.elementCache = new Map();
        console.log("TableScroll:init");
    }
    scrollingAction(event) {
        const el = event.target;
        if (el.scrollTop > 70) {
            this.apply({
                selector: '.page-header',
                callback: el => el.classList.add('sticky-sub-menu')
            });
        }
        else if (el.scrollTop < 70) {
            this.apply({
                selector: '.page-header',
                callback: el => el.classList.remove('sticky-sub-menu')
            });
        }
        if (el.scrollTop > 125) {
            this.apply({
                selector: '.ag-header',
                callback: el => el.classList.add('fixed-table-header')
            });
        }
        else if (el.scrollTop < 125) {
            this.apply({
                selector: '.ag-header',
                callback: el => el.classList.remove('fixed-table-header')
            });
        }
    }
    apply(options) {
        if (this.elRef) {
            const target = this.queryElement(options.selector);
            if (target) {
                options.callback(target);
            }
        }
    }
    queryElement(selector) {
        if (this.elementCache.has(selector)) {
            return this.elementCache.get(selector);
        }
        const element = this.elRef.nativeElement.querySelector(selector);
        if (element) {
            this.elementCache.set(selector, element);
        }
        return element;
    }
}
TableScrollDirective.ɵfac = function TableScrollDirective_Factory(t) { return new (t || TableScrollDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
TableScrollDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TableScrollDirective, selectors: [["", "tableScroll", ""]], hostBindings: function TableScrollDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function TableScrollDirective_scroll_HostBindingHandler($event) { return ctx.scrollingAction($event); });
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableScrollDirective, [{
        type: Directive,
        args: [{
                selector: '[tableScroll]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { scrollingAction: [{
            type: HostListener,
            args: ['scroll', ['$event']]
        }] }); })();

class TablescrollModule {
}
TablescrollModule.ɵfac = function TablescrollModule_Factory(t) { return new (t || TablescrollModule)(); };
TablescrollModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TablescrollModule });
TablescrollModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TablescrollModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TableScrollDirective,
                ],
                exports: [
                    TableScrollDirective,
                ],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TablescrollModule, { declarations: [TableScrollDirective], imports: [CommonModule], exports: [TableScrollDirective] }); })();

class UploadDirective {
    constructor() {
        this.onFileDropped = new EventEmitter();
        this.background = '#fff';
        this.opacity = '1';
    }
    //Dragover listener, when something is dragged over our host element
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#9ecbec';
        this.opacity = '0.8';
    }
    ;
    //Dragleave listener, when something is dragged away from our host element
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#fff';
        this.opacity = '1';
    }
    ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#f5fcff';
        this.opacity = '1';
        let files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.onFileDropped.emit(files);
        }
    }
}
UploadDirective.ɵfac = function UploadDirective_Factory(t) { return new (t || UploadDirective)(); };
UploadDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: UploadDirective, selectors: [["", "appUpload", ""]], hostVars: 4, hostBindings: function UploadDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("dragover", function UploadDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function UploadDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); })("drop", function UploadDirective_drop_HostBindingHandler($event) { return ctx.ondrop($event); });
    } if (rf & 2) {
        i0.ɵɵstyleProp("background-color", ctx.background)("opacity", ctx.opacity);
    } }, outputs: { onFileDropped: "onFileDropped" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadDirective, [{
        type: Directive,
        args: [{
                selector: '[appUpload]'
            }]
    }], function () { return []; }, { onFileDropped: [{
            type: Output
        }], background: [{
            type: HostBinding,
            args: ['style.background-color']
        }], opacity: [{
            type: HostBinding,
            args: ['style.opacity']
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], ondrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();

class UploadModule {
}
UploadModule.ɵfac = function UploadModule_Factory(t) { return new (t || UploadModule)(); };
UploadModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UploadModule });
UploadModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UploadDirective,
                ],
                exports: [
                    UploadDirective,
                ],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UploadModule, { declarations: [UploadDirective], imports: [CommonModule], exports: [UploadDirective] }); })();

class DirectivesModule {
}
DirectivesModule.ɵfac = function DirectivesModule_Factory(t) { return new (t || DirectivesModule)(); };
DirectivesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DirectivesModule });
DirectivesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormFieldInputModule,
        LightboxModule,
        TablescrollModule,
        UploadModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DirectivesModule, [{
        type: NgModule,
        args: [{
                exports: [
                    FormFieldInputModule,
                    LightboxModule,
                    TablescrollModule,
                    UploadModule,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DirectivesModule, { exports: [FormFieldInputModule,
        LightboxModule,
        TablescrollModule,
        UploadModule] }); })();

function ImageTileComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 8);
    i0.ɵɵlistener("click", function ImageTileComponent_i_1_Template_i_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.deleteImage($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.removeIconClass);
} }
const _c0$b = function (a0) { return { "aspect-ratio": a0 }; };
function ImageTileComponent_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("singleClick", ctx_r1.lightboxSingleClick)("src", ctx_r1.imageSrc, i0.ɵɵsanitizeUrl)("ngStyle", i0.ɵɵpureFunction1(3, _c0$b, ctx_r1.aspectRatioWidth / ctx_r1.aspectRatioHeight));
} }
function ImageTileComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 10);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r2.imageSrc, i0.ɵɵsanitizeUrl)("ngStyle", i0.ɵɵpureFunction1(2, _c0$b, ctx_r2.aspectRatioWidth / ctx_r2.aspectRatioHeight));
} }
class ImageTileComponent {
    constructor() {
        this.imageSrc = "";
        this.emitData = "";
        this.title = "title";
        this.desc = "desc";
        this.lightboxEnabled = false;
        this.lightboxSingleClick = false;
        this.aspectRatioWidth = 4;
        this.aspectRatioHeight = 3;
        this.removeIconClass = 'icon icon-times';
        this.deleteImageEmitter = new EventEmitter();
        this.clickImageEmitter = new EventEmitter();
        this.mouseHover = false;
    }
    ngOnInit() {
    }
    clickImage() {
        this.clickImageEmitter.emit(this.emitData);
    }
    deleteImage(e) {
        e.stopPropagation();
        this.deleteImageEmitter.emit(this.emitData);
    }
}
ImageTileComponent.ɵfac = function ImageTileComponent_Factory(t) { return new (t || ImageTileComponent)(); };
ImageTileComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageTileComponent, selectors: [["image-tile"]], inputs: { imageSrc: "imageSrc", emitData: "emitData", title: "title", desc: "desc", lightboxEnabled: "lightboxEnabled", lightboxSingleClick: "lightboxSingleClick", aspectRatioWidth: "aspectRatioWidth", aspectRatioHeight: "aspectRatioHeight", removeIconClass: "removeIconClass" }, outputs: { deleteImageEmitter: "deleteImageEmitter", clickImageEmitter: "clickImageEmitter" }, decls: 11, vars: 5, consts: [[1, "image-tile", 3, "mouseenter", "mouseleave", "click"], ["class", "remove-icon", 3, "ngClass", "click", 4, "ngIf"], ["class", "image lightbox-trigger", "alt", "", "lightbox", "", 3, "singleClick", "src", "ngStyle", 4, "ngIf"], ["class", "image", "alt", "", 3, "src", "ngStyle", 4, "ngIf"], [1, "image-info"], [1, "title"], [1, "text-wrapper"], [1, "desc"], [1, "remove-icon", 3, "ngClass", "click"], ["alt", "", "lightbox", "", 1, "image", "lightbox-trigger", 3, "singleClick", "src", "ngStyle"], ["alt", "", 1, "image", 3, "src", "ngStyle"]], template: function ImageTileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("mouseenter", function ImageTileComponent_Template_div_mouseenter_0_listener() { return ctx.mouseHover = true; })("mouseleave", function ImageTileComponent_Template_div_mouseleave_0_listener() { return ctx.mouseHover = false; })("click", function ImageTileComponent_Template_div_click_0_listener() { return ctx.clickImage(); });
        i0.ɵɵtemplate(1, ImageTileComponent_i_1_Template, 1, 1, "i", 1);
        i0.ɵɵtemplate(2, ImageTileComponent_img_2_Template, 1, 5, "img", 2);
        i0.ɵɵtemplate(3, ImageTileComponent_img_3_Template, 1, 4, "img", 3);
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "div", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 7)(9, "div", 6);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.mouseHover);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.lightboxEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.lightboxEnabled);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.desc, " ");
    } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgStyle, LightboxDirective], styles: [".image-tile[_ngcontent-%COMP%]{position:relative;background:white;box-shadow:#00000014 2px 0 2px;display:flex;flex-direction:column}.image-tile[_ngcontent-%COMP%]   .remove-icon[_ngcontent-%COMP%]{position:absolute;right:10px;top:10px;color:#fff;font-size:20px;cursor:pointer}.image-tile[_ngcontent-%COMP%]   .image[_ngcontent-%COMP%]{object-fit:cover;cursor:pointer}.image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]{cursor:default;padding:5px 10px}.image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:14px}.theme-default[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--default-primary)}.theme-x-pick[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--xpick-primary)}.theme-ai-studio[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--aistudio-primary)}.theme-frontline-creator[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--creator-primary)}.theme-x-make[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--xmake-primary)}.theme-spatial[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--spatial-primary)}.theme-admin[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--admin-secondary)}.theme-x-assist[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--xassist-secondary)}.theme-x-inspect[_ngcontent-%COMP%]   .image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--xinspect-primary)}.image-tile[_ngcontent-%COMP%]   .image-info[_ngcontent-%COMP%]   .desc[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:10px}.image-tile[_ngcontent-%COMP%]   .text-wrapper[_ngcontent-%COMP%]{display:inline-block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageTileComponent, [{
        type: Component,
        args: [{ selector: 'image-tile', template: "<div class=\"image-tile\" (mouseenter)=\"mouseHover = true;\" (mouseleave)=\"mouseHover = false;\"\n\t (click)=\"clickImage()\">\n\t<i *ngIf=\"mouseHover\" class=\"remove-icon\" [ngClass]=\"removeIconClass\" (click)=\"deleteImage($event)\"></i>\n\n\t<img *ngIf=\"lightboxEnabled\" [singleClick]=\"lightboxSingleClick\" class=\"image lightbox-trigger\"\n\t\t [src]=\"imageSrc\" alt=\"\" lightbox\n\t\t [ngStyle]=\"{'aspect-ratio': aspectRatioWidth/aspectRatioHeight}\">\n\t<img *ngIf=\"!lightboxEnabled\" class=\"image\" [src]=\"imageSrc\" alt=\"\"\n\t\t [ngStyle]=\"{'aspect-ratio': aspectRatioWidth/aspectRatioHeight}\">\n\n\t<div class=\"image-info\">\n\t\t<div class=\"title\">\n\t\t\t<div class=\"text-wrapper\">\n\t\t\t\t{{ title }}\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"desc\">\n\t\t\t<div class=\"text-wrapper\">\n\t\t\t\t{{ desc }}\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n", styles: [".image-tile{position:relative;background:white;box-shadow:#00000014 2px 0 2px;display:flex;flex-direction:column}.image-tile .remove-icon{position:absolute;right:10px;top:10px;color:#fff;font-size:20px;cursor:pointer}.image-tile .image{object-fit:cover;cursor:pointer}.image-tile .image-info{cursor:default;padding:5px 10px}.image-tile .image-info .title{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:14px}.theme-default .image-tile .image-info .title{color:var(--default-primary)}.theme-x-pick .image-tile .image-info .title{color:var(--xpick-primary)}.theme-ai-studio .image-tile .image-info .title{color:var(--aistudio-primary)}.theme-frontline-creator .image-tile .image-info .title{color:var(--creator-primary)}.theme-x-make .image-tile .image-info .title{color:var(--xmake-primary)}.theme-spatial .image-tile .image-info .title{color:var(--spatial-primary)}.theme-admin .image-tile .image-info .title{color:var(--admin-secondary)}.theme-x-assist .image-tile .image-info .title{color:var(--xassist-secondary)}.theme-x-inspect .image-tile .image-info .title{color:var(--xinspect-primary)}.image-tile .image-info .desc{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:10px}.image-tile .text-wrapper{display:inline-block}\n"] }]
    }], function () { return []; }, { imageSrc: [{
            type: Input
        }], emitData: [{
            type: Input
        }], title: [{
            type: Input
        }], desc: [{
            type: Input
        }], lightboxEnabled: [{
            type: Input
        }], lightboxSingleClick: [{
            type: Input
        }], aspectRatioWidth: [{
            type: Input
        }], aspectRatioHeight: [{
            type: Input
        }], removeIconClass: [{
            type: Input
        }], deleteImageEmitter: [{
            type: Output
        }], clickImageEmitter: [{
            type: Output
        }] }); })();

class ImageTileModule {
}
ImageTileModule.ɵfac = function ImageTileModule_Factory(t) { return new (t || ImageTileModule)(); };
ImageTileModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ImageTileModule });
ImageTileModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        LightboxModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageTileModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ImageTileComponent
                ],
                exports: [
                    ImageTileComponent
                ],
                imports: [
                    CommonModule,
                    LightboxModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ImageTileModule, { declarations: [ImageTileComponent], imports: [CommonModule,
        LightboxModule], exports: [ImageTileComponent] }); })();

function MenuItemComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "icon-" + ctx_r0.icon);
} }
function MenuItemComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
} }
function MenuItemComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r2.heading);
} }
const _c0$a = function (a0, a1) { return { "active": a0, "action": a1 }; };
class MenuItemComponent {
    constructor() {
        this.heading = "";
        this.isActive = false;
        this.icon = "";
        this.tooltipText = "";
        this.toolTipPlacement = "top";
        this.isDisabled = false;
        this.isServiceRunning = false;
        this.onClickEmitter = new EventEmitter();
    }
    buttonClicked() {
        this.onClickEmitter.next();
    }
    ngOnChanges(changes) {
        if (changes.isDisabled) {
            this.isDisabled = changes.isDisabled.currentValue;
        }
        if (changes.isActive) {
            this.isActive = changes.isActive.currentValue;
        }
    }
}
MenuItemComponent.ɵfac = function MenuItemComponent_Factory(t) { return new (t || MenuItemComponent)(); };
MenuItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MenuItemComponent, selectors: [["menu-item"]], inputs: { heading: "heading", isActive: "isActive", icon: "icon", tooltipText: "tooltipText", toolTipPlacement: "toolTipPlacement", isDisabled: "isDisabled", onClick: "onClick", isServiceRunning: "isServiceRunning" }, outputs: { onClickEmitter: "onClickEmitter" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 10, consts: [[1, "menu-item", 3, "ngClass"], [3, "ngbTooltip", "placement", "disabled", "click"], ["class", "icon", 3, "ngClass", 4, "ngIf"], ["class", "active-circle", 4, "ngIf"], [3, "textContent", 4, "ngIf"], [1, "icon", 3, "ngClass"], [1, "active-circle"], [3, "textContent"]], template: function MenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function MenuItemComponent_Template_button_click_1_listener() { return ctx.buttonClicked(); });
        i0.ɵɵtemplate(2, MenuItemComponent_i_2_Template, 1, 1, "i", 2);
        i0.ɵɵtemplate(3, MenuItemComponent_span_3_Template, 1, 0, "span", 3);
        i0.ɵɵtemplate(4, MenuItemComponent_span_4_Template, 1, 1, "span", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$a, ctx.isActive, !ctx.heading));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngbTooltip", ctx.tooltipText)("placement", ctx.toolTipPlacement)("disabled", ctx.isDisabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.icon !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isServiceRunning);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.heading !== undefined);
    } }, dependencies: [i1.NgClass, i1.NgIf, i2$1.NgbTooltip] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemComponent, [{
        type: Component,
        args: [{ selector: 'menu-item', template: "<div class=\"menu-item\"\n     [ngClass]=\"{'active' : isActive, 'action' : !heading}\"\n>\n    <button (click)=\"buttonClicked()\"\n            [ngbTooltip]=\"tooltipText\"\n            [placement]=\"toolTipPlacement\"\n            [disabled]=\"isDisabled\"\n    >\n        <i class=\"icon\" *ngIf=\"icon !== undefined\" [ngClass]=\"'icon-' + icon\"></i>\n        <span *ngIf=\"isServiceRunning\" class=\"active-circle\"></span>\n        <span *ngIf=\"heading !== undefined\" [textContent]=\"heading\"></span>\n    </button>\n</div>\n" }]
    }], function () { return []; }, { heading: [{
            type: Input
        }], isActive: [{
            type: Input
        }], icon: [{
            type: Input
        }], tooltipText: [{
            type: Input
        }], toolTipPlacement: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], onClick: [{
            type: Input
        }], isServiceRunning: [{
            type: Input
        }], onClickEmitter: [{
            type: Output
        }] }); })();

class MenuItemModule {
}
MenuItemModule.ɵfac = function MenuItemModule_Factory(t) { return new (t || MenuItemModule)(); };
MenuItemModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MenuItemModule });
MenuItemModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        NgbTooltipModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MenuItemComponent,
                ],
                exports: [
                    MenuItemComponent,
                ],
                imports: [
                    CommonModule,
                    NgbTooltipModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MenuItemModule, { declarations: [MenuItemComponent], imports: [CommonModule,
        NgbTooltipModule], exports: [MenuItemComponent] }); })();

function MenuItemDropdownComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.defaultOption.title);
} }
const _c0$9 = function (a0) { return { "small": a0 }; };
const _c1$5 = function (a0) { return { "full-width": a0 }; };
const _c2$3 = ["*"];
class MenuItemDropdownComponent {
    constructor() {
        this.showContentInFullWidth = false;
        this.showContent = false;
        this.options = [];
        this.defaultOption = null;
        this.avoidOverridingDefaultOption = false;
        this.toolTipText = "";
        this.onlyShowIconOfDefaultOption = false;
    }
    ngOnInit() {
        this.showContent = false;
    }
    showContentOn() {
        this.showContent = true;
    }
    toggleShowContent() {
        if (this.showContent) {
            this.showContent = false;
        }
    }
    addOption(option) {
        if (this.options.length === 0) {
            this.setAsDefault({ option: option, isInitial: true });
        }
        this.options.push(option);
    }
    updateOptionDisabledStatus(obj) {
        this.options.find((o, i) => {
            if (o.title === obj.title) {
                this.options[i].ngDisabled = obj.ngDisabled;
                if (this.defaultOption?.title === obj.title) {
                    this.setAsDefault({ option: this.options[i], isInitial: false });
                }
                return true;
            }
            return false;
        });
    }
    //needed for updating default option's title, after translation is loaded.
    updateOptionTitle(obj) {
        this.options.find((o, i) => {
            if (o.title === obj.oldTitle) {
                this.options[i].title = obj.newTitle;
                return true;
            }
            return false;
        });
    }
    //needed for updating default option's title, after translation is loaded.
    updateOptionTooltipText(obj) {
        this.options.find((o, i) => {
            if (o.title === obj.title) {
                this.options[i].tooltipText = obj.toolTip;
                return true;
            }
            return false;
        });
    }
    setAsDefault(obj) {
        if (obj.isInitial || !this.avoidOverridingDefaultOption) {
            this.options.forEach(el => el.isDefault = false);
            obj.option.isDefault = true;
            this.defaultOption = obj.option;
        }
    }
    triggerDefaultOption() {
        this.defaultOption?.onClick();
        this.defaultOption?.onClickEmitter.next();
    }
    onButtonClick(option) {
        option.onClick();
        this.setAsDefault({ option: option, isInitial: false });
        option.onClickEmitter.next();
    }
}
MenuItemDropdownComponent.ɵfac = function MenuItemDropdownComponent_Factory(t) { return new (t || MenuItemDropdownComponent)(); };
MenuItemDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MenuItemDropdownComponent, selectors: [["menu-item-dropdown"]], inputs: { showContentInFullWidth: "showContentInFullWidth", showContent: "showContent", options: "options", defaultOption: "defaultOption", avoidOverridingDefaultOption: "avoidOverridingDefaultOption", toolTipText: "toolTipText", onlyShowIconOfDefaultOption: "onlyShowIconOfDefaultOption" }, ngContentSelectors: _c2$3, decls: 11, vars: 12, consts: [[1, "menu-item", "menu-item-dropdown", 3, "ngClass"], [1, "dropdown-button-wrapper", 3, "ngbTooltip", "placement"], [1, "selected-option", 3, "disabled", "click"], [1, "icon", 3, "ngClass"], [3, "textContent", 4, "ngIf"], [1, "expand-dropdown", 3, "clickOutside"], [3, "click"], [1, "caret-wrapper"], [1, "icon", "icon-caret-down"], [1, "dropdown-content-wrapper", 3, "ngClass", "hidden"], [3, "textContent"]], template: function MenuItemDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "button", 2);
        i0.ɵɵlistener("click", function MenuItemDropdownComponent_Template_button_click_2_listener() { return ctx.triggerDefaultOption(); });
        i0.ɵɵelement(3, "i", 3);
        i0.ɵɵtemplate(4, MenuItemDropdownComponent_span_4_Template, 1, 1, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵlistener("clickOutside", function MenuItemDropdownComponent_Template_div_clickOutside_5_listener() { return ctx.toggleShowContent(); });
        i0.ɵɵelementStart(6, "button", 6);
        i0.ɵɵlistener("click", function MenuItemDropdownComponent_Template_button_click_6_listener() { return ctx.showContentOn(); });
        i0.ɵɵelementStart(7, "span", 7);
        i0.ɵɵelement(8, "i", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵprojection(10);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$9, !ctx.showContentInFullWidth));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngbTooltip", ctx.toolTipText)("placement", "right");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.defaultOption == null ? null : ctx.defaultOption.ngDisabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", "icon-" + (ctx.defaultOption == null ? null : ctx.defaultOption.icon));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.defaultOption == null ? null : ctx.defaultOption.title) && !ctx.onlyShowIconOfDefaultOption);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1$5, ctx.showContentInFullWidth))("hidden", !ctx.showContent);
    } }, dependencies: [i1.NgClass, i1.NgIf, i2$1.NgbTooltip, i2.ClickOutsideDirective] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemDropdownComponent, [{
        type: Component,
        args: [{ selector: 'menu-item-dropdown', template: "<div class=\"menu-item menu-item-dropdown\" [ngClass]=\"{'small' : !showContentInFullWidth}\">\n    <div class=\"dropdown-button-wrapper\" [ngbTooltip]=\"toolTipText\" [placement]=\"'right'\">\n        <button\n            class=\"selected-option\"\n            (click)=\"triggerDefaultOption()\"\n            [disabled]=\"defaultOption?.ngDisabled\">\n            <i class=\"icon\" [ngClass]=\"'icon-' + defaultOption?.icon\"></i>\n            <span *ngIf=\"defaultOption?.title && !onlyShowIconOfDefaultOption\" [textContent]=\"defaultOption.title\"> </span>\n        </button>\n        <div class=\"expand-dropdown\"\n             (clickOutside)=\"toggleShowContent();\" >\n            <button (click)=\"showContentOn()\">\n                        <span class=\"caret-wrapper\">\n                            <i class=\"icon icon-caret-down\"> </i>\n                        </span>\n            </button>\n            <div class=\"dropdown-content-wrapper\" [ngClass]=\"{'full-width': showContentInFullWidth}\"\n                 [hidden]=\"!showContent\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
    }], function () { return []; }, { showContentInFullWidth: [{
            type: Input
        }], showContent: [{
            type: Input
        }], options: [{
            type: Input
        }], defaultOption: [{
            type: Input
        }], avoidOverridingDefaultOption: [{
            type: Input
        }], toolTipText: [{
            type: Input
        }], onlyShowIconOfDefaultOption: [{
            type: Input
        }] }); })();

class MenuItemDropdownModule {
}
MenuItemDropdownModule.ɵfac = function MenuItemDropdownModule_Factory(t) { return new (t || MenuItemDropdownModule)(); };
MenuItemDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MenuItemDropdownModule });
MenuItemDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        NgbTooltipModule,
        ClickOutsideModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MenuItemDropdownComponent,
                ],
                exports: [
                    MenuItemDropdownComponent,
                ],
                imports: [
                    CommonModule,
                    NgbTooltipModule,
                    ClickOutsideModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MenuItemDropdownModule, { declarations: [MenuItemDropdownComponent], imports: [CommonModule,
        NgbTooltipModule,
        ClickOutsideModule], exports: [MenuItemDropdownComponent] }); })();

/*
  This is an extension of the  angular2-multiselect
  Mainly to adapt the look and feel to the FCC Multi Select Dropdown
  Find more information: https://www.npmjs.com/package/angular2-multiselect-dropdown
*/
function MultiselectDropdownComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.settings.text);
} }
function MultiselectDropdownComponent_span_11_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = ctx.$implicit;
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r25[ctx_r24.settings.labelKey], " ");
} }
function MultiselectDropdownComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_span_11_span_1_Template, 2, 1, "span", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.selectedItems)("ngForTrackBy", ctx_r3.trackByFn.bind(ctx_r3));
} }
function MultiselectDropdownComponent_span_12_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r27[ctx_r29.settings.labelKey]);
} }
function MultiselectDropdownComponent_span_12_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵelement(1, "c-templateRenderer", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().$implicit;
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r30.badgeTempl)("item", item_r27);
} }
function MultiselectDropdownComponent_span_12_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_span_12_div_1_span_1_Template, 2, 1, "span", 27);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_span_12_div_1_span_2_Template, 2, 2, "span", 27);
    i0.ɵɵelementStart(3, "span", 28);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_span_12_div_1_Template_span_click_3_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r34); const item_r27 = restoredCtx.$implicit; const k_r28 = restoredCtx.index; const ctx_r33 = i0.ɵɵnextContext(2); ctx_r33.onItemClick(item_r27, k_r28, $event); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵelement(4, "c-icon", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r26.badgeTempl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.badgeTempl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "remove");
} }
function MultiselectDropdownComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_span_12_div_1_Template, 5, 3, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.selectedItems)("ngForTrackBy", ctx_r4.trackByFn.bind(ctx_r4));
} }
function MultiselectDropdownComponent_div_13_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r36 = i0.ɵɵnextContext().$implicit;
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r36[ctx_r38.settings.labelKey]);
} }
function MultiselectDropdownComponent_div_13_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵelement(1, "c-templateRenderer", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r36 = i0.ɵɵnextContext().$implicit;
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r39.badgeTempl)("item", item_r36);
} }
function MultiselectDropdownComponent_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_13_div_1_span_1_Template, 2, 1, "span", 27);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_13_div_1_span_2_Template, 2, 2, "span", 27);
    i0.ɵɵelementStart(3, "span", 28);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_13_div_1_Template_span_click_3_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r43); const item_r36 = restoredCtx.$implicit; const k_r37 = restoredCtx.index; const ctx_r42 = i0.ɵɵnextContext(2); ctx_r42.onItemClick(item_r36, k_r37, $event); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵelement(4, "c-icon", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const k_r37 = ctx.index;
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", k_r37 > ctx_r35.settings.badgeShowLimit - 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r35.badgeTempl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.badgeTempl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "remove");
} }
function MultiselectDropdownComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_13_div_1_Template, 5, 4, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.selectedItems)("ngForTrackBy", ctx_r5.trackByFn.bind(ctx_r5));
} }
function MultiselectDropdownComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("+", (ctx_r6.selectedItems == null ? null : ctx_r6.selectedItems.length) - ctx_r6.settings.badgeShowLimit, "");
} }
function MultiselectDropdownComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 35);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_span_15_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); ctx_r44.clearSelection($event); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵelement(1, "c-icon", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", "remove");
} }
function MultiselectDropdownComponent_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵelement(1, "c-icon", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", "angle-down");
} }
function MultiselectDropdownComponent_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵelement(1, "c-icon", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", "angle-up");
} }
function MultiselectDropdownComponent_div_21_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 42);
    i0.ɵɵlistener("change", function MultiselectDropdownComponent_div_21_input_1_Template_input_change_0_listener($event) { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r47.toggleSelectAll($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r46.isSelectAll)("disabled", ctx_r46.settings.limitSelection == (ctx_r46.selectedItems == null ? null : ctx_r46.selectedItems.length))("id", ctx_r46.id);
} }
function MultiselectDropdownComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_21_input_1_Template, 1, 3, "input", 39);
    i0.ɵɵelementStart(2, "label", 40)(3, "span", 41);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 41);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.settings.showCheckbox);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r11.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", ctx_r11.isSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r11.settings.selectAllText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", !ctx_r11.isSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r11.settings.unSelectAllText);
} }
function MultiselectDropdownComponent_div_22_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_22_span_3_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r55.clearSearch()); });
    i0.ɵɵelement(1, "c-icon", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r49.filter == undefined || (ctx_r49.filter == null ? null : ctx_r49.filter.length) == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", "clear");
} }
function MultiselectDropdownComponent_div_22_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_22_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r57.resetInfiniteSearch()); });
    i0.ɵɵelement(1, "c-icon", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r50.filter == undefined || (ctx_r50.filter == null ? null : ctx_r50.filter.length) == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", "clear");
} }
function MultiselectDropdownComponent_div_22_input_5_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 50, 51);
    i0.ɵɵlistener("ngModelChange", function MultiselectDropdownComponent_div_22_input_5_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r61); const ctx_r60 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r60.filter = $event); })("keyup", function MultiselectDropdownComponent_div_22_input_5_Template_input_keyup_0_listener() { i0.ɵɵrestoreView(_r61); const ctx_r62 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r62.filterGroupedList()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r51.settings.searchPlaceholderText)("ngModel", ctx_r51.filter);
} }
function MultiselectDropdownComponent_div_22_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 52, 51);
    i0.ɵɵlistener("ngModelChange", function MultiselectDropdownComponent_div_22_input_6_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r64.filter = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r52.settings.searchPlaceholderText)("ngModel", ctx_r52.filter);
} }
function MultiselectDropdownComponent_div_22_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 50, 51);
    i0.ɵɵlistener("ngModelChange", function MultiselectDropdownComponent_div_22_input_7_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r68); const ctx_r67 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r67.filter = $event); })("keyup", function MultiselectDropdownComponent_div_22_input_7_Template_input_keyup_0_listener($event) { i0.ɵɵrestoreView(_r68); const ctx_r69 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r69.searchTerm$.next($event.target.value)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r53.settings.searchPlaceholderText)("ngModel", ctx_r53.filter);
} }
function MultiselectDropdownComponent_div_22_c_templateRenderer_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "c-templateRenderer", 31);
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("data", ctx_r54.searchTempl)("item", ctx_r54.item);
} }
function MultiselectDropdownComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43)(1, "span", 44);
    i0.ɵɵelement(2, "c-icon", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MultiselectDropdownComponent_div_22_span_3_Template, 2, 2, "span", 45);
    i0.ɵɵtemplate(4, MultiselectDropdownComponent_div_22_span_4_Template, 2, 2, "span", 45);
    i0.ɵɵtemplate(5, MultiselectDropdownComponent_div_22_input_5_Template, 2, 2, "input", 46);
    i0.ɵɵtemplate(6, MultiselectDropdownComponent_div_22_input_6_Template, 2, 2, "input", 47);
    i0.ɵɵtemplate(7, MultiselectDropdownComponent_div_22_input_7_Template, 2, 2, "input", 46);
    i0.ɵɵtemplate(8, MultiselectDropdownComponent_div_22_c_templateRenderer_8_Template, 1, 2, "c-templateRenderer", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "search");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.settings.lazyLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.settings.lazyLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.settings.groupBy && !ctx_r12.settings.lazyLoading && !ctx_r12.searchTempl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.settings.groupBy && !ctx_r12.settings.lazyLoading && !ctx_r12.searchTempl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.settings.lazyLoading && !ctx_r12.searchTempl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.searchTempl);
} }
function MultiselectDropdownComponent_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_23_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r76); const ctx_r75 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r75.toggleFilterSelectAll()); });
    i0.ɵɵelement(1, "input", 58);
    i0.ɵɵelementStart(2, "label")(3, "span", 41);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 41);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r70.isFilterSelectAll)("disabled", ctx_r70.settings.limitSelection == (ctx_r70.selectedItems == null ? null : ctx_r70.selectedItems.length));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ctx_r70.isFilterSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r70.settings.filterSelectAllText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", !ctx_r70.isFilterSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r70.settings.filterUnSelectAllText);
} }
function MultiselectDropdownComponent_div_23_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r78 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_23_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r78); const ctx_r77 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r77.toggleFilterSelectAll()); });
    i0.ɵɵelement(1, "input", 59);
    i0.ɵɵelementStart(2, "label")(3, "span", 41);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 41);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r71.isFilterSelectAll && (ctx_r71.filter == null ? null : ctx_r71.filter.length) > 0)("disabled", ctx_r71.settings.limitSelection == (ctx_r71.selectedItems == null ? null : ctx_r71.selectedItems.length));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ctx_r71.isFilterSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r71.settings.filterSelectAllText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", !ctx_r71.isFilterSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r71.settings.filterUnSelectAllText);
} }
function MultiselectDropdownComponent_div_23_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 60);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r72.filter == undefined || (ctx_r72.filter == null ? null : ctx_r72.filter.length) == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r72.settings.noDataLabel);
} }
function MultiselectDropdownComponent_div_23_label_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 60);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r73.filter == undefined || (ctx_r73.filter == null ? null : ctx_r73.filter.length) == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r73.settings.noDataLabel);
} }
function MultiselectDropdownComponent_div_23_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61)(1, "button", 62);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_23_div_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r80); const ctx_r79 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r79.addFilterNewItem()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r74.filter == undefined || (ctx_r74.filter == null ? null : ctx_r74.filter.length) == 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r74.settings.addNewButtonText);
} }
function MultiselectDropdownComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_23_div_1_Template, 7, 6, "div", 54);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_23_div_2_Template, 7, 6, "div", 54);
    i0.ɵɵtemplate(3, MultiselectDropdownComponent_div_23_label_3_Template, 2, 2, "label", 55);
    i0.ɵɵtemplate(4, MultiselectDropdownComponent_div_23_label_4_Template, 2, 2, "label", 55);
    i0.ɵɵtemplate(5, MultiselectDropdownComponent_div_23_div_5_Template, 3, 2, "div", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.settings.groupBy && (ctx_r13.filter == null ? null : ctx_r13.filter.length) > 0 && ctx_r13.filterLength > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.settings.groupBy && (ctx_r13.filter == null ? null : ctx_r13.filter.length) > 0 && (ctx_r13.groupedData == null ? null : ctx_r13.groupedData.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.settings.groupBy && ctx_r13.filterLength == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.settings.groupBy && (ctx_r13.groupedData == null ? null : ctx_r13.groupedData.length) == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.settings.addNewItemOnFilter && ctx_r13.filterLength == 0);
} }
function MultiselectDropdownComponent_div_24_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_24_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r83); const ctx_r82 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r82.toggleInfiniteFilterSelectAll()); });
    i0.ɵɵelement(1, "input", 59);
    i0.ɵɵelementStart(2, "label")(3, "span", 41);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 41);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r81.isInfiniteFilterSelectAll)("disabled", ctx_r81.settings.limitSelection == (ctx_r81.selectedItems == null ? null : ctx_r81.selectedItems.length));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ctx_r81.isInfiniteFilterSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r81.settings.filterSelectAllText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", !ctx_r81.isInfiniteFilterSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r81.settings.filterUnSelectAllText);
} }
function MultiselectDropdownComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_24_div_1_Template, 7, 6, "div", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r14.filter == null ? null : ctx_r14.filter.length) > 0 && ctx_r14.infiniteFilterLength > 0);
} }
function MultiselectDropdownComponent_div_25_li_2_input_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 59);
} if (rf & 2) {
    const item_r85 = i0.ɵɵnextContext().$implicit;
    const ctx_r87 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r87.isSelected(item_r85))("disabled", ctx_r87.settings.limitSelection == (ctx_r87.selectedItems == null ? null : ctx_r87.selectedItems.length) && !ctx_r87.isSelected(item_r85) || item_r85.disabled);
} }
const _c0$8 = function (a0) { return { "selected-item": a0 }; };
function MultiselectDropdownComponent_div_25_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_25_li_2_Template_li_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r90); const item_r85 = restoredCtx.$implicit; const i_r86 = restoredCtx.index; const ctx_r89 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r89.onItemClick(item_r85, i_r86, $event)); });
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_25_li_2_input_1_Template, 1, 2, "input", 67);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r85 = ctx.$implicit;
    const ctx_r84 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$8, ctx_r84.isSelected(item_r85) == true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r84.settings.showCheckbox);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r85[ctx_r84.settings.labelKey]);
} }
function MultiselectDropdownComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63)(1, "ul", 64);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_25_li_2_Template, 4, 5, "li", 65);
    i0.ɵɵpipe(3, "listFilter");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("max-height", ctx_r15.settings.maxHeight + "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 3, ctx_r15.data, ctx_r15.filter, ctx_r15.settings.searchBy));
} }
function MultiselectDropdownComponent_div_26_li_3_input_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r93 = i0.ɵɵnextContext().$implicit;
    const ctx_r95 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r95.isSelected(item_r93))("disabled", ctx_r95.settings.limitSelection == (ctx_r95.selectedItems == null ? null : ctx_r95.selectedItems.length) && !ctx_r95.isSelected(item_r93) || item_r93.disabled);
} }
function MultiselectDropdownComponent_div_26_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r98 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_26_li_3_Template_li_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r98); const item_r93 = restoredCtx.$implicit; const i_r94 = restoredCtx.index; const ctx_r97 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r97.onItemClick(item_r93, i_r94, $event)); });
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_26_li_3_input_1_Template, 1, 2, "input", 70);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r93 = ctx.$implicit;
    const ctx_r92 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$8, ctx_r92.isSelected(item_r93) == true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r92.settings.showCheckbox);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r93[ctx_r92.settings.labelKey]);
} }
const _c1$4 = function (a0) { return { "height": a0 }; };
function MultiselectDropdownComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r100 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63)(1, "ul", 68, 69);
    i0.ɵɵlistener("vsStart", function MultiselectDropdownComponent_div_26_Template_ul_vsStart_1_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r99 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r99.onScrollEnd($event)); })("vsEnd", function MultiselectDropdownComponent_div_26_Template_ul_vsEnd_1_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r101 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r101.onScrollEnd($event)); });
    i0.ɵɵtemplate(3, MultiselectDropdownComponent_div_26_li_3_Template, 4, 5, "li", 65);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r91 = i0.ɵɵreference(2);
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("max-height", ctx_r16.settings.maxHeight + "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("enableUnequalChildrenSizes", ctx_r16.randomSize)("items", ctx_r16.virtualdata)("ngStyle", i0.ɵɵpureFunction1(6, _c1$4, ctx_r16.settings.maxHeight + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", _r91.viewPortItems);
} }
function MultiselectDropdownComponent_div_27_li_2_input_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r103 = i0.ɵɵnextContext().$implicit;
    const ctx_r105 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r105.isSelected(item_r103))("disabled", ctx_r105.settings.limitSelection == (ctx_r105.selectedItems == null ? null : ctx_r105.selectedItems.length) && !ctx_r105.isSelected(item_r103) || item_r103.disabled);
} }
function MultiselectDropdownComponent_div_27_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r108 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_27_li_2_Template_li_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r108); const item_r103 = restoredCtx.$implicit; const i_r104 = restoredCtx.index; const ctx_r107 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r107.onItemClick(item_r103, i_r104, $event)); });
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_27_li_2_input_1_Template, 1, 2, "input", 70);
    i0.ɵɵelement(2, "label")(3, "c-templateRenderer", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r103 = ctx.$implicit;
    const ctx_r102 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$8, ctx_r102.isSelected(item_r103) == true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r102.settings.showCheckbox);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("data", ctx_r102.itemTempl)("item", item_r103);
} }
function MultiselectDropdownComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63)(1, "ul", 64);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_27_li_2_Template, 4, 6, "li", 65);
    i0.ɵɵpipe(3, "listFilter");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("max-height", ctx_r17.settings.maxHeight + "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 3, ctx_r17.data, ctx_r17.filter, ctx_r17.settings.searchBy));
} }
function MultiselectDropdownComponent_div_28_li_3_input_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r111 = i0.ɵɵnextContext().$implicit;
    const ctx_r113 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r113.isSelected(item_r111))("disabled", ctx_r113.settings.limitSelection == (ctx_r113.selectedItems == null ? null : ctx_r113.selectedItems.length) && !ctx_r113.isSelected(item_r111) || item_r111.disabled);
} }
function MultiselectDropdownComponent_div_28_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r116 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_28_li_3_Template_li_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r116); const item_r111 = restoredCtx.$implicit; const i_r112 = restoredCtx.index; const ctx_r115 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r115.onItemClick(item_r111, i_r112, $event)); });
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_28_li_3_input_1_Template, 1, 2, "input", 70);
    i0.ɵɵelement(2, "label")(3, "c-templateRenderer", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r111 = ctx.$implicit;
    const ctx_r110 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$8, ctx_r110.isSelected(item_r111) == true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r110.settings.showCheckbox);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("data", ctx_r110.itemTempl)("item", item_r111);
} }
function MultiselectDropdownComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    const _r118 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63)(1, "ul", 68, 72);
    i0.ɵɵlistener("vsStart", function MultiselectDropdownComponent_div_28_Template_ul_vsStart_1_listener($event) { i0.ɵɵrestoreView(_r118); const ctx_r117 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r117.onScrollEnd($event)); })("vsEnd", function MultiselectDropdownComponent_div_28_Template_ul_vsEnd_1_listener($event) { i0.ɵɵrestoreView(_r118); const ctx_r119 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r119.onScrollEnd($event)); });
    i0.ɵɵtemplate(3, MultiselectDropdownComponent_div_28_li_3_Template, 4, 6, "li", 65);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r109 = i0.ɵɵreference(2);
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("max-height", ctx_r18.settings.maxHeight + "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("enableUnequalChildrenSizes", ctx_r18.randomSize)("items", ctx_r18.virtualdata)("ngStyle", i0.ɵɵpureFunction1(6, _c1$4, ctx_r18.settings.maxHeight + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", _r109.viewPortItems);
} }
function MultiselectDropdownComponent_div_29_span_3_li_1_input_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r122 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r126 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r126.isSelected(item_r122))("disabled", ctx_r126.settings.limitSelection == (ctx_r126.selectedItems == null ? null : ctx_r126.selectedItems.length) && !ctx_r126.isSelected(item_r122) || item_r122.disabled);
} }
const _c2$2 = function (a0, a1) { return { "grp-title": a0, "grp-item": a1 }; };
function MultiselectDropdownComponent_div_29_span_3_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r130 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_29_span_3_li_1_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r130); const ctx_r129 = i0.ɵɵnextContext(); const item_r122 = ctx_r129.$implicit; const i_r123 = ctx_r129.index; const ctx_r128 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r128.onItemClick(item_r122, i_r123, $event)); });
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_29_span_3_li_1_input_1_Template, 1, 2, "input", 70);
    i0.ɵɵelement(2, "label")(3, "c-templateRenderer", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r122 = i0.ɵɵnextContext().$implicit;
    const ctx_r124 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2$2, item_r122.grpTitle, !item_r122.grpTitle && !ctx_r124.settings.singleSelection));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r124.settings.showCheckbox && !ctx_r124.settings.singleSelection);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("data", ctx_r124.itemTempl)("item", item_r122);
} }
function MultiselectDropdownComponent_div_29_span_3_li_2_input_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r122 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r132 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r132.isSelected(item_r122))("disabled", ctx_r132.settings.limitSelection == (ctx_r132.selectedItems == null ? null : ctx_r132.selectedItems.length) && !ctx_r132.isSelected(item_r122) || item_r122.disabled);
} }
function MultiselectDropdownComponent_div_29_span_3_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 77);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_29_span_3_li_2_input_1_Template, 1, 2, "input", 70);
    i0.ɵɵelement(2, "label")(3, "c-templateRenderer", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r122 = i0.ɵɵnextContext().$implicit;
    const ctx_r125 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2$2, item_r122.grpTitle, !item_r122.grpTitle && !ctx_r125.settings.singleSelection));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r125.settings.showCheckbox);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("data", ctx_r125.itemTempl)("item", item_r122);
} }
function MultiselectDropdownComponent_div_29_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_29_span_3_li_1_Template, 4, 7, "li", 75);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_29_span_3_li_2_Template, 4, 7, "li", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r122 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r122.grpTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r122.grpTitle);
} }
function MultiselectDropdownComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r136 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63)(1, "ul", 68, 73);
    i0.ɵɵlistener("vsStart", function MultiselectDropdownComponent_div_29_Template_ul_vsStart_1_listener($event) { i0.ɵɵrestoreView(_r136); const ctx_r135 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r135.onScrollEnd($event)); })("vsEnd", function MultiselectDropdownComponent_div_29_Template_ul_vsEnd_1_listener($event) { i0.ɵɵrestoreView(_r136); const ctx_r137 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r137.onScrollEnd($event)); });
    i0.ɵɵtemplate(3, MultiselectDropdownComponent_div_29_span_3_Template, 3, 2, "span", 74);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r120 = i0.ɵɵreference(2);
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("max-height", ctx_r19.settings.maxHeight + "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("enableUnequalChildrenSizes", ctx_r19.randomSize)("items", ctx_r19.virtualdata)("ngStyle", i0.ɵɵpureFunction1(6, _c1$4, ctx_r19.settings.maxHeight + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", _r120.viewPortItems);
} }
function MultiselectDropdownComponent_div_30_span_2_input_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r139 = i0.ɵɵnextContext().$implicit;
    const ctx_r141 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", item_r139.selected)("disabled", ctx_r141.settings.limitSelection == (ctx_r141.selectedItems == null ? null : ctx_r141.selectedItems.length) && !ctx_r141.isSelected(item_r139) || item_r139.disabled);
} }
function MultiselectDropdownComponent_div_30_span_2_span_6_input_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const val_r144 = i0.ɵɵnextContext().$implicit;
    const ctx_r146 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("checked", ctx_r146.isSelected(val_r144))("disabled", ctx_r146.settings.limitSelection == (ctx_r146.selectedItems == null ? null : ctx_r146.selectedItems.length) && !ctx_r146.isSelected(val_r144) || val_r144.disabled);
} }
function MultiselectDropdownComponent_div_30_span_2_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r149 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_30_span_2_span_6_Template_li_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r149); const val_r144 = restoredCtx.$implicit; const j_r145 = restoredCtx.index; const ctx_r148 = i0.ɵɵnextContext(3); ctx_r148.onItemClick(val_r144, j_r145, $event); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_30_span_2_span_6_input_2_Template, 1, 2, "input", 70);
    i0.ɵɵelement(3, "label")(4, "c-templateRenderer", 31);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const val_r144 = ctx.$implicit;
    const ctx_r142 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2$2, val_r144.grpTitle, !val_r144.grpTitle && !ctx_r142.settings.singleSelection));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r142.settings.showCheckbox);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("data", ctx_r142.itemTempl)("item", val_r144);
} }
function MultiselectDropdownComponent_div_30_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r151 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_30_span_2_Template_li_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r151); const item_r139 = restoredCtx.$implicit; const ctx_r150 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r150.selectGroup(item_r139)); });
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_30_span_2_input_2_Template, 1, 2, "input", 70);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 64);
    i0.ɵɵtemplate(6, MultiselectDropdownComponent_div_30_span_2_span_6_Template, 5, 7, "span", 74);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r139 = ctx.$implicit;
    const ctx_r138 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2$2, item_r139.grpTitle, !item_r139.grpTitle && !ctx_r138.settings.singleSelection));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r138.settings.showCheckbox && !ctx_r138.settings.singleSelection);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r139[ctx_r138.settings.labelKey]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r139.list);
} }
function MultiselectDropdownComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63)(1, "ul", 64);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_30_span_2_Template, 7, 7, "span", 74);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("max-height", ctx_r20.settings.maxHeight + "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r20.groupedData);
} }
function MultiselectDropdownComponent_div_31_span_4_li_1_input_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r154 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r158 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r158.isSelected(item_r154))("disabled", ctx_r158.settings.limitSelection == (ctx_r158.selectedItems == null ? null : ctx_r158.selectedItems.length) && !ctx_r158.isSelected(item_r154) || item_r154.disabled);
} }
const _c3 = function (a0, a1, a2) { return { "grp-title": a0, "grp-item": a1, "selected-item": a2 }; };
function MultiselectDropdownComponent_div_31_span_4_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 77);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_31_span_4_li_1_input_1_Template, 1, 2, "input", 70);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r154 = i0.ɵɵnextContext().$implicit;
    const ctx_r156 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c3, item_r154.grpTitle, !item_r154.grpTitle && !ctx_r156.settings.singleSelection, ctx_r156.isSelected(item_r154) == true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r156.settings.showCheckbox && !item_r154.grpTitle && !ctx_r156.settings.singleSelection);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r154[ctx_r156.settings.labelKey]);
} }
function MultiselectDropdownComponent_div_31_span_4_li_2_input_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r154 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r161 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r161.isSelected(item_r154))("disabled", ctx_r161.settings.limitSelection == (ctx_r161.selectedItems == null ? null : ctx_r161.selectedItems.length) && !ctx_r161.isSelected(item_r154) || item_r154.disabled);
} }
function MultiselectDropdownComponent_div_31_span_4_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r165 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_31_span_4_li_2_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r165); const ctx_r164 = i0.ɵɵnextContext(); const item_r154 = ctx_r164.$implicit; const i_r155 = ctx_r164.index; const ctx_r163 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r163.onItemClick(item_r154, i_r155, $event)); });
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_31_span_4_li_2_input_1_Template, 1, 2, "input", 70);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r154 = i0.ɵɵnextContext().$implicit;
    const ctx_r157 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c3, item_r154.grpTitle, !item_r154.grpTitle && !ctx_r157.settings.singleSelection, ctx_r157.isSelected(item_r154) == true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r157.settings.showCheckbox && !item_r154.grpTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r154[ctx_r157.settings.labelKey]);
} }
function MultiselectDropdownComponent_div_31_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_31_span_4_li_1_Template, 4, 7, "li", 76);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_31_span_4_li_2_Template, 4, 7, "li", 75);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r154 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r154.grpTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r154.grpTitle);
} }
function MultiselectDropdownComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    const _r168 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63)(1, "virtual-scroller", 78);
    i0.ɵɵlistener("vsUpdate", function MultiselectDropdownComponent_div_31_Template_virtual_scroller_vsUpdate_1_listener($event) { i0.ɵɵrestoreView(_r168); const ctx_r167 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r167.viewPortItems = $event); })("vsEnd", function MultiselectDropdownComponent_div_31_Template_virtual_scroller_vsEnd_1_listener($event) { i0.ɵɵrestoreView(_r168); const ctx_r169 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r169.onScrollEnd($event)); });
    i0.ɵɵelementStart(2, "ul", 68, 79);
    i0.ɵɵlistener("vsStart", function MultiselectDropdownComponent_div_31_Template_ul_vsStart_2_listener($event) { i0.ɵɵrestoreView(_r168); const ctx_r170 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r170.onScrollEnd($event)); })("vsEnd", function MultiselectDropdownComponent_div_31_Template_ul_vsEnd_2_listener($event) { i0.ɵɵrestoreView(_r168); const ctx_r171 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r171.onScrollEnd($event)); });
    i0.ɵɵtemplate(4, MultiselectDropdownComponent_div_31_span_4_Template, 3, 2, "span", 74);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r152 = i0.ɵɵreference(3);
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("max-height", ctx_r21.settings.maxHeight + "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r21.groupedData)("ngStyle", i0.ɵɵpureFunction1(8, _c1$4, ctx_r21.settings.maxHeight + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("enableUnequalChildrenSizes", ctx_r21.randomSize)("items", ctx_r21.virtualdata)("ngStyle", i0.ɵɵpureFunction1(10, _c1$4, ctx_r21.settings.maxHeight + "px"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", _r152.viewPortItems);
} }
function MultiselectDropdownComponent_div_32_span_2_input_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const item_r173 = i0.ɵɵnextContext().$implicit;
    const ctx_r175 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", item_r173.selected)("disabled", ctx_r175.settings.limitSelection == (ctx_r175.selectedItems == null ? null : ctx_r175.selectedItems.length) && !ctx_r175.isSelected(item_r173) || item_r173.disabled);
} }
function MultiselectDropdownComponent_div_32_span_2_span_6_input_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 71);
} if (rf & 2) {
    const val_r178 = i0.ɵɵnextContext().$implicit;
    const ctx_r180 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("checked", ctx_r180.isSelected(val_r178))("disabled", ctx_r180.settings.limitSelection == (ctx_r180.selectedItems == null ? null : ctx_r180.selectedItems.length) && !ctx_r180.isSelected(val_r178) || val_r178.disabled);
} }
const _c4 = function (a0, a1, a2) { return { "selected-item": a0, "grp-title": a1, "grp-item": a2 }; };
function MultiselectDropdownComponent_div_32_span_2_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r183 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_32_span_2_span_6_Template_li_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r183); const val_r178 = restoredCtx.$implicit; const j_r179 = restoredCtx.index; const ctx_r182 = i0.ɵɵnextContext(3); ctx_r182.onItemClick(val_r178, j_r179, $event); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_32_span_2_span_6_input_2_Template, 1, 2, "input", 70);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const val_r178 = ctx.$implicit;
    const ctx_r176 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c4, ctx_r176.isSelected(val_r178) == true, val_r178.grpTitle, !val_r178.grpTitle && !ctx_r176.settings.singleSelection));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r176.settings.showCheckbox);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(val_r178[ctx_r176.settings.labelKey]);
} }
function MultiselectDropdownComponent_div_32_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r185 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "li", 66);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_32_span_2_Template_li_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r185); const item_r173 = restoredCtx.$implicit; const ctx_r184 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r184.selectGroup(item_r173)); });
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_32_span_2_input_2_Template, 1, 2, "input", 70);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 64);
    i0.ɵɵtemplate(6, MultiselectDropdownComponent_div_32_span_2_span_6_Template, 5, 7, "span", 74);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r173 = ctx.$implicit;
    const ctx_r172 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2$2, item_r173.grpTitle, !item_r173.grpTitle && !ctx_r172.settings.singleSelection));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r172.settings.showCheckbox && !ctx_r172.settings.singleSelection);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r173[ctx_r172.settings.labelKey]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r173.list);
} }
function MultiselectDropdownComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63)(1, "ul", 64);
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_div_32_span_2_Template, 7, 7, "span", 74);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("max-height", ctx_r22.settings.maxHeight + "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r22.groupedData);
} }
function MultiselectDropdownComponent_h5_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 80);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r23.settings.noDataLabel);
} }
const _c5 = function (a0) { return { open: a0 }; };
const _c6 = function (a0) { return { "disabled": a0 }; };
const _c7 = function (a0) { return { "dropdown-list-top": a0 }; };
const _c8 = function (a0) { return { "single-select-mode": a0 }; };
class MultiselectDropdownComponent extends AngularMultiSelect {
    constructor() {
        super(...arguments);
        this.label = '';
    }
}
MultiselectDropdownComponent.ɵfac = /*@__PURE__*/ function () { let ɵMultiselectDropdownComponent_BaseFactory; return function MultiselectDropdownComponent_Factory(t) { return (ɵMultiselectDropdownComponent_BaseFactory || (ɵMultiselectDropdownComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MultiselectDropdownComponent)))(t || MultiselectDropdownComponent); }; }();
MultiselectDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiselectDropdownComponent, selectors: [["app-multiselect-dropdown"]], inputs: { label: "label" }, features: [i0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MultiselectDropdownComponent),
                multi: true
            }]), i0.ɵɵInheritDefinitionFeature], decls: 34, vars: 38, consts: [[1, "form-field", "form-field-is-filled", "multiselect-parent", "btn-group", "dropdown-multiselect", 3, "ngClass"], [1, "form-field-control"], ["for", "", 1, "form-field-label"], [1, "form-field-input"], [1, "cuppa-dropdown", 3, "clickOutside"], ["cuppaDropdown", ""], [1, "selected-list"], ["selectedList", ""], [1, "c-btn", 3, "ngClass", "click"], [4, "ngIf"], ["class", "c-list", 4, "ngIf"], ["class", "countplaceholder", 4, "ngIf"], ["class", "c-remove clear-all", 3, "click", 4, "ngIf"], ["class", "c-angle-down", 4, "ngIf"], ["class", "c-angle-up", 4, "ngIf"], [1, "dropdown-list", "animated", "fadeIn", 3, "ngClass", "hidden"], ["dropdownList", ""], [1, "list-area", 3, "ngClass"], ["class", "pure-checkbox select-all", 4, "ngIf"], ["class", "list-filter", 4, "ngIf"], ["class", "filter-select-all", 4, "ngIf"], ["style", "overflow: auto;", 3, "maxHeight", 4, "ngIf"], ["class", "list-message", 4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "c-list"], ["class", "c-token", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "c-token"], ["class", "c-label", 4, "ngIf"], [1, "c-remove", 3, "click"], [3, "name"], [1, "c-label"], [3, "data", "item"], ["class", "c-token", 3, "hidden", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "c-token", 3, "hidden"], [1, "countplaceholder"], [1, "c-remove", "clear-all", 3, "click"], [1, "c-angle-down"], [1, "c-angle-up"], [1, "pure-checkbox", "select-all"], ["type", "checkbox", 3, "checked", "disabled", "id", "change", 4, "ngIf"], [3, "for"], [3, "hidden"], ["type", "checkbox", 3, "checked", "disabled", "id", "change"], [1, "list-filter"], ["id", "searchIcon", 1, "c-search"], ["class", "c-clear", 3, "hidden", "click", 4, "ngIf"], ["class", "c-input", "type", "text", "aria-labelledby", "searchIcon", 3, "placeholder", "ngModel", "ngModelChange", "keyup", 4, "ngIf"], ["class", "c-input", "type", "text", "aria-labelledby", "searchIcon", 3, "placeholder", "ngModel", "ngModelChange", 4, "ngIf"], [3, "data", "item", 4, "ngIf"], [1, "c-clear", 3, "hidden", "click"], ["type", "text", "aria-labelledby", "searchIcon", 1, "c-input", 3, "placeholder", "ngModel", "ngModelChange", "keyup"], ["searchInput", ""], ["type", "text", "aria-labelledby", "searchIcon", 1, "c-input", 3, "placeholder", "ngModel", "ngModelChange"], [1, "filter-select-all"], ["class", "pure-checkbox select-all", 3, "click", 4, "ngIf"], ["class", "nodata-label", 3, "hidden", 4, "ngIf"], ["class", "btn-container", 3, "hidden", 4, "ngIf"], [1, "pure-checkbox", "select-all", 3, "click"], ["type", "checkbox", "aria-labelledby", "optionName", "aria-label", "option", 3, "checked", "disabled"], ["type", "checkbox", "aria-labelledby", "option", 3, "checked", "disabled"], [1, "nodata-label", 3, "hidden"], [1, "btn-container", 3, "hidden"], [1, "c-btn", "btn-iceblue", 3, "click"], [2, "overflow", "auto"], [1, "lazyContainer"], ["class", "pure-checkbox", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "pure-checkbox", 3, "ngClass", "click"], ["type", "checkbox", "aria-labelledby", "option", 3, "checked", "disabled", 4, "ngIf"], ["virtualScroller", "", 1, "lazyContainer", 3, "enableUnequalChildrenSizes", "items", "ngStyle", "vsStart", "vsEnd"], ["scroll", ""], ["type", "checkbox", 3, "checked", "disabled", 4, "ngIf"], ["type", "checkbox", 3, "checked", "disabled"], ["scroll2", ""], ["scroll3", ""], [4, "ngFor", "ngForOf"], ["class", "pure-checkbox", 3, "ngClass", "click", 4, "ngIf"], ["class", "pure-checkbox", 3, "ngClass", 4, "ngIf"], [1, "pure-checkbox", 3, "ngClass"], [3, "items", "ngStyle", "vsUpdate", "vsEnd"], ["scroll4", ""], [1, "list-message"]], template: function MultiselectDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4, 5);
        i0.ɵɵlistener("clickOutside", function MultiselectDropdownComponent_Template_div_clickOutside_5_listener() { return ctx.closeDropdownOnClickOut(); });
        i0.ɵɵelementStart(7, "div", 6, 7)(9, "div", 8);
        i0.ɵɵlistener("click", function MultiselectDropdownComponent_Template_div_click_9_listener($event) { return ctx.toggleDropdown($event); });
        i0.ɵɵtemplate(10, MultiselectDropdownComponent_span_10_Template, 2, 1, "span", 9);
        i0.ɵɵtemplate(11, MultiselectDropdownComponent_span_11_Template, 2, 2, "span", 9);
        i0.ɵɵtemplate(12, MultiselectDropdownComponent_span_12_Template, 2, 2, "span", 10);
        i0.ɵɵtemplate(13, MultiselectDropdownComponent_div_13_Template, 2, 2, "div", 10);
        i0.ɵɵtemplate(14, MultiselectDropdownComponent_span_14_Template, 2, 1, "span", 11);
        i0.ɵɵtemplate(15, MultiselectDropdownComponent_span_15_Template, 2, 1, "span", 12);
        i0.ɵɵtemplate(16, MultiselectDropdownComponent_span_16_Template, 2, 1, "span", 13);
        i0.ɵɵtemplate(17, MultiselectDropdownComponent_span_17_Template, 2, 1, "span", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(18, "div", 15, 16)(20, "div", 17);
        i0.ɵɵtemplate(21, MultiselectDropdownComponent_div_21_Template, 7, 6, "div", 18);
        i0.ɵɵtemplate(22, MultiselectDropdownComponent_div_22_Template, 9, 7, "div", 19);
        i0.ɵɵtemplate(23, MultiselectDropdownComponent_div_23_Template, 6, 5, "div", 20);
        i0.ɵɵtemplate(24, MultiselectDropdownComponent_div_24_Template, 2, 1, "div", 20);
        i0.ɵɵtemplate(25, MultiselectDropdownComponent_div_25_Template, 4, 7, "div", 21);
        i0.ɵɵtemplate(26, MultiselectDropdownComponent_div_26_Template, 4, 8, "div", 21);
        i0.ɵɵtemplate(27, MultiselectDropdownComponent_div_27_Template, 4, 7, "div", 21);
        i0.ɵɵtemplate(28, MultiselectDropdownComponent_div_28_Template, 4, 8, "div", 21);
        i0.ɵɵtemplate(29, MultiselectDropdownComponent_div_29_Template, 4, 8, "div", 21);
        i0.ɵɵtemplate(30, MultiselectDropdownComponent_div_30_Template, 3, 3, "div", 21);
        i0.ɵɵtemplate(31, MultiselectDropdownComponent_div_31_Template, 5, 12, "div", 21);
        i0.ɵɵtemplate(32, MultiselectDropdownComponent_div_32_Template, 3, 3, "div", 21);
        i0.ɵɵtemplate(33, MultiselectDropdownComponent_h5_33_Template, 2, 1, "h5", 22);
        i0.ɵɵelementEnd()()()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(30, _c5, ctx.isActive));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.label);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(32, _c6, ctx.settings.disabled));
        i0.ɵɵattribute("tabindex", 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.selectedItems == null ? null : ctx.selectedItems.length) == 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.singleSelection && !ctx.badgeTempl);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.selectedItems == null ? null : ctx.selectedItems.length) > 0 && ctx.settings.singleSelection && ctx.badgeTempl);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.selectedItems == null ? null : ctx.selectedItems.length) > 0 && !ctx.settings.singleSelection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.selectedItems == null ? null : ctx.selectedItems.length) > (ctx.settings == null ? null : ctx.settings.badgeShowLimit));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.clearAll && (ctx.selectedItems == null ? null : ctx.selectedItems.length) > 0 && !ctx.settings.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isActive);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isActive);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("bottom", ctx.dropdownListYOffset ? ctx.dropdownListYOffset : null, "px");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(34, _c7, ctx.dropdownListYOffset))("hidden", !ctx.isActive);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c8, ctx.settings.singleSelection));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.enableCheckAll && !ctx.settings.singleSelection && !ctx.settings.limitSelection && (ctx.data == null ? null : ctx.data.length) > 0 && !ctx.isDisabledItemPresent);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.enableSearchFilter);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.settings.lazyLoading && ctx.settings.enableFilterSelectAll && !ctx.isDisabledItemPresent);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.lazyLoading && ctx.settings.enableFilterSelectAll && !ctx.isDisabledItemPresent);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.settings.groupBy && !ctx.settings.lazyLoading && ctx.itemTempl == undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.settings.groupBy && ctx.settings.lazyLoading && ctx.itemTempl == undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.settings.groupBy && !ctx.settings.lazyLoading && ctx.itemTempl != undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.settings.groupBy && ctx.settings.lazyLoading && ctx.itemTempl != undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.groupBy && ctx.settings.lazyLoading && ctx.itemTempl != undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.groupBy && !ctx.settings.lazyLoading && ctx.itemTempl != undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.groupBy && ctx.settings.lazyLoading && ctx.itemTempl == undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.groupBy && !ctx.settings.lazyLoading && ctx.itemTempl == undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.length) == 0);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgStyle, i2.ClickOutsideDirective, i3$1.ClickOutsideDirective, i3$1.TemplateRenderer, i3$1.ɵh, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, i5.VirtualScrollerComponent, i3$1.ListFilterPipe], styles: ["app-multiselect-dropdown .form-field-input{height:2rem!important;align-items:center}virtual-scroll{display:block;width:100%}.cuppa-dropdown{position:relative;flex-grow:1}.cuppa-dropdown ::focus{outline:none}.cuppa-dropdown .selected-item{background-color:transparent;margin:0}.c-btn{background-color:transparent;border:none;display:inline-block;line-height:1.25;border-radius:3px;font-size:.85rem;padding:5px 10px;cursor:pointer;align-items:center;min-height:38px}.c-btn:focus{outline:none}.c-btn.disabled{background:#ccc}.selected-list .c-list{float:left;padding:0;margin:0;width:calc(100% - 20px)}.selected-list .c-list .c-token{list-style:none;padding:4px 22px 4px 8px;border-radius:2px;margin-right:4px;margin-top:2px;float:left;position:relative}.selected-list .c-list .c-token .c-label{display:block;float:left}.selected-list .c-list .c-token .c-remove{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:8px}.selected-list .c-list .c-token .c-remove svg{fill:#fff}.selected-list .fa-angle-down,.selected-list .fa-angle-up{font-size:15pt;position:absolute;right:10px;top:50%;transform:translateY(-50%)}.selected-list .c-angle-down,.selected-list .c-angle-up{width:12px;height:12px;position:absolute;right:10px;top:50%;transform:translateY(-50%);pointer-events:none}.selected-list .c-angle-down svg,.selected-list .c-angle-up svg{fill:#333}.selected-list .countplaceholder{position:absolute;right:45px;top:50%;transform:translateY(-50%)}.selected-list .c-btn{width:100%;padding:5px 0;cursor:pointer;display:flex;position:relative}.selected-list .c-btn .c-icon{position:absolute;right:5px;top:50%;transform:translateY(-50%)}.dropdown-list{position:absolute;padding-top:14px;width:100%;z-index:99999}.dropdown-list ul{padding:0;list-style:none;overflow:auto;margin:0}.dropdown-list ul li{padding:10px;cursor:pointer;text-align:left}.dropdown-list ul li:first-child{padding-top:10px}.dropdown-list ul li:last-child{padding-bottom:10px}.dropdown-list::-webkit-scrollbar{width:8px}.dropdown-list::-webkit-scrollbar-thumb{background:#ccc;border-radius:5px}.dropdown-list::-webkit-scrollbar-track{background:#f2f2f2}.arrow-down,.arrow-up{width:0;height:0;border-left:13px solid transparent;border-right:13px solid transparent;border-bottom:15px solid #fff;margin-left:15px;position:absolute;top:0}.arrow-down{bottom:-14px;top:unset;transform:rotate(180deg)}.arrow-2{border-bottom:15px solid #ccc;top:-1px}.arrow-down.arrow-2{top:unset;bottom:-16px}.list-area{border:1px solid #ccc;border-radius:3px;background:#fff;margin:0}.select-all{padding:10px;border-bottom:1px solid #ccc;text-align:left}.list-filter{border-bottom:1px solid #ccc;position:relative;padding-left:35px;height:35px}.list-filter input{border:0;width:100%;height:100%;padding:0}.list-filter input:focus{outline:0}.list-filter .c-search{position:absolute;top:9px;left:10px;width:15px;height:15px}.list-filter .c-search svg{fill:#888}.list-filter .c-clear{position:absolute;top:10px;right:10px;width:15px;height:15px}.list-filter .c-clear svg{fill:#888}.pure-checkbox input[type=checkbox]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.pure-checkbox input[type=checkbox] label{font-weight:400}.pure-checkbox input[type=checkbox]:focus+label:before,.pure-checkbox input[type=checkbox]:hover+label:before{background-color:#f2f2f2}.pure-checkbox input[type=checkbox]:active+label:before{transition-duration:0s}.pure-checkbox input[type=checkbox]:disabled+label{color:#ccc}.pure-checkbox input[type=checkbox]+label{position:relative;padding-left:2em;vertical-align:middle;-webkit-user-select:none;user-select:none;cursor:pointer;margin:0;font-weight:300}.pure-checkbox input[type=checkbox]+label:before{box-sizing:content-box;content:\"\";position:absolute;top:50%;left:0;width:15px;height:15px;margin-top:-9px;text-align:center;transition:.4s;border-radius:3px}.pure-checkbox input[type=checkbox]+label:after{box-sizing:content-box;content:\"\";position:absolute;transform:scale(0);transform-origin:50%;transition:transform .2s ease-out;background-color:transparent;top:50%;left:3px;width:9px;height:4px;margin-top:-5px;border-style:solid;border-width:0 0 2px 2px;border-image:none;transform:rotate(-45deg) scale(0)}.theme-default .pure-checkbox input[type=checkbox]+label:after{border-color:var(--default-primary)}.theme-x-pick .pure-checkbox input[type=checkbox]+label:after{border-color:var(--xpick-primary)}.theme-ai-studio .pure-checkbox input[type=checkbox]+label:after{border-color:var(--aistudio-primary)}.theme-frontline-creator .pure-checkbox input[type=checkbox]+label:after{border-color:var(--creator-primary)}.theme-x-make .pure-checkbox input[type=checkbox]+label:after{border-color:var(--xmake-primary)}.theme-spatial .pure-checkbox input[type=checkbox]+label:after{border-color:var(--spatial-primary)}.theme-admin .pure-checkbox input[type=checkbox]+label:after{border-color:var(--admin-secondary)}.theme-x-assist .pure-checkbox input[type=checkbox]+label:after{border-color:var(--xassist-secondary)}.theme-x-inspect .pure-checkbox input[type=checkbox]+label:after{border-color:var(--xinspect-primary)}.pure-checkbox input[type=checkbox]:disabled+label:before{border-color:#ccc}.pure-checkbox input[type=checkbox]:disabled:focus+label:before .pure-checkbox input[type=checkbox]:disabled:hover+label:before{background-color:inherit}.pure-checkbox input[type=checkbox]:disabled:checked+label:before{background-color:#ccc}.pure-checkbox input[type=radio]:checked+label:before{background-color:#fff}.pure-checkbox input[type=radio]:checked+label:after{transform:scale(1)}.pure-checkbox input[type=radio]+label:before{border-radius:50%}.pure-checkbox input[type=checkbox]:checked+label:after{content:\"\";transition:transform .2s ease-out;transform:rotate(-45deg) scale(1)}.list-message{text-align:center;margin:0;padding:15px 0;font-size:initial}.list-grp{padding:0 15px!important}.list-grp h4{text-transform:capitalize;margin:15px 0 0;font-size:14px;font-weight:700}.list-grp>li{padding-left:15px!important}.grp-item{padding-left:30px!important}.grp-title{padding-bottom:0!important}.grp-title label{margin-bottom:0!important;font-weight:800;text-transform:capitalize}.grp-title:hover{background:0 0!important}.loading-icon{width:20px;position:absolute;right:10px;top:23px;z-index:1}.nodata-label{width:100%;text-align:center;padding:10px 0 0}.btn-container{text-align:center;padding:0 5px 10px}.clear-all{width:8px;position:absolute;top:50%;right:30px;transform:translateY(-50%)}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiselectDropdownComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'app-multiselect-dropdown', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MultiselectDropdownComponent),
                        multi: true
                    }], encapsulation: ViewEncapsulation.None, template: "<div class=\"form-field form-field-is-filled  multiselect-parent btn-group dropdown-multiselect\"\n    [ngClass]=\"{ open : isActive} \">\n    <div class=\"form-field-control\">\n        <label class=\"form-field-label\" for=\"\">{{label}}</label>\n        <div class=\"form-field-input\">\n            <div class=\"cuppa-dropdown\" (clickOutside)=\"closeDropdownOnClickOut()\" #cuppaDropdown>\n                <div class=\"selected-list\" #selectedList>\n                    <div class=\"c-btn\" (click)=\"toggleDropdown($event)\" [ngClass]=\"{'disabled': settings.disabled}\"\n                        [attr.tabindex]=\"0\">\n                        <span *ngIf=\"selectedItems?.length == 0\">{{settings.text}}</span>\n                        <span *ngIf=\"settings.singleSelection && !badgeTempl\">\n                            <span *ngFor=\"let item of selectedItems;trackBy: trackByFn.bind(this);\">\n                                {{item[settings.labelKey]}}\n                            </span>\n                        </span>\n                        <span class=\"c-list\"\n                            *ngIf=\"selectedItems?.length > 0 && settings.singleSelection && badgeTempl \">\n                            <div class=\"c-token\"\n                                *ngFor=\"let item of selectedItems;trackBy: trackByFn.bind(this);let k = index\">\n                                <span *ngIf=\"!badgeTempl\" class=\"c-label\">{{item[settings.labelKey]}}</span>\n                                <span *ngIf=\"badgeTempl\" class=\"c-label\">\n                                    <c-templateRenderer [data]=\"badgeTempl\" [item]=\"item\"></c-templateRenderer>\n                                </span>\n                                <span class=\"c-remove\" (click)=\"onItemClick(item,k,$event);$event.stopPropagation()\">\n                                    <c-icon [name]=\"'remove'\"></c-icon>\n                                </span>\n                            </div>\n                        </span>\n                        <div class=\"c-list\" *ngIf=\"selectedItems?.length > 0 && !settings.singleSelection\">\n                            <div class=\"c-token\"\n                                *ngFor=\"let item of selectedItems;trackBy: trackByFn.bind(this);let k = index\"\n                                [hidden]=\"k > settings.badgeShowLimit-1\">\n                                <span *ngIf=\"!badgeTempl\" class=\"c-label\">{{item[settings.labelKey]}}</span>\n                                <span *ngIf=\"badgeTempl\" class=\"c-label\">\n                                    <c-templateRenderer [data]=\"badgeTempl\" [item]=\"item\"></c-templateRenderer>\n                                </span>\n                                <span class=\"c-remove\" (click)=\"onItemClick(item,k,$event);$event.stopPropagation()\">\n                                    <c-icon [name]=\"'remove'\"></c-icon>\n                                </span>\n                            </div>\n                        </div>\n                        <span class=\"countplaceholder\"\n                            *ngIf=\"selectedItems?.length > settings?.badgeShowLimit\">+{{selectedItems?.length -\n                            settings.badgeShowLimit }}</span>\n                        <span class=\"c-remove clear-all\"\n                            *ngIf=\"settings.clearAll && selectedItems?.length > 0 && !settings.disabled\"\n                            (click)=\"clearSelection($event);$event.stopPropagation()\">\n                            <c-icon [name]=\"'remove'\"></c-icon>\n                        </span>\n                        <span *ngIf=\"!isActive\" class=\"c-angle-down\">\n                            <c-icon [name]=\"'angle-down'\"></c-icon>\n                        </span>\n                        <span *ngIf=\"isActive\" class=\"c-angle-up\">\n                            <c-icon [name]=\"'angle-up'\"></c-icon>\n                        </span>\n                    </div>\n                </div>\n                <div #dropdownList class=\"dropdown-list animated fadeIn\"\n                    [ngClass]=\"{'dropdown-list-top': dropdownListYOffset}\"\n                    [style.bottom.px]=\"dropdownListYOffset ? dropdownListYOffset : null\" [hidden]=\"!isActive\">\n                    <!-- <div [ngClass]=\"{'arrow-up': !dropdownListYOffset, 'arrow-down': dropdownListYOffset}\" class=\"arrow-2\"></div> -->\n                    <!-- <div [ngClass]=\"{'arrow-up': !dropdownListYOffset, 'arrow-down': dropdownListYOffset}\"></div> -->\n                    <div class=\"list-area\" [ngClass]=\"{'single-select-mode': settings.singleSelection }\">\n                        <div class=\"pure-checkbox select-all\"\n                            *ngIf=\"settings.enableCheckAll && !settings.singleSelection && !settings.limitSelection && data?.length > 0 && !isDisabledItemPresent\">\n                            <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelectAll\"\n                                [disabled]=\"settings.limitSelection == selectedItems?.length\" [id]=\"id\"\n                                (change)=\"toggleSelectAll($event)\" />\n                            <label [for]=\"id\">\n                                <span [hidden]=\"isSelectAll\">{{settings.selectAllText}}</span>\n                                <span [hidden]=\"!isSelectAll\">{{settings.unSelectAllText}}</span>\n                            </label>\n                        </div>\n                        <!-- <img class=\"loading-icon\" *ngIf=\"loading\" src=\"assets/img/loading.gif\" /> -->\n                        <div class=\"list-filter\" *ngIf=\"settings.enableSearchFilter\">\n                            <span class=\"c-search\" id=\"searchIcon\">\n                                <c-icon [name]=\"'search'\"></c-icon>\n                            </span>\n                            <span *ngIf=\"!settings.lazyLoading\" [hidden]=\"filter == undefined || filter?.length == 0\"\n                                class=\"c-clear\" (click)=\"clearSearch()\">\n                                <c-icon [name]=\"'clear'\"></c-icon>\n                            </span>\n                            <span *ngIf=\"settings.lazyLoading\" [hidden]=\"filter == undefined || filter?.length == 0\"\n                                class=\"c-clear\" (click)=\"resetInfiniteSearch()\">\n                                <c-icon [name]=\"'clear'\"></c-icon>\n                            </span>\n                            <input class=\"c-input\" *ngIf=\"settings.groupBy && !settings.lazyLoading && !searchTempl\"\n                                #searchInput type=\"text\" [placeholder]=\"settings.searchPlaceholderText\"\n                                [(ngModel)]=\"filter\" (keyup)=\"filterGroupedList()\" aria-labelledby=\"searchIcon\">\n                            <input class=\"c-input\" *ngIf=\"!settings.groupBy && !settings.lazyLoading && !searchTempl\"\n                                #searchInput type=\"text\" [placeholder]=\"settings.searchPlaceholderText\"\n                                [(ngModel)]=\"filter\" aria-labelledby=\"searchIcon\">\n                            <input class=\"c-input\" *ngIf=\"settings.lazyLoading && !searchTempl\" #searchInput type=\"text\"\n                                [placeholder]=\"settings.searchPlaceholderText\" [(ngModel)]=\"filter\"\n                                (keyup)=\"searchTerm$.next($event.target.value)\" aria-labelledby=\"searchIcon\">\n                            <!--            <input class=\"c-input\" *ngIf=\"!settings.lazyLoading && !searchTempl && settings.groupBy\" #searchInput type=\"text\" [placeholder]=\"settings.searchPlaceholderText\"\n                        [(ngModel)]=\"filter\" (keyup)=\"filterGroupList($event)\">-->\n                            <c-templateRenderer *ngIf=\"searchTempl\" [data]=\"searchTempl\" [item]=\"item\">\n                            </c-templateRenderer>\n                        </div>\n                        <div class=\"filter-select-all\"\n                            *ngIf=\"!settings.lazyLoading && settings.enableFilterSelectAll && !isDisabledItemPresent\">\n                            <div class=\"pure-checkbox select-all\"\n                                *ngIf=\"!settings.groupBy && filter?.length > 0 && filterLength > 0\"\n                                (click)=\"toggleFilterSelectAll()\">\n                                <input type=\"checkbox\" [checked]=\"isFilterSelectAll\"\n                                    [disabled]=\"settings.limitSelection == selectedItems?.length\"\n                                    aria-labelledby=\"optionName\" aria-label=\"option\" />\n                                <label>\n                                    <span [hidden]=\"isFilterSelectAll\">{{settings.filterSelectAllText}}</span>\n                                    <span [hidden]=\"!isFilterSelectAll\">{{settings.filterUnSelectAllText}}</span>\n                                </label>\n                            </div>\n                            <div class=\"pure-checkbox select-all\"\n                                *ngIf=\"settings.groupBy && filter?.length > 0 && groupedData?.length > 0\"\n                                (click)=\"toggleFilterSelectAll()\">\n                                <input type=\"checkbox\" [checked]=\"isFilterSelectAll && filter?.length > 0\"\n                                    [disabled]=\"settings.limitSelection == selectedItems?.length\"\n                                    aria-labelledby=\"option\" />\n                                <label>\n                                    <span [hidden]=\"isFilterSelectAll\">{{settings.filterSelectAllText}}</span>\n                                    <span [hidden]=\"!isFilterSelectAll\">{{settings.filterUnSelectAllText}}</span>\n                                </label>\n                            </div>\n                            <label class=\"nodata-label\" *ngIf=\"!settings.groupBy && filterLength == 0\"\n                                [hidden]=\"filter == undefined || filter?.length == 0\">{{settings.noDataLabel}}</label>\n                            <label class=\"nodata-label\" *ngIf=\"settings.groupBy && groupedData?.length == 0\"\n                                [hidden]=\"filter == undefined || filter?.length == 0\">{{settings.noDataLabel}}</label>\n                            <div class=\"btn-container\" *ngIf=\"settings.addNewItemOnFilter && filterLength == 0\"\n                                [hidden]=\"filter == undefined || filter?.length == 0\">\n                                <button class=\"c-btn btn-iceblue\"\n                                    (click)=\"addFilterNewItem()\">{{settings.addNewButtonText}}</button>\n                            </div>\n                        </div>\n                        <div class=\"filter-select-all\"\n                            *ngIf=\"settings.lazyLoading && settings.enableFilterSelectAll && !isDisabledItemPresent\">\n                            <div class=\"pure-checkbox select-all\" *ngIf=\"filter?.length > 0 && infiniteFilterLength > 0\"\n                                (click)=\"toggleInfiniteFilterSelectAll()\">\n                                <input type=\"checkbox\" [checked]=\"isInfiniteFilterSelectAll\"\n                                    [disabled]=\"settings.limitSelection == selectedItems?.length\"\n                                    aria-labelledby=\"option\" />\n                                <label>\n                                    <span [hidden]=\"isInfiniteFilterSelectAll\">{{settings.filterSelectAllText}}</span>\n                                    <span\n                                        [hidden]=\"!isInfiniteFilterSelectAll\">{{settings.filterUnSelectAllText}}</span>\n                                </label>\n                            </div>\n                        </div>\n                        <div *ngIf=\"!settings.groupBy && !settings.lazyLoading && itemTempl == undefined\"\n                            [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                            <ul class=\"lazyContainer\">\n                                <li *ngFor=\"let item of data | listFilter:filter : settings.searchBy; let i = index;\"\n                                    (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\"\n                                    [ngClass]=\"{'selected-item': isSelected(item) == true }\">\n                                    <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\"\n                                        [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\"\n                                        aria-labelledby=\"option\" />\n                                    <label>{{item[settings.labelKey]}}</label>\n                                </li>\n                            </ul>\n                        </div>\n                        <div *ngIf=\"!settings.groupBy && settings.lazyLoading && itemTempl == undefined\"\n                            [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                            <ul virtualScroller #scroll [enableUnequalChildrenSizes]=\"randomSize\" [items]=\"virtualdata\"\n                                (vsStart)=\"onScrollEnd($event)\" (vsEnd)=\"onScrollEnd($event)\"\n                                [ngStyle]=\"{'height': settings.maxHeight+'px'}\" class=\"lazyContainer\">\n                                <li *ngFor=\"let item of scroll.viewPortItems; let i = index;\"\n                                    (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\"\n                                    [ngClass]=\"{'selected-item': isSelected(item) == true }\">\n                                    <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\"\n                                        [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                    <label>{{item[settings.labelKey]}}</label>\n                                </li>\n                            </ul>\n                        </div>\n                        <div *ngIf=\"!settings.groupBy && !settings.lazyLoading && itemTempl != undefined\"\n                            [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                            <ul class=\"lazyContainer\">\n                                <li *ngFor=\"let item of data | listFilter:filter : settings.searchBy; let i = index;\"\n                                    (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\"\n                                    [ngClass]=\"{'selected-item': isSelected(item) == true }\">\n                                    <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\"\n                                        [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                    <label></label>\n                                    <c-templateRenderer [data]=\"itemTempl\" [item]=\"item\"></c-templateRenderer>\n                                </li>\n                            </ul>\n                        </div>\n                        <div *ngIf=\"!settings.groupBy && settings.lazyLoading && itemTempl != undefined\"\n                            [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                            <ul virtualScroller #scroll2 [enableUnequalChildrenSizes]=\"randomSize\" [items]=\"virtualdata\"\n                                (vsStart)=\"onScrollEnd($event)\" (vsEnd)=\"onScrollEnd($event)\" class=\"lazyContainer\"\n                                [ngStyle]=\"{'height': settings.maxHeight+'px'}\">\n                                <li *ngFor=\"let item of scroll2.viewPortItems; let i = index;\"\n                                    (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\"\n                                    [ngClass]=\"{'selected-item': isSelected(item) == true }\">\n                                    <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\"\n                                        [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                    <label></label>\n                                    <c-templateRenderer [data]=\"itemTempl\" [item]=\"item\"></c-templateRenderer>\n                                </li>\n                            </ul>\n                        </div>\n                        <div *ngIf=\"settings.groupBy && settings.lazyLoading && itemTempl != undefined\"\n                            [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                            <ul virtualScroller #scroll3 [enableUnequalChildrenSizes]=\"randomSize\" [items]=\"virtualdata\"\n                                (vsStart)=\"onScrollEnd($event)\" (vsEnd)=\"onScrollEnd($event)\"\n                                [ngStyle]=\"{'height': settings.maxHeight+'px'}\" class=\"lazyContainer\">\n                                <span *ngFor=\"let item of scroll3.viewPortItems; let i = index;\">\n                                    <li (click)=\"onItemClick(item,i,$event)\" *ngIf=\"!item.grpTitle\"\n                                        [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle && !settings.singleSelection}\"\n                                        class=\"pure-checkbox\">\n                                        <input *ngIf=\"settings.showCheckbox && !settings.singleSelection\"\n                                            type=\"checkbox\" [checked]=\"isSelected(item)\"\n                                            [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                        <label></label>\n                                        <c-templateRenderer [data]=\"itemTempl\" [item]=\"item\"></c-templateRenderer>\n                                    </li>\n                                    <li *ngIf=\"item.grpTitle\"\n                                        [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle && !settings.singleSelection}\"\n                                        class=\"pure-checkbox\">\n                                        <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\"\n                                            [checked]=\"isSelected(item)\"\n                                            [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                        <label></label>\n                                        <c-templateRenderer [data]=\"itemTempl\" [item]=\"item\"></c-templateRenderer>\n                                    </li>\n                                </span>\n                            </ul>\n                        </div>\n                        <div *ngIf=\"settings.groupBy && !settings.lazyLoading && itemTempl != undefined\"\n                            [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                            <ul class=\"lazyContainer\">\n                                <span *ngFor=\"let item of groupedData; let i = index;\">\n                                    <li (click)=\"selectGroup(item)\"\n                                        [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle && !settings.singleSelection}\"\n                                        class=\"pure-checkbox\">\n                                        <input *ngIf=\"settings.showCheckbox && !settings.singleSelection\"\n                                            type=\"checkbox\" [checked]=\"item.selected\"\n                                            [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                        <label>{{item[settings.labelKey]}}</label>\n                                        <ul class=\"lazyContainer\">\n                                            <span *ngFor=\"let val of item.list ; let j = index;\">\n                                                <li (click)=\"onItemClick(val,j,$event); $event.stopPropagation()\"\n                                                    [ngClass]=\"{'grp-title': val.grpTitle,'grp-item': !val.grpTitle && !settings.singleSelection}\"\n                                                    class=\"pure-checkbox\">\n                                                    <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\"\n                                                        [checked]=\"isSelected(val)\"\n                                                        [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(val)) || val.disabled\" />\n                                                    <label></label>\n                                                    <c-templateRenderer [data]=\"itemTempl\" [item]=\"val\">\n                                                    </c-templateRenderer>\n                                                </li>\n                                            </span>\n                                        </ul>\n                                    </li>\n                                </span>\n                            </ul>\n                        </div>\n                        <div *ngIf=\"settings.groupBy && settings.lazyLoading && itemTempl == undefined\"\n                            [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                            <virtual-scroller [items]=\"groupedData\" (vsUpdate)=\"viewPortItems = $event\"\n                                (vsEnd)=\"onScrollEnd($event)\" [ngStyle]=\"{'height': settings.maxHeight+'px'}\">\n                                <ul virtualScroller #scroll4 [enableUnequalChildrenSizes]=\"randomSize\"\n                                    [items]=\"virtualdata\" (vsStart)=\"onScrollEnd($event)\" (vsEnd)=\"onScrollEnd($event)\"\n                                    [ngStyle]=\"{'height': settings.maxHeight+'px'}\" class=\"lazyContainer\">\n                                    <span *ngFor=\"let item of scroll4.viewPortItems; let i = index;\">\n                                        <li *ngIf=\"item.grpTitle\"\n                                            [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle && !settings.singleSelection, 'selected-item': isSelected(item) == true }\"\n                                            class=\"pure-checkbox\">\n                                            <input\n                                                *ngIf=\"settings.showCheckbox && !item.grpTitle && !settings.singleSelection\"\n                                                type=\"checkbox\" [checked]=\"isSelected(item)\"\n                                                [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                            <label>{{item[settings.labelKey]}}</label>\n                                        </li>\n                                        <li (click)=\"onItemClick(item,i,$event)\" *ngIf=\"!item.grpTitle\"\n                                            [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle && !settings.singleSelection, 'selected-item': isSelected(item) == true }\"\n                                            class=\"pure-checkbox\">\n                                            <input *ngIf=\"settings.showCheckbox && !item.grpTitle\" type=\"checkbox\"\n                                                [checked]=\"isSelected(item)\"\n                                                [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                            <label>{{item[settings.labelKey]}}</label>\n                                        </li>\n                                    </span>\n                                </ul>\n                            </virtual-scroller>\n                        </div>\n                        <div *ngIf=\"settings.groupBy && !settings.lazyLoading && itemTempl == undefined\"\n                            [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                            <ul class=\"lazyContainer\">\n                                <span *ngFor=\"let item of groupedData ; let i = index;\">\n                                    <li (click)=\"selectGroup(item)\"\n                                        [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle && !settings.singleSelection}\"\n                                        class=\"pure-checkbox\">\n                                        <input *ngIf=\"settings.showCheckbox && !settings.singleSelection\"\n                                            type=\"checkbox\" [checked]=\"item.selected\"\n                                            [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(item)) || item.disabled\" />\n                                        <label>{{item[settings.labelKey]}}</label>\n                                        <ul class=\"lazyContainer\">\n                                            <span *ngFor=\"let val of item.list ; let j = index;\">\n                                                <li (click)=\"onItemClick(val,j,$event); $event.stopPropagation()\"\n                                                    [ngClass]=\"{'selected-item': isSelected(val) == true,'grp-title': val.grpTitle,'grp-item': !val.grpTitle && !settings.singleSelection}\"\n                                                    class=\"pure-checkbox\">\n                                                    <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\"\n                                                        [checked]=\"isSelected(val)\"\n                                                        [disabled]=\"(settings.limitSelection == selectedItems?.length && !isSelected(val)) || val.disabled\" />\n                                                    <label>{{val[settings.labelKey]}}</label>\n                                                </li>\n                                            </span>\n                                        </ul>\n                                    </li>\n                                </span>\n                                <!-- <span *ngFor=\"let item of groupedData ; let i = index;\">\n                            <li (click)=\"onItemClick(item,i,$event)\" *ngIf=\"!item.grpTitle\" [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle}\" class=\"pure-checkbox\">\n                            <input *ngIf=\"settings.showCheckbox && !item.grpTitle\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"\n                            />\n                            <label>{{item[settings.labelKey]}}</label>\n                        </li>\n                        <li *ngIf=\"item.grpTitle && !settings.selectGroup\" [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle}\" class=\"pure-checkbox\">\n                            <input *ngIf=\"settings.showCheckbox && settings.selectGroup\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"\n                            />\n                            <label>{{item[settings.labelKey]}}</label>\n                        </li>\n                        <li  (click)=\"selectGroup(item)\" *ngIf=\"item.grpTitle && settings.selectGroup\" [ngClass]=\"{'grp-title': item.grpTitle,'grp-item': !item.grpTitle}\" class=\"pure-checkbox\">\n                            <input *ngIf=\"settings.showCheckbox && settings.selectGroup\" type=\"checkbox\" [checked]=\"item.selected\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"\n                            />\n                            <label>{{item[settings.labelKey]}}</label>\n                        </li>\n                        </span> -->\n                            </ul>\n                        </div>\n                        <h5 class=\"list-message\" *ngIf=\"data?.length == 0\">{{settings.noDataLabel}}</h5>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: ["app-multiselect-dropdown .form-field-input{height:2rem!important;align-items:center}virtual-scroll{display:block;width:100%}.cuppa-dropdown{position:relative;flex-grow:1}.cuppa-dropdown ::focus{outline:none}.cuppa-dropdown .selected-item{background-color:transparent;margin:0}.c-btn{background-color:transparent;border:none;display:inline-block;line-height:1.25;border-radius:3px;font-size:.85rem;padding:5px 10px;cursor:pointer;align-items:center;min-height:38px}.c-btn:focus{outline:none}.c-btn.disabled{background:#ccc}.selected-list .c-list{float:left;padding:0;margin:0;width:calc(100% - 20px)}.selected-list .c-list .c-token{list-style:none;padding:4px 22px 4px 8px;border-radius:2px;margin-right:4px;margin-top:2px;float:left;position:relative}.selected-list .c-list .c-token .c-label{display:block;float:left}.selected-list .c-list .c-token .c-remove{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:8px}.selected-list .c-list .c-token .c-remove svg{fill:#fff}.selected-list .fa-angle-down,.selected-list .fa-angle-up{font-size:15pt;position:absolute;right:10px;top:50%;transform:translateY(-50%)}.selected-list .c-angle-down,.selected-list .c-angle-up{width:12px;height:12px;position:absolute;right:10px;top:50%;transform:translateY(-50%);pointer-events:none}.selected-list .c-angle-down svg,.selected-list .c-angle-up svg{fill:#333}.selected-list .countplaceholder{position:absolute;right:45px;top:50%;transform:translateY(-50%)}.selected-list .c-btn{width:100%;padding:5px 0;cursor:pointer;display:flex;position:relative}.selected-list .c-btn .c-icon{position:absolute;right:5px;top:50%;transform:translateY(-50%)}.dropdown-list{position:absolute;padding-top:14px;width:100%;z-index:99999}.dropdown-list ul{padding:0;list-style:none;overflow:auto;margin:0}.dropdown-list ul li{padding:10px;cursor:pointer;text-align:left}.dropdown-list ul li:first-child{padding-top:10px}.dropdown-list ul li:last-child{padding-bottom:10px}.dropdown-list::-webkit-scrollbar{width:8px}.dropdown-list::-webkit-scrollbar-thumb{background:#ccc;border-radius:5px}.dropdown-list::-webkit-scrollbar-track{background:#f2f2f2}.arrow-down,.arrow-up{width:0;height:0;border-left:13px solid transparent;border-right:13px solid transparent;border-bottom:15px solid #fff;margin-left:15px;position:absolute;top:0}.arrow-down{bottom:-14px;top:unset;transform:rotate(180deg)}.arrow-2{border-bottom:15px solid #ccc;top:-1px}.arrow-down.arrow-2{top:unset;bottom:-16px}.list-area{border:1px solid #ccc;border-radius:3px;background:#fff;margin:0}.select-all{padding:10px;border-bottom:1px solid #ccc;text-align:left}.list-filter{border-bottom:1px solid #ccc;position:relative;padding-left:35px;height:35px}.list-filter input{border:0;width:100%;height:100%;padding:0}.list-filter input:focus{outline:0}.list-filter .c-search{position:absolute;top:9px;left:10px;width:15px;height:15px}.list-filter .c-search svg{fill:#888}.list-filter .c-clear{position:absolute;top:10px;right:10px;width:15px;height:15px}.list-filter .c-clear svg{fill:#888}.pure-checkbox input[type=checkbox]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.pure-checkbox input[type=checkbox] label{font-weight:400}.pure-checkbox input[type=checkbox]:focus+label:before,.pure-checkbox input[type=checkbox]:hover+label:before{background-color:#f2f2f2}.pure-checkbox input[type=checkbox]:active+label:before{transition-duration:0s}.pure-checkbox input[type=checkbox]:disabled+label{color:#ccc}.pure-checkbox input[type=checkbox]+label{position:relative;padding-left:2em;vertical-align:middle;-webkit-user-select:none;user-select:none;cursor:pointer;margin:0;font-weight:300}.pure-checkbox input[type=checkbox]+label:before{box-sizing:content-box;content:\"\";position:absolute;top:50%;left:0;width:15px;height:15px;margin-top:-9px;text-align:center;transition:.4s;border-radius:3px}.pure-checkbox input[type=checkbox]+label:after{box-sizing:content-box;content:\"\";position:absolute;transform:scale(0);transform-origin:50%;transition:transform .2s ease-out;background-color:transparent;top:50%;left:3px;width:9px;height:4px;margin-top:-5px;border-style:solid;border-width:0 0 2px 2px;border-image:none;transform:rotate(-45deg) scale(0)}.theme-default .pure-checkbox input[type=checkbox]+label:after{border-color:var(--default-primary)}.theme-x-pick .pure-checkbox input[type=checkbox]+label:after{border-color:var(--xpick-primary)}.theme-ai-studio .pure-checkbox input[type=checkbox]+label:after{border-color:var(--aistudio-primary)}.theme-frontline-creator .pure-checkbox input[type=checkbox]+label:after{border-color:var(--creator-primary)}.theme-x-make .pure-checkbox input[type=checkbox]+label:after{border-color:var(--xmake-primary)}.theme-spatial .pure-checkbox input[type=checkbox]+label:after{border-color:var(--spatial-primary)}.theme-admin .pure-checkbox input[type=checkbox]+label:after{border-color:var(--admin-secondary)}.theme-x-assist .pure-checkbox input[type=checkbox]+label:after{border-color:var(--xassist-secondary)}.theme-x-inspect .pure-checkbox input[type=checkbox]+label:after{border-color:var(--xinspect-primary)}.pure-checkbox input[type=checkbox]:disabled+label:before{border-color:#ccc}.pure-checkbox input[type=checkbox]:disabled:focus+label:before .pure-checkbox input[type=checkbox]:disabled:hover+label:before{background-color:inherit}.pure-checkbox input[type=checkbox]:disabled:checked+label:before{background-color:#ccc}.pure-checkbox input[type=radio]:checked+label:before{background-color:#fff}.pure-checkbox input[type=radio]:checked+label:after{transform:scale(1)}.pure-checkbox input[type=radio]+label:before{border-radius:50%}.pure-checkbox input[type=checkbox]:checked+label:after{content:\"\";transition:transform .2s ease-out;transform:rotate(-45deg) scale(1)}.list-message{text-align:center;margin:0;padding:15px 0;font-size:initial}.list-grp{padding:0 15px!important}.list-grp h4{text-transform:capitalize;margin:15px 0 0;font-size:14px;font-weight:700}.list-grp>li{padding-left:15px!important}.grp-item{padding-left:30px!important}.grp-title{padding-bottom:0!important}.grp-title label{margin-bottom:0!important;font-weight:800;text-transform:capitalize}.grp-title:hover{background:0 0!important}.loading-icon{width:20px;position:absolute;right:10px;top:23px;z-index:1}.nodata-label{width:100%;text-align:center;padding:10px 0 0}.btn-container{text-align:center;padding:0 5px 10px}.clear-all{width:8px;position:absolute;top:50%;right:30px;transform:translateY(-50%)}\n"] }]
    }], null, { label: [{
            type: Input
        }] }); })();

class MultiselectDropdownModule {
}
MultiselectDropdownModule.ɵfac = function MultiselectDropdownModule_Factory(t) { return new (t || MultiselectDropdownModule)(); };
MultiselectDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MultiselectDropdownModule });
MultiselectDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ClickOutsideModule,
        AngularMultiSelectModule,
        FormsModule,
        VirtualScrollerModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiselectDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MultiselectDropdownComponent,
                ],
                exports: [
                    MultiselectDropdownComponent,
                ],
                imports: [
                    CommonModule,
                    ClickOutsideModule,
                    AngularMultiSelectModule,
                    FormsModule,
                    VirtualScrollerModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MultiselectDropdownModule, { declarations: [MultiselectDropdownComponent], imports: [CommonModule,
        ClickOutsideModule,
        AngularMultiSelectModule,
        FormsModule,
        VirtualScrollerModule], exports: [MultiselectDropdownComponent] }); })();

function FileUploadButtonComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "i", 6);
    i0.ɵɵlistener("click", function FileUploadButtonComponent_div_4_div_1_Template_i_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const file_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.removeFile(file_r2)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const file_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(file_r2.name);
} }
function FileUploadButtonComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FileUploadButtonComponent_div_4_div_1_Template, 4, 1, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.files)("ngForTrackBy", ctx_r0.trackByName);
} }
const _c0$7 = function (a0, a1, a2) { return { "button-secondary": a0, "button-primary": a1, "disabled": a2 }; };
class FileUploadButtonComponent {
    constructor() {
        this.multiple = false;
        this.inputClass = '';
        this.accept = '';
        this.noBorder = false;
        this.disabled = false;
        this.onSelect = new EventEmitter();
        this.files = [];
    }
    ngOnInit() {
        this.buttonText = this.buttonText === undefined ? 'Custom upload' : this.buttonText;
        if (this.multiple) {
            document.getElementById('file-upload')?.setAttribute("multiple", "multiple");
        }
        this.showFiles = this.showFiles === undefined ? true : this.showFiles;
    }
    updateFiles(event) {
        this.files = Array.from(event.target.files);
        this.onSelect.emit(this.files);
        event.target.value = '';
    }
    /**
     * Removes the given file from the file list.
     * @param {File} selectedFile
     */
    removeFile(selectedFile) {
        this.files = Array.from(this.files).filter(item => item.name !== selectedFile.name);
        // And remove it also from the DOM element:
        // This solution doesn't really support multiple files either.
        /* (<HTMLInputElement> this.$element[0].children.namedItem('file-upload')).value = ''; */
    }
    trackByName(i, el) {
        return el.name;
    }
}
FileUploadButtonComponent.ɵfac = function FileUploadButtonComponent_Factory(t) { return new (t || FileUploadButtonComponent)(); };
FileUploadButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FileUploadButtonComponent, selectors: [["file-upload-button"]], inputs: { buttonText: "buttonText", multiple: "multiple", showFiles: "showFiles", inputClass: "inputClass", accept: "accept", noBorder: "noBorder", disabled: "disabled" }, outputs: { onSelect: "onSelect" }, decls: 5, vars: 12, consts: [["id", "file-upload-label", "for", "file-upload", 3, "ngClass"], ["id", "file-icon", 1, "icon", "icon-upload-solid"], ["id", "file-upload", "type", "file", "file-input", "files", 3, "disabled", "accept", "change"], [4, "ngIf"], ["class", "files-to-upload", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "files-to-upload"], [1, "icon", "icon-cross-thin", 3, "click"]], template: function FileUploadButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "label", 0);
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 2);
        i0.ɵɵlistener("change", function FileUploadButtonComponent_Template_input_change_3_listener($event) { return ctx.updateFiles($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, FileUploadButtonComponent_div_4_Template, 2, 2, "div", 3);
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("file-upload-button ", ctx.inputClass, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(8, _c0$7, ctx.noBorder, !ctx.noBorder, ctx.disabled));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.buttonText, "\n");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabled)("accept", ctx.accept);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showFiles);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf], styles: ["#file-icon[_ngcontent-%COMP%]{transform:translateY(-1px);font-size:18px}#file-upload-label[_ngcontent-%COMP%]{font-family:Arial}.disabled[_ngcontent-%COMP%]{opacity:.5;cursor:not-allowed}.disabled[_ngcontent-%COMP%]:hover{border-bottom:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadButtonComponent, [{
        type: Component,
        args: [{ selector: 'file-upload-button', template: "<label id=\"file-upload-label\" for=\"file-upload\" class=\"file-upload-button {{inputClass}}\"\n       [ngClass]=\"{ 'button-secondary': noBorder, 'button-primary': !noBorder, 'disabled': disabled }\">\n    <i id=\"file-icon\" class=\"icon icon-upload-solid\"></i> {{buttonText}}\n</label>\n<input id=\"file-upload\" type=\"file\"\n\t   [disabled]=\"disabled\"\n       file-input=\"files\"\n       (change)=\"updateFiles($event)\"\n       [accept]=\"accept\"\n/>\n<div *ngIf=\"showFiles\">\n    <div class=\"files-to-upload\" *ngFor=\"let file of files; trackBy: trackByName\">\n        <p>{{file.name}}</p><i class=\"icon icon-cross-thin\" (click)=\"removeFile(file)\"></i>\n    </div>\n</div>\n", styles: ["#file-icon{transform:translateY(-1px);font-size:18px}#file-upload-label{font-family:Arial}.disabled{opacity:.5;cursor:not-allowed}.disabled:hover{border-bottom:none}\n"] }]
    }], null, { buttonText: [{
            type: Input
        }], multiple: [{
            type: Input
        }], showFiles: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], accept: [{
            type: Input
        }], noBorder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], onSelect: [{
            type: Output
        }] }); })();

const _c0$6 = function (a0, a1) { return { "icon-eye": a0, "icon-eye-slash": a1 }; };
function FormFieldTextInputComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 6);
    i0.ɵɵlistener("click", function FormFieldTextInputComponent_i_5_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.togglePassword()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c0$6, ctx_r0.showPassword, !ctx_r0.showPassword));
} }
function FormFieldTextInputComponent_label_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.smallText);
} }
const _c1$3 = function (a0) { return { "form-field-is-disabled": a0 }; };
const _c2$1 = function () { return { standalone: true }; };
class FormFieldTextInputComponent {
    constructor(control) {
        this.control = control;
        this.autoComplete = '';
        this.elementId = '';
        this.focus = false;
        this.isDisabled = false;
        this.label = '';
        this.list = '';
        this.maxlength = '';
        this.minlength = 0;
        this.onNgChange = '';
        this.ngModel = '';
        this.showPassword = false;
        this.type = '';
        this.value = '';
        this.data = '';
        this.required = false;
        this.disabled = false;
        this.errorMessages = new Map();
        this.ngModelChange = new EventEmitter();
        this.onBlurChange = new EventEmitter();
        this.ubxType = '';
        this.onChangeFn = (_) => { };
        this.onTouchedFn = () => { };
        this.ubxType = '';
        this.control && (this.control.valueAccessor = this);
        this.errorMessages.set('required', () => `${this.label} is required.`);
        this.errorMessages.set('minlength', () => `The no. of characters should not be less than ${this.minlength}.`);
        this.errorMessages.set('maxlength', () => `The no. of characters should not be more than ${this.maxlength}.`);
        this.errorMessages.set('email', () => `This is not a valid email address format.`);
        this.errorMessages.set('invalidNumber', () => `This is not a valid Phone Number.`);
        this.errorMessages.set('invalidNumber2', () => `This is not a valid Phone Number 2`);
    }
    get invalid() {
        // return this.control ? this.control.invalid? this.control.invalid : false : true;
        return this.control ? !!this.control.invalid : false;
    }
    get showError() {
        if (!this.control) {
            return false;
        }
        const { dirty, touched } = this.control;
        return this.invalid ? !!(dirty || touched) : false;
    }
    get errors() {
        if (!this.control) {
            return [];
        }
        const { errors } = this.control;
        return errors ? Object.keys(errors).map(key => this.errorMessages.has(key) ? this.errorMessages.get(key)() : errors[key] || key) : [];
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    writeValue(obj) {
        this.data = obj;
    }
    onChange() {
        this.onChangeFn(this.data);
    }
    ngOnInit() {
        // Bindings are now defined
        // Setting default values to some input attributes
        this.ubxType = this.type !== undefined ? this.type : 'text';
        this.value = this.value !== undefined ? this.value : this.ngModel;
        this.autoComplete = this.autoComplete ? this.autoComplete : 'off';
        if (!this.elementId) {
            this.elementId = v4();
        }
    }
    togglePassword() {
        this.showPassword = !this.showPassword;
        this.ubxType = this.showPassword ? 'text' : 'password';
    }
    onBlur() {
        this.onBlurChange.emit(this.data);
        if (this.control.control) {
            this.control.control.markAllAsTouched();
        }
    }
}
FormFieldTextInputComponent.ɵfac = function FormFieldTextInputComponent_Factory(t) { return new (t || FormFieldTextInputComponent)(i0.ɵɵdirectiveInject(NgControl, 10)); };
FormFieldTextInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormFieldTextInputComponent, selectors: [["form-field-text-input"]], inputs: { autoComplete: "autoComplete", elementId: "elementId", focus: "focus", isDisabled: "isDisabled", label: "label", list: "list", maxlength: "maxlength", minlength: "minlength", onNgChange: "onNgChange", ngModel: "ngModel", smallText: "smallText", showPassword: "showPassword", type: "type", value: "value", data: "data", required: "required", disabled: "disabled" }, outputs: { ngModelChange: "ngModelChange", onBlurChange: "onBlurChange" }, decls: 7, vars: 19, consts: [[1, "form-field", 3, "ngClass"], [1, "form-field-control"], [1, "form-field-label", 3, "for"], ["form-field-input", "", 1, "form-field-input", 3, "type", "id", "required", "disabled", "minlength", "maxlength", "maxLength", "focus", "ngModel", "ngModelOptions", "ngModelChange", "input", "change", "blur"], ["class", "icon input-field-icon", 3, "ngClass", "click", 4, "ngIf"], ["class", "small-text", 4, "ngIf"], [1, "icon", "input-field-icon", 3, "ngClass", "click"], [1, "small-text"]], template: function FormFieldTextInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 3);
        i0.ɵɵlistener("ngModelChange", function FormFieldTextInputComponent_Template_input_ngModelChange_4_listener($event) { return ctx.data = $event; })("input", function FormFieldTextInputComponent_Template_input_input_4_listener() { return ctx.onChange(); })("change", function FormFieldTextInputComponent_Template_input_change_4_listener() { return ctx.onChange(); })("blur", function FormFieldTextInputComponent_Template_input_blur_4_listener() { return ctx.onBlur(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, FormFieldTextInputComponent_i_5_Template, 1, 4, "i", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, FormFieldTextInputComponent_label_6_Template, 2, 1, "label", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c1$3, ctx.isDisabled));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", ctx.elementId);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("type", ctx.ubxType)("id", ctx.elementId)("required", ctx.required)("disabled", ctx.disabled)("minlength", ctx.minlength)("maxlength", ctx.maxlength)("maxLength", ctx.maxlength)("focus", ctx.focus)("ngModel", ctx.data)("ngModelOptions", i0.ɵɵpureFunction0(18, _c2$1));
        i0.ɵɵattribute("cy-data", ctx.elementId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.type === "password");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.smallText);
    } }, dependencies: [i1.NgClass, i1.NgIf, FormFieldInputDirective, i3.DefaultValueAccessor, i3.NgControlStatus, i3.RequiredValidator, i3.MinLengthValidator, i3.MaxLengthValidator, i3.NgModel], styles: ["[highlight][_ngcontent-%COMP%]{background:green;color:#fff}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldTextInputComponent, [{
        type: Component,
        args: [{ selector: 'form-field-text-input', template: "<div class=\"form-field\" [ngClass]=\"{ 'form-field-is-disabled': isDisabled }\">\n    <div class=\"form-field-control\">\n        <label [for]=\"elementId\" class=\"form-field-label\">\n            {{label}}\n        </label>\n        <input\n            form-field-input\n            class=\"form-field-input\"\n            [type]=\"ubxType\"\n            [id]=\"elementId\"\n            [required]=\"required\"\n            [disabled]=\"disabled\"\n            [minlength]=\"minlength\"\n\t\t\t[maxlength]=\"maxlength\"\n\t\t\t[maxLength]=\"maxlength\"\n\t\t\t[attr.cy-data]=\"elementId\"\n\t\t\t[focus]=\"focus\"\n            [(ngModel)]=\"data\"\n            [ngModelOptions]=\"{standalone: true}\"\n            (input)=\"onChange()\"\n            (change)=\"onChange()\"\n            (blur)=\"onBlur()\"\n        />\n\n        <i *ngIf=\"type === 'password'\"\n           class=\"icon input-field-icon\"\n           (click)=\"togglePassword()\"\n           [ngClass]=\"{ 'icon-eye': showPassword, 'icon-eye-slash': !showPassword }\">\n\t\t</i>\n    </div>\n    <label class=\"small-text\" *ngIf=\"smallText\">{{smallText}}</label>\n</div>\n", styles: ["[highlight]{background:green;color:#fff}\n"] }]
    }], function () { return [{ type: i3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }, {
                type: Inject,
                args: [NgControl]
            }] }]; }, { autoComplete: [{
            type: Input
        }], elementId: [{
            type: Input
        }], focus: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], label: [{
            type: Input
        }], list: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], minlength: [{
            type: Input
        }], onNgChange: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], smallText: [{
            type: Input
        }], showPassword: [{
            type: Input
        }], type: [{
            type: Input
        }], value: [{
            type: Input
        }], data: [{
            type: Input
        }], required: [{
            type: Input
        }], disabled: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onBlurChange: [{
            type: Output
        }] }); })();

const _c0$5 = ["page-header", ""];
function PageHeaderComponent_ng_container_5_ng_container_1_button_secondary_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button-secondary", 10);
    i0.ɵɵlistener("click", function PageHeaderComponent_ng_container_5_ng_container_1_button_secondary_1_Template_button_secondary_click_0_listener($event) { i0.ɵɵrestoreView(_r10); const button_r3 = i0.ɵɵnextContext(2).$implicit; button_r3.click($event); return i0.ɵɵresetView(button_r3.metrics && button_r3.metrics()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("icon", "icon icon-", button_r3.icon, "");
    i0.ɵɵproperty("text", button_r3.text)("id", button_r3.id)("disabled", button_r3.disabled)("ngbTooltip", button_r3.tooltip);
} }
function PageHeaderComponent_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageHeaderComponent_ng_container_5_ng_container_1_button_secondary_1_Template, 1, 5, "button-secondary", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r3.ngIf == null ? true : button_r3.ngIf);
} }
function PageHeaderComponent_ng_container_5_ng_container_2_button_secondary_dropdown_1_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 11);
    i0.ɵɵlistener("click", function PageHeaderComponent_ng_container_5_ng_container_2_button_secondary_dropdown_1_li_2_Template_a_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r17); const dropdownButton_r15 = restoredCtx.$implicit; return i0.ɵɵresetView(dropdownButton_r15.click($event)); });
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const dropdownButton_r15 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("icon icon-", dropdownButton_r15.icon, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dropdownButton_r15.text);
} }
function PageHeaderComponent_ng_container_5_ng_container_2_button_secondary_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button-secondary-dropdown", 10);
    i0.ɵɵlistener("click", function PageHeaderComponent_ng_container_5_ng_container_2_button_secondary_dropdown_1_Template_button_secondary_dropdown_click_0_listener($event) { i0.ɵɵrestoreView(_r20); const button_r3 = i0.ɵɵnextContext(2).$implicit; return i0.ɵɵresetView(button_r3.click($event)); });
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵtemplate(2, PageHeaderComponent_ng_container_5_ng_container_2_button_secondary_dropdown_1_li_2_Template, 5, 4, "li", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("icon", "icon icon-", button_r3.icon, "");
    i0.ɵɵproperty("text", button_r3.text)("id", button_r3.id)("disabled", button_r3.disabled)("ngbTooltip", button_r3.tooltip);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", button_r3.dropdownButtons);
} }
function PageHeaderComponent_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageHeaderComponent_ng_container_5_ng_container_2_button_secondary_dropdown_1_Template, 3, 6, "button-secondary-dropdown", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r3.ngIf == null ? true : button_r3.ngIf);
} }
function PageHeaderComponent_ng_container_5_ng_container_3_file_upload_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "file-upload-button", 13);
    i0.ɵɵlistener("onSelect", function PageHeaderComponent_ng_container_5_ng_container_3_file_upload_button_1_Template_file_upload_button_onSelect_0_listener($event) { i0.ɵɵrestoreView(_r26); const button_r3 = i0.ɵɵnextContext(2).$implicit; button_r3.click($event); return i0.ɵɵresetView(button_r3.metrics && button_r3.metrics()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("multiple", button_r3.multiple)("showFiles", button_r3.showFiles)("noBorder", button_r3.noBorder)("id", button_r3.id)("disabled", button_r3.disabled)("ngbTooltip", button_r3.tooltip)("buttonText", button_r3.text);
} }
function PageHeaderComponent_ng_container_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageHeaderComponent_ng_container_5_ng_container_3_file_upload_button_1_Template, 1, 7, "file-upload-button", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r3.ngIf == null ? true : button_r3.ngIf);
} }
function PageHeaderComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageHeaderComponent_ng_container_5_ng_container_1_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(2, PageHeaderComponent_ng_container_5_ng_container_2_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(3, PageHeaderComponent_ng_container_5_ng_container_3_Template, 2, 1, "ng-container", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r3.type == "DEFAULT");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r3.type == "DROPDOWN");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", button_r3.type == "UPLOAD");
} }
function PageHeaderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "form-field-text-input", 15);
    i0.ɵɵlistener("ngModelChange", function PageHeaderComponent_div_7_Template_form_field_text_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.configuration.searchbar.searchExpression = $event); })("ngModelChange", function PageHeaderComponent_div_7_Template_form_field_text_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); ctx_r31.configuration.searchbar.searchExpression = ctx_r31.configuration.searchbar.searchExpression.trimStart(); return i0.ɵɵresetView(ctx_r31.configuration.searchbar.searchExpressionChangeEvent($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", ctx_r1.configuration.searchbar.label)("elementId", "filter-text-box")("ngModel", ctx_r1.configuration.searchbar.searchExpression);
} }
function PageHeaderComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "dataset-slider", 20);
    i0.ɵɵlistener("valueChange", function PageHeaderComponent_div_8_div_2_Template_dataset_slider_valueChange_1_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.configuration.slider.value = $event); })("onValueUpdate", function PageHeaderComponent_div_8_div_2_Template_dataset_slider_onValueUpdate_1_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.configuration.slider.modelChangeEvent ? ctx_r35.configuration.slider.modelChangeEvent($event) : null); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("min", ctx_r32.configuration.slider.min)("max", ctx_r32.configuration.slider.max)("step", ctx_r32.configuration.slider.step)("value", ctx_r32.configuration.slider.value)("showIcon", ctx_r32.configuration.slider.showIcon)("grid", ctx_r32.configuration.slider.grid);
} }
function PageHeaderComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("clickOutside", function PageHeaderComponent_div_8_Template_div_clickOutside_0_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r36.clickoutside($event)); });
    i0.ɵɵelementStart(1, "button-secondary", 17);
    i0.ɵɵlistener("click", function PageHeaderComponent_div_8_Template_button_secondary_click_1_listener() { i0.ɵɵrestoreView(_r37); const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38.showSlider = !ctx_r38.showSlider); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PageHeaderComponent_div_8_div_2_Template, 2, 6, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r2.configuration.slider.icon ? ctx_r2.configuration.slider.icon : "th-large")("text", ctx_r2.configuration.slider.buttonName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showSlider);
} }
const _c1$2 = [[["", "filterChooserContent", ""]]];
const _c2 = ["[filterChooserContent]"];
class PageHeaderComponent {
    constructor() {
        this.showSlider = false;
    }
    ngOnInit() {
        if (this.configuration.buttons) {
            this.setIconStrings(this.configuration.buttons);
        }
    }
    clickoutside($event) {
        if (this.showSlider) {
            this.showSlider = false;
        }
    }
    setIconStrings(buttons) {
        buttons.forEach((button) => {
            // throw warning if specific actionType and icon are defined at the same time.
            if (["CREATE", "EDIT", "DELETE", "EXPORT"].includes(button.actionType) && button.icon) {
                console.warn(`${button._parent.constructor.name}: The icon "${button.icon}" will be ignored, as you defined the action type as "${button.actionType}". Choose either the actionType "CUSTOM" or remove the icon property. ${button._parent.name}`);
            }
            // define default icons for default actions
            switch (button.actionType) {
                case 'CREATE': {
                    button.icon = "plus-circle-solid";
                    break;
                }
                case 'EDIT': {
                    button.icon = "pen";
                    break;
                }
                case 'DELETE': {
                    button.icon = "times-circle";
                    break;
                }
                case 'EXPORT': {
                    button.icon = "download";
                    break;
                }
            }
        });
    }
}
PageHeaderComponent.ɵfac = function PageHeaderComponent_Factory(t) { return new (t || PageHeaderComponent)(); };
PageHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageHeaderComponent, selectors: [["", "page-header", ""]], hostAttrs: [1, "row", "page-header"], inputs: { configuration: "configuration" }, attrs: _c0$5, ngContentSelectors: _c2, decls: 10, vars: 4, consts: [[1, "col", "col-sm-12"], [1, "headline"], [1, "row", "sub-menu-bar"], [1, "col", "col-sm-7"], [4, "ngFor", "ngForOf"], [1, "col", "col-sm-5", "actions-right"], ["class", "search-input", 4, "ngIf"], ["class", "page-header-slider", 3, "clickOutside", 4, "ngIf"], [4, "ngIf"], [3, "text", "icon", "id", "disabled", "ngbTooltip", "click", 4, "ngIf"], [3, "text", "icon", "id", "disabled", "ngbTooltip", "click"], [3, "click"], [3, "multiple", "showFiles", "noBorder", "id", "disabled", "ngbTooltip", "buttonText", "onSelect", 4, "ngIf"], [3, "multiple", "showFiles", "noBorder", "id", "disabled", "ngbTooltip", "buttonText", "onSelect"], [1, "search-input"], ["type", "text", 3, "label", "elementId", "ngModel", "ngModelChange"], [1, "page-header-slider", 3, "clickOutside"], [3, "icon", "text", "click"], ["class", "slider-wrapper", 4, "ngIf"], [1, "slider-wrapper"], ["ngDefaultControl", "", "id", "configuration.slider.id", 1, "", 3, "min", "max", "step", "value", "showIcon", "grid", "valueChange", "onValueUpdate"]], template: function PageHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c1$2);
        i0.ɵɵelementStart(0, "div", 0)(1, "h1", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "div", 3);
        i0.ɵɵtemplate(5, PageHeaderComponent_ng_container_5_Template, 4, 3, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, PageHeaderComponent_div_7_Template, 2, 3, "div", 6);
        i0.ɵɵtemplate(8, PageHeaderComponent_div_8_Template, 3, 3, "div", 7);
        i0.ɵɵprojection(9);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.configuration.title);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.configuration.buttons);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.configuration.searchbar && (ctx.configuration.searchbar.ngIf == null ? true : ctx.configuration.searchbar.ngIf));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.configuration.slider && (ctx.configuration.slider.ngIf == null ? true : ctx.configuration.slider.ngIf));
    } }, dependencies: [i1.NgForOf, i1.NgIf, ButtonSecondaryComponent, i2$1.NgbTooltip, ButtonSecondaryDropdownComponent, FileUploadButtonComponent, i2.ClickOutsideDirective, DatasetSliderComponent, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, FormFieldTextInputComponent], styles: [".actions-right[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end;gap:5px}.page-header-slider[_ngcontent-%COMP%]{position:relative}.page-header-slider[_ngcontent-%COMP%]   .slider-wrapper[_ngcontent-%COMP%]{position:absolute;right:0;width:300px;top:35px;background-color:#fff;padding:7.5px;border-radius:5px;box-shadow:0 6px 12px #9f9f9f80}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageHeaderComponent, [{
        type: Component,
        args: [{ selector: '[page-header]', host: { 'class': 'row page-header' }, template: "<div class=\"col col-sm-12\">\n    <h1 class=\"headline\">{{ configuration.title }}</h1>\n    <div class=\"row sub-menu-bar\">\n\n        <!--BUTTONS-->\n        <div class=\"col col-sm-7\">\n            <ng-container *ngFor=\"let button of configuration.buttons\" >\n\n                <!--DEFAULT BUTTON-->\n                <ng-container *ngIf=\"button.type == 'DEFAULT'\" >\n                    <button-secondary\n                        [text]=\"button.text\"\n                        *ngIf = \"button.ngIf == null ? true : button.ngIf\"\n                        (click)=\"button.click($event); button.metrics && button.metrics();\"\n                        icon = \"icon icon-{{button.icon}}\"\n                        [id]=\"button.id\"\n                        [disabled] = \"button.disabled\"\n                        [ngbTooltip] = \"button.tooltip\"\n                        >\n                    </button-secondary>\n                </ng-container>\n\n                <!--DROPDOWN BUTTON-->\n                <ng-container *ngIf=\"button.type == 'DROPDOWN'\" >\n                    <button-secondary-dropdown\n                        [text]=\"button.text\"\n                        *ngIf = \"button.ngIf == null ? true : button.ngIf\"\n                        (click)=\"button.click($event)\"\n                        icon = \"icon icon-{{button.icon}}\"\n                        [id]=\"button.id\"\n                        [disabled] = \"button.disabled\"\n                        [ngbTooltip] = \"button.tooltip\"\n                        >\n\n                        <ul>\n                            <li *ngFor=\"let dropdownButton of button.dropdownButtons\" >\n                                <a (click)=\"dropdownButton.click($event)\">\n                                    <i class=\"icon icon-{{dropdownButton.icon}}\"></i>\n                                    <span>{{ dropdownButton.text }}</span>\n                                </a>\n                            </li>\n                        </ul>\n                    </button-secondary-dropdown>\n                </ng-container>\n\n                <!--UPLOAD BUTTON-->\n                <ng-container *ngIf=\"button.type == 'UPLOAD'\" >\n\t\t\t\t\t<file-upload-button\n\t\t\t\t\t\t*ngIf = \"button.ngIf == null ? true : button.ngIf\"\n\t\t\t\t\t\t[multiple]=\"button.multiple\"\n\t\t\t\t\t\t[showFiles]=\"button.showFiles\"\n\t\t\t\t\t\t[noBorder]=\"button.noBorder\"\n\t\t\t\t\t\t[id]=\"button.id\"\n\t\t\t\t\t\t[disabled] = \"button.disabled\"\n\t\t\t\t\t\t[ngbTooltip] = \"button.tooltip\"\n\t\t\t\t\t\t(onSelect)=\"button.click($event); button.metrics && button.metrics()\"\n\t\t\t\t\t\t[buttonText]=\"button.text\">\n\t\t\t\t\t</file-upload-button>\n                </ng-container>\n            </ng-container>\n        </div>\n\n        <div class=\"col col-sm-5 actions-right\">\n            <!-- SEARCH BAR-->\n            <div class=\"search-input\" *ngIf=\"configuration.searchbar && (configuration.searchbar.ngIf == null ? true : configuration.searchbar.ngIf) \">\n\n                <form-field-text-input\n                    [label]=\"configuration.searchbar.label\"\n                    [elementId]=\"'filter-text-box'\"\n                    type=\"text\"\n                    [(ngModel)]=\"configuration.searchbar.searchExpression\"\n                    (ngModelChange)=\"configuration.searchbar.searchExpression = configuration.searchbar.searchExpression.trimStart();\n                    \t\t\t\t configuration.searchbar.searchExpressionChangeEvent($event)\">\n                </form-field-text-input>\n            </div>\n\n            <!-- SLIDER -->\n            <div class=\"page-header-slider\" (clickOutside)=\"clickoutside($event)\" *ngIf=\"configuration.slider && (configuration.slider.ngIf == null ? true : configuration.slider.ngIf)\">\n                <button-secondary\n                    [icon]=\"configuration.slider.icon ? configuration.slider.icon : 'th-large'\"\n                    [text]=\"configuration.slider.buttonName\"\n                    (click)=\"showSlider = !showSlider\">\n                </button-secondary>\n\n                <div class=\"slider-wrapper\" *ngIf=\"showSlider\" >\n                    <dataset-slider\n                        ngDefaultControl\n                        class=\"\"\n                        [min]=\"configuration.slider.min\"\n                        [max]=\"configuration.slider.max\"\n                        [step]=\"configuration.slider.step\"\n                        [(value)]=\"configuration.slider.value\"\n                        id=\"configuration.slider.id\"\n                        (onValueUpdate)=\"configuration.slider.modelChangeEvent ? configuration.slider.modelChangeEvent($event) : null\"\n                        [showIcon]=configuration.slider.showIcon\n                        [grid]=configuration.slider.grid>\n                    </dataset-slider>\n                </div>\n            </div>\n\n\n            <!-- FILTER BUTTON + CUSTOM FILTER MODAL-->\n            <ng-content select=\"[filterChooserContent]\"></ng-content>\n\n\n        </div>\n    </div>\n</div>\n\n", styles: [".actions-right{display:flex;flex-direction:row;justify-content:flex-end;gap:5px}.page-header-slider{position:relative}.page-header-slider .slider-wrapper{position:absolute;right:0;width:300px;top:35px;background-color:#fff;padding:7.5px;border-radius:5px;box-shadow:0 6px 12px #9f9f9f80}\n"] }]
    }], function () { return []; }, { configuration: [{
            type: Input
        }] }); })();

class FormFieldTextInputModule {
}
FormFieldTextInputModule.ɵfac = function FormFieldTextInputModule_Factory(t) { return new (t || FormFieldTextInputModule)(); };
FormFieldTextInputModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormFieldTextInputModule });
FormFieldTextInputModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormFieldInputModule,
        FormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldTextInputModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormFieldTextInputComponent,
                ],
                exports: [
                    FormFieldTextInputComponent,
                ],
                imports: [
                    CommonModule,
                    FormFieldInputModule,
                    FormsModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormFieldTextInputModule, { declarations: [FormFieldTextInputComponent], imports: [CommonModule,
        FormFieldInputModule,
        FormsModule], exports: [FormFieldTextInputComponent] }); })();

class FileUploadButtonModule {
}
FileUploadButtonModule.ɵfac = function FileUploadButtonModule_Factory(t) { return new (t || FileUploadButtonModule)(); };
FileUploadButtonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FileUploadButtonModule });
FileUploadButtonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FileUploadButtonComponent,
                ],
                exports: [
                    FileUploadButtonComponent,
                ],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FileUploadButtonModule, { declarations: [FileUploadButtonComponent], imports: [CommonModule], exports: [FileUploadButtonComponent] }); })();

class PageHeaderModule {
}
PageHeaderModule.ɵfac = function PageHeaderModule_Factory(t) { return new (t || PageHeaderModule)(); };
PageHeaderModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PageHeaderModule });
PageHeaderModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ButtonSecondaryModule,
        NgbTooltipModule,
        ButtonSecondaryDropdownModule,
        FileUploadButtonModule,
        ClickOutsideModule,
        DatasetSliderModule,
        FormsModule,
        FormFieldTextInputModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PageHeaderComponent,
                ],
                exports: [
                    PageHeaderComponent,
                ],
                imports: [
                    CommonModule,
                    ButtonSecondaryModule,
                    NgbTooltipModule,
                    ButtonSecondaryDropdownModule,
                    FileUploadButtonModule,
                    ClickOutsideModule,
                    DatasetSliderModule,
                    FormsModule,
                    FormFieldTextInputModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PageHeaderModule, { declarations: [PageHeaderComponent], imports: [CommonModule,
        ButtonSecondaryModule,
        NgbTooltipModule,
        ButtonSecondaryDropdownModule,
        FileUploadButtonModule,
        ClickOutsideModule,
        DatasetSliderModule,
        FormsModule,
        FormFieldTextInputModule], exports: [PageHeaderComponent] }); })();

const _c0$4 = function () { return { standalone: true }; };
class FormFieldTextareaComponent {
    constructor(control) {
        this.control = control;
        this.autoComplete = '';
        this.elementId = '';
        this.maxRows = 10;
        this.maxLength = 10;
        this.focus = false;
        this.isDisabled = false;
        this.label = '';
        this.onNgChange = '';
        this.ngModel = '';
        this.type = '';
        this.data = '';
        this.placeholder = '';
        this.required = false;
        this.disabled = false;
        this.xOnly = false;
        this.yOnly = false;
        this.resizeTextArea = true;
        this.rows = 1;
        this.rowHeight = 24;
        this.height = 32;
        this.errorMessages = new Map();
        this.ngModelChange = new EventEmitter();
        this.onBlurChange = new EventEmitter();
        this.style = {};
        this.onChangeFn = (_) => {
        };
        this.onTouchedFn = () => {
        };
        this.control && (this.control.valueAccessor = this);
        this.errorMessages.set('required', () => `${this.label} is required.`);
    }
    get invalid() {
        // return this.control ? this.control.invalid? this.control.invalid : false : true;
        return this.control ? !!this.control.invalid : false;
    }
    get showError() {
        if (!this.control) {
            return false;
        }
        const { dirty, touched } = this.control;
        return this.invalid ? !!(dirty || touched) : false;
    }
    get errors() {
        if (!this.control) {
            return [];
        }
        const { errors } = this.control;
        return errors ? Object.keys(errors).map(key => this.errorMessages.has(key) ? this.errorMessages.get(key)() : errors[key] || key) : [];
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    textAreaAdjust() {
        let element = document.getElementById(this.elementId);
        if (element && (element.scrollHeight > element.clientHeight)) {
            const totalHeight = element.scrollHeight + 10;
            const maxHeight = this.maxRows * this.rowHeight;
            element.style.height = totalHeight > maxHeight ? maxHeight + "px" : totalHeight + "px";
            if (totalHeight > maxHeight) {
                element.style.height = maxHeight + "px";
                element.style.overflowY = "auto";
            }
            else {
                element.style.height = totalHeight + "px";
                element.style.overflowY = "hidden";
            }
        }
    }
    ngOnInit() {
        if (!this.elementId) {
            this.elementId = v4();
        }
        this.maxRows = this.maxRows !== undefined ? this.maxRows : 30;
        this.maxLength = this.maxLength !== undefined ? this.maxLength : 500;
        this.placeholder = this.placeholder !== undefined ? this.placeholder : "Type your message";
        if (this.resizeTextArea) {
            //adjust height
            this.textAreaAdjust();
            this.style['max-height'] = this.maxRows * this.rowHeight + 'px';
            this.style['min-height'] = this.height + 'px';
            this.style['overflow'] = 'hidden';
            this.style['height'] = 'auto';
            if (this.xOnly && !this.yOnly) {
                this.style['resize'] = 'horizontal';
            }
            else if (!this.xOnly && this.yOnly) {
                this.style['resize'] = 'vertical';
            }
        }
        else {
            this.style['resize'] = 'none';
            this.style['height'] = this.rows * this.rowHeight + 5 + 'px';
        }
    }
    onBlur() {
        this.onBlurChange.emit(this.ngModel);
    }
    writeValue(obj) {
        this.ngModel = obj;
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    onChange() {
        this.onChangeFn(this.ngModel);
    }
    resize($event) {
        console.log("XXXXXXXXXXX");
    }
}
FormFieldTextareaComponent.ɵfac = function FormFieldTextareaComponent_Factory(t) { return new (t || FormFieldTextareaComponent)(i0.ɵɵdirectiveInject(NgControl, 10)); };
FormFieldTextareaComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormFieldTextareaComponent, selectors: [["form-field-textarea"]], inputs: { autoComplete: "autoComplete", elementId: "elementId", maxRows: "maxRows", maxLength: "maxLength", focus: "focus", isDisabled: "isDisabled", label: "label", onNgChange: "onNgChange", ngModel: "ngModel", type: "type", value: "value", data: "data", placeholder: "placeholder", required: "required", disabled: "disabled", xOnly: "xOnly", yOnly: "yOnly", resizeTextArea: "resizeTextArea", rows: "rows" }, outputs: { ngModelChange: "ngModelChange", onBlurChange: "onBlurChange" }, decls: 6, vars: 13, consts: [[1, "form-field", "form-field-text-area", "form-field-is-filled"], [1, "form-field-control", "text-area"], [1, "form-field-label", 3, "for"], ["form-field-input", "", "spellcheck", "false", 1, "form-field-input", 3, "disabled", "placeholder", "ngModel", "ngModelOptions", "name", "id", "maxLength", "ngStyle", "rows", "resize", "ngModelChange", "keyup", "input", "change", "blur"]], template: function FormFieldTextareaComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "textarea", 3);
        i0.ɵɵlistener("resize", function FormFieldTextareaComponent_Template_textarea_resize_4_listener($event) { return ctx.resize($event); })("ngModelChange", function FormFieldTextareaComponent_Template_textarea_ngModelChange_4_listener($event) { return ctx.ngModel = $event; })("keyup", function FormFieldTextareaComponent_Template_textarea_keyup_4_listener() { return ctx.textAreaAdjust(); })("input", function FormFieldTextareaComponent_Template_textarea_input_4_listener() { return ctx.onChange(); })("change", function FormFieldTextareaComponent_Template_textarea_change_4_listener() { return ctx.onChange(); })("blur", function FormFieldTextareaComponent_Template_textarea_blur_4_listener() { return ctx.onBlur(); });
        i0.ɵɵtext(5, "        ");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", ctx.elementId);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabled)("placeholder", ctx.placeholder)("ngModel", ctx.ngModel)("ngModelOptions", i0.ɵɵpureFunction0(12, _c0$4))("name", ctx.elementId)("id", ctx.elementId)("maxLength", ctx.maxLength)("ngStyle", ctx.style)("rows", ctx.rows);
        i0.ɵɵattribute("cy-data", ctx.elementId);
    } }, dependencies: [i1.NgStyle, FormFieldInputDirective, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel], styles: ["form-field-textarea{width:100%}form-field-textarea textarea.form-field-input{overflow:hidden;-webkit-appearance:none;appearance:none;background:transparent;border:0;border-bottom:1px solid #CCCCCC;color:#454545;display:block;margin-top:15px;outline:0;width:100%;font-family:Roboto,sans-serif;font-weight:400;font-size:14px;padding:3px 0 0;line-height:1.6;overflow-y:auto;transition:height .1s}form-field-textarea textarea.form-field-input.no-resize{resize:none}form-field-textarea textarea.form-field-input.with-scrollbar{overflow:auto}form-field-textarea .form-field.form-field-text-area .form-field-control .form-field-label,form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,form-field-textarea .form-field.form-field-text-area.open .form-field-label{padding:10px 0 0;transform:translateY(-26px);font-size:11.2px;font-weight:900;color:#454545}.theme-default form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-default form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--default-primary)}.theme-x-pick form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-x-pick form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--xpick-primary)}.theme-ai-studio form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-ai-studio form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--aistudio-primary)}.theme-frontline-creator form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-frontline-creator form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--creator-primary)}.theme-x-make form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-x-make form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--xmake-primary)}.theme-spatial form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-spatial form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--spatial-primary)}.theme-admin form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-admin form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--admin-secondary)}.theme-x-assist form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-x-assist form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--xassist-secondary)}.theme-x-inspect form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-x-inspect form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--xinspect-primary)}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldTextareaComponent, [{
        type: Component,
        args: [{ selector: 'form-field-textarea', encapsulation: ViewEncapsulation.None, template: "<div class=\"form-field form-field-text-area form-field-is-filled\">\n\t<div class=\"form-field-control text-area\">\n\t\t<label [for]=\"elementId\" class=\"form-field-label\">\n\t\t\t{{label}}\n\t\t</label>\n\t\t<textarea [disabled]=\"disabled\"\n\t\t\t\t  form-field-input\n\t\t\t\t  [placeholder]=\"placeholder\"\n\t\t\t\t  class=\"form-field-input\"\n\t\t\t\t  (resize)=\"resize($event)\"\n\t\t\t\t  [(ngModel)]=\"ngModel\"\n\t\t\t\t  [ngModelOptions]=\"{standalone: true}\"\n\t\t\t\t  [name]=\"elementId\"\n\t\t\t\t  [id]=\"elementId\"\n\t\t\t\t  [maxLength]=\"maxLength\"\n\t\t\t\t  (keyup)=\"textAreaAdjust()\"\n\t\t\t\t  (input)=\"onChange()\"\n\t\t\t\t  (change)=\"onChange()\"\n\t\t\t\t  (blur)=\"onBlur()\"\n\t\t\t\t  [attr.cy-data]=\"elementId\"\n\t\t\t\t  [ngStyle]=\"style\"\n\t\t\t\t  [rows]=\"rows\"\n\t\t\t\t  spellcheck=\"false\">\n        </textarea>\n\t</div>\n</div>\n\n", styles: ["form-field-textarea{width:100%}form-field-textarea textarea.form-field-input{overflow:hidden;-webkit-appearance:none;appearance:none;background:transparent;border:0;border-bottom:1px solid #CCCCCC;color:#454545;display:block;margin-top:15px;outline:0;width:100%;font-family:Roboto,sans-serif;font-weight:400;font-size:14px;padding:3px 0 0;line-height:1.6;overflow-y:auto;transition:height .1s}form-field-textarea textarea.form-field-input.no-resize{resize:none}form-field-textarea textarea.form-field-input.with-scrollbar{overflow:auto}form-field-textarea .form-field.form-field-text-area .form-field-control .form-field-label,form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,form-field-textarea .form-field.form-field-text-area.open .form-field-label{padding:10px 0 0;transform:translateY(-26px);font-size:11.2px;font-weight:900;color:#454545}.theme-default form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-default form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--default-primary)}.theme-x-pick form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-x-pick form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--xpick-primary)}.theme-ai-studio form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-ai-studio form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--aistudio-primary)}.theme-frontline-creator form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-frontline-creator form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--creator-primary)}.theme-x-make form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-x-make form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--xmake-primary)}.theme-spatial form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-spatial form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--spatial-primary)}.theme-admin form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-admin form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--admin-secondary)}.theme-x-assist form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-x-assist form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--xassist-secondary)}.theme-x-inspect form-field-textarea .form-field.form-field-text-area.form-field-is-active .form-field-label,.theme-x-inspect form-field-textarea .form-field.form-field-text-area.open .form-field-label{color:var(--xinspect-primary)}\n"] }]
    }], function () { return [{ type: i3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }, {
                type: Inject,
                args: [NgControl]
            }] }]; }, { autoComplete: [{
            type: Input
        }], elementId: [{
            type: Input
        }], maxRows: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], focus: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], label: [{
            type: Input
        }], onNgChange: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], type: [{
            type: Input
        }], value: [{
            type: Input
        }], data: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], required: [{
            type: Input
        }], disabled: [{
            type: Input
        }], xOnly: [{
            type: Input
        }], yOnly: [{
            type: Input
        }], resizeTextArea: [{
            type: Input
        }], rows: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onBlurChange: [{
            type: Output
        }] }); })();

class FormFieldTextareaModule {
}
FormFieldTextareaModule.ɵfac = function FormFieldTextareaModule_Factory(t) { return new (t || FormFieldTextareaModule)(); };
FormFieldTextareaModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FormFieldTextareaModule });
FormFieldTextareaModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormFieldInputModule,
        FormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldTextareaModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormFieldTextareaComponent,
                ],
                exports: [
                    FormFieldTextareaComponent,
                ],
                imports: [
                    CommonModule,
                    FormFieldInputModule,
                    FormsModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FormFieldTextareaModule, { declarations: [FormFieldTextareaComponent], imports: [CommonModule,
        FormFieldInputModule,
        FormsModule], exports: [FormFieldTextareaComponent] }); })();

class TextInputsModule {
}
TextInputsModule.ɵfac = function TextInputsModule_Factory(t) { return new (t || TextInputsModule)(); };
TextInputsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TextInputsModule });
TextInputsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormFieldTextInputModule,
        FormFieldTextareaModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextInputsModule, [{
        type: NgModule,
        args: [{
                exports: [
                    FormFieldTextInputModule,
                    FormFieldTextareaModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TextInputsModule, { exports: [FormFieldTextInputModule,
        FormFieldTextareaModule] }); })();

function SingleEditableTextComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 5)(2, "a", 6);
    i0.ɵɵlistener("click", function SingleEditableTextComponent_div_3_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.acceptEdit(ctx_r2.editableText)); });
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 8);
    i0.ɵɵlistener("click", function SingleEditableTextComponent_div_3_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.cancelEdit(ctx_r4.editableText)); });
    i0.ɵɵelement(5, "i", 9);
    i0.ɵɵelementEnd()()();
} }
function SingleEditableTextComponent_div_4_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("click", function SingleEditableTextComponent_div_4_a_1_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.editText(ctx_r6.editableText)); });
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementEnd();
} }
function SingleEditableTextComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, SingleEditableTextComponent_div_4_a_1_Template, 2, 0, "a", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.canBeEdited);
} }
class SingleEditableTextComponent {
    constructor(element) {
        this.element = element;
        this.text = null;
        this.canBeEdited = false;
        this.editOnClick = false;
        this.maxLength = 255;
        this.textChanged = new EventEmitter();
        this.editableText = { text: "", isEdited: false, originalText: '' };
    }
    ngOnInit() {
        this.editableText.text = this.text ? this.text : "";
    }
    ngOnChanges(changes) {
        if (changes.text) {
            this.text = changes.text.currentValue;
            this.editableText.text = changes.text.currentValue;
        }
        if (changes.canBeEdited !== undefined) {
            this.canBeEdited = changes.canBeEdited.currentValue;
        }
    }
    editText(editableText) {
        editableText.originalText = editableText.text ? editableText.text : "";
        editableText.isEdited = true;
        window.setTimeout(() => {
            this.element.nativeElement.getElementsByTagName("input").item(0).focus();
        }, 100);
    }
    cancelEdit(editableText) {
        editableText.isEdited = false;
        editableText.text = editableText.originalText;
    }
    acceptEdit(editableText) {
        editableText.isEdited = false;
        this.textChanged.next(editableText.text);
    }
    toggleEdit() {
        if (this.editOnClick) {
            this.editText(this.editableText);
        }
    }
}
SingleEditableTextComponent.ɵfac = function SingleEditableTextComponent_Factory(t) { return new (t || SingleEditableTextComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
SingleEditableTextComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleEditableTextComponent, selectors: [["single-editable-text"]], inputs: { text: "text", canBeEdited: "canBeEdited", editOnClick: "editOnClick", label: "label", maxLength: "maxLength" }, outputs: { textChanged: "textChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 6, consts: [[1, "row"], [1, "col", "col-sm-12", "editable-text"], [1, "editable-caption-text", 3, "disabled", "label", "maxlength", "ngModel", "click", "ngModelChange"], ["class", "editable-text-input-buttons", 4, "ngIf"], ["class", "editable-caption-button", 4, "ngIf"], [1, "editable-text-input-buttons"], ["id", "acceptEdit", 3, "click"], [1, "icon", "icon-check"], ["id", "cancelEdit", 3, "click"], [1, "icon", "icon-times"], [1, "editable-caption-button"], ["id", "editText", 3, "click", 4, "ngIf"], ["id", "editText", 3, "click"], [1, "icon", "icon-pen", "editable-caption-buttons"]], template: function SingleEditableTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "form-field-text-input", 2);
        i0.ɵɵlistener("click", function SingleEditableTextComponent_Template_form_field_text_input_click_2_listener() { return ctx.toggleEdit(); })("ngModelChange", function SingleEditableTextComponent_Template_form_field_text_input_ngModelChange_2_listener($event) { return ctx.editableText.text = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, SingleEditableTextComponent_div_3_Template, 6, 0, "div", 3);
        i0.ɵɵtemplate(4, SingleEditableTextComponent_div_4_Template, 2, 1, "div", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", !ctx.editableText.isEdited)("label", ctx.label)("maxlength", ctx.maxLength.toString())("ngModel", ctx.editableText.text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.editableText.isEdited);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.editableText.isEdited);
    } }, dependencies: [i1.NgIf, FormFieldTextInputComponent], styles: [".editable-text[_ngcontent-%COMP%]{display:flex}.editable-text[_ngcontent-%COMP%]   .editable-text-label-input[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:95%;font-size:15px;padding-right:10px;flex-grow:1;flex-basis:auto;margin-top:0}.editable-text-input-buttons[_ngcontent-%COMP%]{display:flex}.editable-text-input-buttons[_ngcontent-%COMP%]   .editable-text-input-buttons[_ngcontent-%COMP%]{display:inline-block;align-self:flex-end}.editable-caption-text[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:95%;font-size:15px;padding-right:10px;flex-grow:1;flex-basis:auto}.editable-caption-button[_ngcontent-%COMP%]{padding:3px 5px 0 0;display:flex;height:100%}.editable-caption-button[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;align-self:flex-end}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SingleEditableTextComponent, [{
        type: Component,
        args: [{ selector: 'single-editable-text', template: "<div class=\"row\">\n\t<div class=\"col col-sm-12 editable-text\">\n\t\t<form-field-text-input class=\"editable-caption-text\"\n\t\t\t\t\t\t\t   [disabled]=\"!editableText.isEdited\"\n\t\t\t\t\t\t\t   [label]=\"label\"\n\t\t\t\t\t\t\t   (click)=\"toggleEdit()\"\n\t\t\t\t\t\t\t   [maxlength]=\"maxLength.toString()\"\n\t\t\t\t\t\t\t   [(ngModel)]=\"editableText.text\"></form-field-text-input>\n\n\t\t<div *ngIf=\"editableText.isEdited\"\n\t\t\t class=\"editable-text-input-buttons\">\n\t\t\t<div class=\"editable-text-input-buttons\">\n\t\t\t\t<a (click)=\"acceptEdit(editableText)\" id=\"acceptEdit\"><i class=\"icon icon-check\"></i></a>\n\t\t\t\t<a (click)=\"cancelEdit(editableText)\" id=\"cancelEdit\"><i class=\"icon icon-times\"></i></a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div *ngIf=\"!editableText.isEdited\"\n\t\t\t class=\"editable-caption-button\">\n\t\t\t<a *ngIf=\"canBeEdited\" id=\"editText\" (click)=\"editText(editableText)\"><i class=\"icon icon-pen editable-caption-buttons\"></i></a>\n\t\t</div>\n\t</div>\n</div>\n", styles: [".editable-text{display:flex}.editable-text .editable-text-label-input{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:95%;font-size:15px;padding-right:10px;flex-grow:1;flex-basis:auto;margin-top:0}.editable-text-input-buttons{display:flex}.editable-text-input-buttons .editable-text-input-buttons{display:inline-block;align-self:flex-end}.editable-caption-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:95%;font-size:15px;padding-right:10px;flex-grow:1;flex-basis:auto}.editable-caption-button{padding:3px 5px 0 0;display:flex;height:100%}.editable-caption-button a{display:inline-block;align-self:flex-end}\n"] }]
    }], function () { return [{ type: i0.ElementRef }]; }, { text: [{
            type: Input
        }], canBeEdited: [{
            type: Input
        }], editOnClick: [{
            type: Input
        }], label: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], textChanged: [{
            type: Output
        }] }); })();

class SingleEditableTextModule {
}
SingleEditableTextModule.ɵfac = function SingleEditableTextModule_Factory(t) { return new (t || SingleEditableTextModule)(); };
SingleEditableTextModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SingleEditableTextModule });
SingleEditableTextModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormFieldTextInputModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SingleEditableTextModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SingleEditableTextComponent,
                ],
                exports: [
                    SingleEditableTextComponent,
                ],
                imports: [
                    CommonModule,
                    FormFieldTextInputModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SingleEditableTextModule, { declarations: [SingleEditableTextComponent], imports: [CommonModule,
        FormFieldTextInputModule], exports: [SingleEditableTextComponent] }); })();

function SubMenuItemComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 4);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "icon-" + ctx_r0.icon);
} }
function SubMenuItemComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 5);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.title);
} }
class SubMenuItemComponent {
    constructor() {
        this.title = "";
        this.icon = "";
        this.tooltipText = "";
        this.ngDisabled = false;
        this.onClickEmitter = new EventEmitter();
        this.newItemEvent = new EventEmitter();
        this.newDefaultItem = new EventEmitter();
        this.updateOptionTitle = new EventEmitter();
        this.updateOptionDisabledStatus = new EventEmitter();
        this.updateOptionTooltipText = new EventEmitter();
    }
    ngOnInit() {
        this.newItemEvent.next(this.makeOption());
    }
    makeOption() {
        return {
            title: this.title,
            icon: this.icon,
            ngDisabled: this.ngDisabled,
            tooltipText: this.tooltipText,
            onClick: this.onClick,
            isDefault: false,
            iconTile: null,
            onClickEmitter: this.onClickEmitter
        };
    }
    onButtonClicked() {
        this.newDefaultItem.next({ option: this.makeOption(), isInitial: false });
        this.onClick();
        this.onClickEmitter.next();
    }
    //update option title in parent controller, after translation is loaded
    ngOnChanges(changes) {
        if (changes.givenTitle !== undefined && changes.givenTitle.previousValue !== undefined && changes.givenTitle.currentValue !== undefined) {
            this.updateOptionTitle.next({ oldTitle: changes.givenTitle.previousValue, newTitle: changes.givenTitle.currentValue });
        }
        if (changes.isDisabled !== undefined && changes.isDisabled.previousValue !== undefined && changes.isDisabled.currentValue !== undefined) {
            this.updateOptionDisabledStatus.next({ title: this.title, ngDisabled: changes.isDisabled.currentValue });
        }
        if (changes.tooltipText !== undefined && changes.tooltipText.previousValue !== undefined && changes.tooltipText.currentValue !== undefined) {
            this.updateOptionTooltipText.next({ title: this.title, tooltip: changes.tooltipText.currentValue });
        }
    }
}
SubMenuItemComponent.ɵfac = function SubMenuItemComponent_Factory(t) { return new (t || SubMenuItemComponent)(); };
SubMenuItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SubMenuItemComponent, selectors: [["sub-menu-item"]], inputs: { title: "title", icon: "icon", tooltipText: "tooltipText", ngDisabled: "ngDisabled", onClick: "onClick" }, outputs: { onClickEmitter: "onClickEmitter", newItemEvent: "newItemEvent", newDefaultItem: "newDefaultItem", updateOptionTitle: "updateOptionTitle", updateOptionDisabledStatus: "updateOptionDisabledStatus", updateOptionTooltipText: "updateOptionTooltipText" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 4, consts: [[1, "menu-item"], [3, "disabled", "ngbTooltip", "click"], ["class", "icon", 3, "ngClass", 4, "ngIf"], [3, "textContent", 4, "ngIf"], [1, "icon", 3, "ngClass"], [3, "textContent"]], template: function SubMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function SubMenuItemComponent_Template_button_click_1_listener() { return ctx.onButtonClicked(); });
        i0.ɵɵtemplate(2, SubMenuItemComponent_i_2_Template, 1, 1, "i", 2);
        i0.ɵɵtemplate(3, SubMenuItemComponent_span_3_Template, 1, 1, "span", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.ngDisabled)("ngbTooltip", ctx.tooltipText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.icon);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.title);
    } }, dependencies: [i1.NgClass, i1.NgIf, i2$1.NgbTooltip] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubMenuItemComponent, [{
        type: Component,
        args: [{ selector: 'sub-menu-item', template: "<div class=\"menu-item\">\n    <button (click)=\"onButtonClicked()\"\n            [disabled]=\"ngDisabled\"\n            [ngbTooltip]=\"tooltipText\">\n        <i class=\"icon\" *ngIf=\"icon\" [ngClass]=\"'icon-' + icon\"></i>\n        <span *ngIf=\"title\" [textContent]=\"title\"></span>\n    </button>\n</div>\n" }]
    }], function () { return []; }, { title: [{
            type: Input
        }], icon: [{
            type: Input
        }], tooltipText: [{
            type: Input
        }], ngDisabled: [{
            type: Input
        }], onClick: [{
            type: Input
        }], onClickEmitter: [{
            type: Output
        }], newItemEvent: [{
            type: Output
        }], newDefaultItem: [{
            type: Output
        }], updateOptionTitle: [{
            type: Output
        }], updateOptionDisabledStatus: [{
            type: Output
        }], updateOptionTooltipText: [{
            type: Output
        }] }); })();

class SubMenuItemModule {
}
SubMenuItemModule.ɵfac = function SubMenuItemModule_Factory(t) { return new (t || SubMenuItemModule)(); };
SubMenuItemModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SubMenuItemModule });
SubMenuItemModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        NgbTooltipModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubMenuItemModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SubMenuItemComponent,
                ],
                exports: [
                    SubMenuItemComponent,
                ],
                imports: [
                    CommonModule,
                    NgbTooltipModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SubMenuItemModule, { declarations: [SubMenuItemComponent], imports: [CommonModule,
        NgbTooltipModule], exports: [SubMenuItemComponent] }); })();

function SubMenuItemTileComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "icon-" + ctx_r0.iconTile);
} }
const _c0$3 = ["*"];
class SubMenuItemTileComponent {
    constructor(parent) {
        this.parent = parent;
        this.title = "";
        this.icon = "";
        this.tooltipText = "";
        this.toolTipPlacement = "top";
        this.ngDisabled = false;
        this.onClick = () => { };
        this.onClickEmitter = new EventEmitter();
        this.newItemEvent = new EventEmitter();
        this.newDefaultItem = new EventEmitter();
        this.updateOptionTitle = new EventEmitter();
        this.updateOptionDisabledStatus = new EventEmitter();
        this.updateOptionTooltipText = new EventEmitter();
    }
    ngOnInit() {
        this.newItemEvent.next(this.makeOption());
        this.parent.addOption(this.makeOption());
    }
    makeOption() {
        return {
            title: this.title,
            icon: this.icon,
            ngDisabled: this.ngDisabled,
            tooltipText: this.tooltipText,
            onClick: this.onClick,
            onClickEmitter: this.onClickEmitter,
            isDefault: false,
            iconTile: this.iconTile
        };
    }
    onButtonClicked() {
        this.onClick();
        this.parent.setAsDefault({ option: this.makeOption(), isInitial: true });
        this.onClickEmitter.next();
    }
    //update option title in parent controller, after translation is loaded
    ngOnChanges(changes) {
        if (changes.title !== undefined && changes.title.previousValue !== undefined && changes.title.currentValue !== undefined) {
            this.parent.updateOptionTitle(({ oldTitle: changes.title.previousValue, newTitle: changes.title.currentValue }));
        }
        if (changes.ngDisabled !== undefined && changes.ngDisabled.previousValue !== undefined && changes.ngDisabled.currentValue !== undefined) {
            this.parent.updateOptionDisabledStatus({ title: this.title, ngDisabled: changes.ngDisabled.currentValue });
        }
        if (changes.tooltipText !== undefined && changes.tooltipText.previousValue !== undefined && changes.tooltipText.currentValue !== undefined) {
            this.parent.updateOptionTooltipText({ title: this.title, toolTip: changes.tooltipText.currentValue });
        }
    }
}
SubMenuItemTileComponent.ɵfac = function SubMenuItemTileComponent_Factory(t) { return new (t || SubMenuItemTileComponent)(i0.ɵɵdirectiveInject(MenuItemDropdownComponent)); };
SubMenuItemTileComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SubMenuItemTileComponent, selectors: [["sub-menu-item-tile"]], inputs: { title: "title", icon: "icon", tooltipText: "tooltipText", toolTipPlacement: "toolTipPlacement", ngDisabled: "ngDisabled", onClick: "onClick", iconTile: "iconTile" }, outputs: { onClickEmitter: "onClickEmitter", newItemEvent: "newItemEvent", newDefaultItem: "newDefaultItem", updateOptionTitle: "updateOptionTitle", updateOptionDisabledStatus: "updateOptionDisabledStatus", updateOptionTooltipText: "updateOptionTooltipText" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$3, decls: 7, vars: 5, consts: [[1, "menu-item", "menu-item-tile"], [3, "disabled", "ngbTooltip", "placement", "click"], [3, "textContent"], [1, "menu-item-visual"], ["class", "icon", 3, "ngClass", 4, "ngIf"], [1, "icon", 3, "ngClass"]], template: function SubMenuItemTileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function SubMenuItemTileComponent_Template_button_click_1_listener() { return ctx.onButtonClicked(); });
        i0.ɵɵelement(2, "p", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, SubMenuItemTileComponent_i_4_Template, 1, 1, "i", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div");
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.ngDisabled)("ngbTooltip", ctx.tooltipText)("placement", ctx.toolTipPlacement);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("textContent", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.iconTile !== undefined);
    } }, dependencies: [i1.NgClass, i1.NgIf, i2$1.NgbTooltip] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubMenuItemTileComponent, [{
        type: Component,
        args: [{ selector: 'sub-menu-item-tile', template: "<div class=\"menu-item menu-item-tile\">\n    <button\n            (click)=\"onButtonClicked()\"\n            [disabled]=\"ngDisabled\"\n            [ngbTooltip]=\"tooltipText\"\n            [placement]=\"toolTipPlacement\"\n    >\n        <p [textContent]=\"title\"> </p>\n        <div class=\"menu-item-visual\">\n            <i class=\"icon\" *ngIf=\"iconTile !== undefined\" [ngClass]=\"'icon-' + iconTile\"></i>\n        </div>\n    </button>\n    <div><ng-content></ng-content></div>\n</div>\n" }]
    }], function () { return [{ type: MenuItemDropdownComponent, decorators: [{
                type: Inject,
                args: [MenuItemDropdownComponent]
            }] }]; }, { title: [{
            type: Input
        }], icon: [{
            type: Input
        }], tooltipText: [{
            type: Input
        }], toolTipPlacement: [{
            type: Input
        }], ngDisabled: [{
            type: Input
        }], onClick: [{
            type: Input
        }], onClickEmitter: [{
            type: Output
        }], iconTile: [{
            type: Input
        }], newItemEvent: [{
            type: Output
        }], newDefaultItem: [{
            type: Output
        }], updateOptionTitle: [{
            type: Output
        }], updateOptionDisabledStatus: [{
            type: Output
        }], updateOptionTooltipText: [{
            type: Output
        }] }); })();

class SubMenuItemTileModule {
}
SubMenuItemTileModule.ɵfac = function SubMenuItemTileModule_Factory(t) { return new (t || SubMenuItemTileModule)(); };
SubMenuItemTileModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SubMenuItemTileModule });
SubMenuItemTileModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        NgbTooltipModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubMenuItemTileModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SubMenuItemTileComponent,
                ],
                exports: [
                    SubMenuItemTileComponent,
                ],
                imports: [
                    CommonModule,
                    NgbTooltipModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SubMenuItemTileModule, { declarations: [SubMenuItemTileComponent], imports: [CommonModule,
        NgbTooltipModule], exports: [SubMenuItemTileComponent] }); })();

function TagCellRendererComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngbTooltip", tag_r2)("disableTooltip", tag_r2.length <= 30)("openDelay", 500);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind3(2, 5, tag_r2, 0, 30), "", tag_r2.length > 30 ? "..." : "", " ");
} }
function TagCellRendererComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1, "...");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", ctx_r1.overflowTooltip);
} }
class TagCellRendererComponent {
    constructor(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.customBreakpoint = '(max-width: 1207px)';
        this.tags = [];
        this.overflowTooltip = "";
        this.breakpointObserver.observe([
            this.customBreakpoint
        ]).subscribe((state) => {
            if (state.matches) {
                this.tagsLimit = 1;
            }
            else {
                this.tagsLimit = 2;
            }
        });
    }
    // gets called once before the renderer is used
    agInit(params) {
        if (params.value) {
            this.tags = params.value;
            if (this.tags.length > 2) {
                for (let i = 2; i < this.tags.length; i++) {
                    if (i < this.tags.length - 1) {
                        this.overflowTooltip = this.overflowTooltip.concat(this.tags[i] + ", ");
                    }
                    else {
                        this.overflowTooltip = this.overflowTooltip.concat(this.tags[i]);
                    }
                }
            }
        }
        else {
            this.tags = [];
        }
    }
    // gets called whenever the cell refreshes
    refresh(params) {
        // set value into cell again
        if (params.value) {
            this.tags = params.value;
        }
        else {
            this.tags = [];
        }
        return true;
    }
}
TagCellRendererComponent.ɵfac = function TagCellRendererComponent_Factory(t) { return new (t || TagCellRendererComponent)(i0.ɵɵdirectiveInject(i1$2.BreakpointObserver)); };
TagCellRendererComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TagCellRendererComponent, selectors: [["tag-cell-renderer-component"]], decls: 5, vars: 6, consts: [[1, "tags-wrapper-cell-renderer"], [1, "tags"], ["class", "templateTag", 3, "ngbTooltip", "disableTooltip", "openDelay", 4, "ngFor", "ngForOf"], ["class", "templateTag", "container", "body", 3, "ngbTooltip", 4, "ngIf"], [1, "templateTag", 3, "ngbTooltip", "disableTooltip", "openDelay"], ["container", "body", 1, "templateTag", 3, "ngbTooltip"]], template: function TagCellRendererComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, TagCellRendererComponent_span_2_Template, 3, 9, "span", 2);
        i0.ɵɵpipe(3, "slice");
        i0.ɵɵtemplate(4, TagCellRendererComponent_span_4_Template, 2, 1, "span", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 2, ctx.tags, 0, ctx.tagsLimit));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.tags.length > 2);
    } }, dependencies: [i1.NgForOf, i1.NgIf, i2$1.NgbTooltip, i1.SlicePipe], styles: [".tags-wrapper-cell-renderer[_ngcontent-%COMP%]{min-width:350px;flex-grow:1}.tags-wrapper-cell-renderer[_ngcontent-%COMP%]   .tags[_ngcontent-%COMP%]{padding:0}.tags-wrapper-cell-renderer[_ngcontent-%COMP%]   .tags[_ngcontent-%COMP%]   .templateTag[_ngcontent-%COMP%]{display:inline-block;padding:4px 9px;margin:0 5px 5px 0;border-radius:20px;color:#fff;font-size:12px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagCellRendererComponent, [{
        type: Component,
        args: [{ selector: 'tag-cell-renderer-component', template: `
		<div class="tags-wrapper-cell-renderer">
			<div class="tags">
				<span *ngFor="let tag of tags | slice:0:tagsLimit" class="templateTag" [ngbTooltip]="tag" [disableTooltip]="tag.length <= 30" [openDelay]="500" >
					{{ tag | slice:0:30 }}{{tag.length > 30 ? '...' : '' }}
				</span>
				<span class="templateTag" *ngIf="tags.length > 2" [ngbTooltip]="overflowTooltip" container="body">...</span>
			</div>
		</div>
   `, styles: [".tags-wrapper-cell-renderer{min-width:350px;flex-grow:1}.tags-wrapper-cell-renderer .tags{padding:0}.tags-wrapper-cell-renderer .tags .templateTag{display:inline-block;padding:4px 9px;margin:0 5px 5px 0;border-radius:20px;color:#fff;font-size:12px}\n"] }]
    }], function () { return [{ type: i1$2.BreakpointObserver }]; }, null); })();

class TagCellRendererModule {
}
TagCellRendererModule.ɵfac = function TagCellRendererModule_Factory(t) { return new (t || TagCellRendererModule)(); };
TagCellRendererModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TagCellRendererModule });
TagCellRendererModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        NgbTooltipModule,
        AgGridModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagCellRendererModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TagCellRendererComponent,
                ],
                exports: [
                    TagCellRendererComponent,
                ],
                imports: [
                    CommonModule,
                    NgbTooltipModule,
                    AgGridModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TagCellRendererModule, { declarations: [TagCellRendererComponent], imports: [CommonModule,
        NgbTooltipModule,
        AgGridModule], exports: [TagCellRendererComponent] }); })();

/*
  This is an extension of the ngx-chips module.
  to make use of our custom form-field-control wrapper dom elements
  e.g. Label
*/
function TagsInputComponent_tag_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tag", 9);
    i0.ɵɵlistener("onSelect", function TagsInputComponent_tag_6_Template_tag_onSelect_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const item_r3 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.selectItem(item_r3)); })("onRemove", function TagsInputComponent_tag_6_Template_tag_onRemove_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const item_r3 = restoredCtx.$implicit; const i_r4 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onRemoveRequested(item_r3, i_r4)); })("onKeyDown", function TagsInputComponent_tag_6_Template_tag_onKeyDown_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.handleKeydown($event)); })("onTagEdited", function TagsInputComponent_tag_6_Template_tag_onTagEdited_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.updateEditedTag($event)); })("onBlur", function TagsInputComponent_tag_6_Template_tag_onBlur_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r6); const i_r4 = restoredCtx.index; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onTagBlurred($event, i_r4)); })("dragstart", function TagsInputComponent_tag_6_Template_tag_dragstart_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r6); const item_r3 = restoredCtx.$implicit; const i_r4 = restoredCtx.index; const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.dragZone ? ctx_r11.onDragStarted($event, item_r3, i_r4) : undefined); })("drop", function TagsInputComponent_tag_6_Template_tag_drop_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r6); const i_r4 = restoredCtx.index; const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.dragZone ? ctx_r12.onTagDropped($event, i_r4) : undefined); })("dragenter", function TagsInputComponent_tag_6_Template_tag_dragenter_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.dragZone ? ctx_r13.onDragOver($event) : undefined); })("dragover", function TagsInputComponent_tag_6_Template_tag_dragover_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r6); const i_r4 = restoredCtx.index; const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.dragZone ? ctx_r14.onDragOver($event, i_r4) : undefined); })("dragleave", function TagsInputComponent_tag_6_Template_tag_dragleave_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.dragZone ? ctx_r15.dragProvider.onDragEnd() : undefined); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("draggable", ctx_r0.editable);
    i0.ɵɵproperty("canAddTag", ctx_r0.isTagValid)("disabled", ctx_r0.disable)("@animation", ctx_r0.animationMetadata)("hasRipple", ctx_r0.ripple)("index", i_r4)("removable", ctx_r0.removable)("editable", ctx_r0.editable)("displayBy", ctx_r0.displayBy)("identifyBy", ctx_r0.identifyBy)("template", !!ctx_r0.hasCustomTemplate() ? ctx_r0.templates.first : undefined)("draggable", ctx_r0.dragZone)("model", item_r3);
    i0.ɵɵattribute("tabindex", 0);
} }
function TagsInputComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} }
function TagsInputComponent_div_10_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const error_r17 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(error_r17);
} }
function TagsInputComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, TagsInputComponent_div_10_p_1_Template, 3, 1, "p", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.theme);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.errors);
} }
const _c0$2 = function (a0) { return { "form-field-is-disabled": a0 }; };
const _c1$1 = ["*"];
// all this boilerplate is needed
class TagsInputComponent extends TagInputComponent {
    constructor() {
        super(...arguments);
        this.label = '';
        this.isDisabled = false;
        this.elementId = '';
    }
}
TagsInputComponent.ɵfac = /*@__PURE__*/ function () { let ɵTagsInputComponent_BaseFactory; return function TagsInputComponent_Factory(t) { return (ɵTagsInputComponent_BaseFactory || (ɵTagsInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TagsInputComponent)))(t || TagsInputComponent); }; }();
TagsInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TagsInputComponent, selectors: [["tags-input"]], inputs: { label: "label", isDisabled: "isDisabled", elementId: "elementId" }, features: [i0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TagsInputComponent),
                multi: true
            }]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$1, decls: 12, vars: 32, consts: [[1, "form-field", "form-field-is-filled", 3, "ngClass"], [1, "form-field-control"], [1, "form-field-label", 3, "for"], [1, "ng2-tag-input", 3, "ngClass", "click", "drop", "dragenter", "dragover", "dragend"], [1, "ng2-tags-container"], [3, "draggable", "canAddTag", "disabled", "hasRipple", "index", "removable", "editable", "displayBy", "identifyBy", "template", "model", "onSelect", "onRemove", "onKeyDown", "onTagEdited", "onBlur", "dragstart", "drop", "dragenter", "dragover", "dragleave", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "inputText", "disabled", "validators", "asyncValidators", "hidden", "placeholder", "inputClass", "inputId", "tabindex", "onSubmit", "onBlur", "click", "onKeydown", "onKeyup"], ["class", "progress-bar", 4, "ngIf"], ["class", "error-messages", 3, "ngClass", 4, "ngIf"], [3, "draggable", "canAddTag", "disabled", "hasRipple", "index", "removable", "editable", "displayBy", "identifyBy", "template", "model", "onSelect", "onRemove", "onKeyDown", "onTagEdited", "onBlur", "dragstart", "drop", "dragenter", "dragover", "dragleave"], [1, "progress-bar"], [1, "error-messages", 3, "ngClass"], ["class", "error-message", 4, "ngFor", "ngForOf"], [1, "error-message"]], template: function TagsInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵlistener("click", function TagsInputComponent_Template_div_click_4_listener() { return ctx.focus(true, false); })("drop", function TagsInputComponent_Template_div_drop_4_listener($event) { return ctx.dragZone ? ctx.onTagDropped($event, undefined) : undefined; })("dragenter", function TagsInputComponent_Template_div_dragenter_4_listener($event) { return ctx.dragZone ? ctx.onDragOver($event) : undefined; })("dragover", function TagsInputComponent_Template_div_dragover_4_listener($event) { return ctx.dragZone ? ctx.onDragOver($event) : undefined; })("dragend", function TagsInputComponent_Template_div_dragend_4_listener() { return ctx.dragZone ? ctx.dragProvider.onDragEnd() : undefined; });
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, TagsInputComponent_tag_6_Template, 1, 14, "tag", 5);
        i0.ɵɵelementStart(7, "tag-input-form", 6);
        i0.ɵɵlistener("onSubmit", function TagsInputComponent_Template_tag_input_form_onSubmit_7_listener() { return ctx.onFormSubmit(); })("onBlur", function TagsInputComponent_Template_tag_input_form_onBlur_7_listener() { return ctx.blur(); })("click", function TagsInputComponent_Template_tag_input_form_click_7_listener() { return ctx.dropdown ? ctx.dropdown.show() : undefined; })("onKeydown", function TagsInputComponent_Template_tag_input_form_onKeydown_7_listener($event) { return ctx.fireEvents("keydown", $event); })("onKeyup", function TagsInputComponent_Template_tag_input_form_onKeyup_7_listener($event) { return ctx.fireEvents("keyup", $event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(8, TagsInputComponent_div_8_Template, 1, 0, "div", 7);
        i0.ɵɵpipe(9, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, TagsInputComponent_div_10_Template, 2, 2, "div", 8);
        i0.ɵɵprojection(11);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(30, _c0$2, ctx.isDisabled));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", ctx.elementId);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("ng2-tag-input--dropping", ctx.isDropping())("ng2-tag-input--disabled", ctx.disable)("ng2-tag-input--loading", ctx.isLoading)("ng2-tag-input--invalid", ctx.hasErrors())("ng2-tag-input--focused", ctx.isInputFocused());
        i0.ɵɵproperty("ngClass", ctx.theme);
        i0.ɵɵattribute("tabindex", -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.items)("ngForTrackBy", ctx.trackBy);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("inputText", ctx.inputText)("disabled", ctx.disable)("validators", ctx.validators)("asyncValidators", ctx.asyncValidators)("hidden", ctx.maxItemsReached)("placeholder", ctx.items.length ? ctx.placeholder : ctx.secondaryPlaceholder)("inputClass", ctx.inputClass)("inputId", ctx.inputId)("tabindex", ctx.tabindex);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 28, ctx.isProgressBarVisible$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hasErrors());
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$2.TagInputForm, i2$2.TagComponent, i1.AsyncPipe], data: { animation: [
            trigger('animation', [
                state('in', style({ transform: 'translateX(0)' })),
                transition(':enter', [
                    animate(250, keyframes([
                        style({ opacity: 0, offset: 0, transform: 'translate(0px, 20px)' }),
                        style({ opacity: 0.3, offset: 0.3, transform: 'translate(0px, -10px)' }),
                        style({ opacity: 0.5, offset: 0.5, transform: 'translate(0px, 0px)' }),
                        style({ opacity: 0.75, offset: 0.75, transform: 'translate(0px, 5px)' }),
                        style({ opacity: 1, offset: 1, transform: 'translate(0px, 0px)' })
                    ]))
                ]),
                transition(':leave', [
                    animate(150, keyframes([
                        style({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
                        style({ opacity: 1, transform: 'translateX(-15px)', offset: 0.7 }),
                        style({ opacity: 0, transform: 'translateX(100%)', offset: 1.0 })
                    ]))
                ])
            ])
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagsInputComponent, [{
        type: Component,
        args: [{ selector: 'tags-input', providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TagsInputComponent),
                        multi: true
                    }], animations: [
                    trigger('animation', [
                        state('in', style({ transform: 'translateX(0)' })),
                        transition(':enter', [
                            animate(250, keyframes([
                                style({ opacity: 0, offset: 0, transform: 'translate(0px, 20px)' }),
                                style({ opacity: 0.3, offset: 0.3, transform: 'translate(0px, -10px)' }),
                                style({ opacity: 0.5, offset: 0.5, transform: 'translate(0px, 0px)' }),
                                style({ opacity: 0.75, offset: 0.75, transform: 'translate(0px, 5px)' }),
                                style({ opacity: 1, offset: 1, transform: 'translate(0px, 0px)' })
                            ]))
                        ]),
                        transition(':leave', [
                            animate(150, keyframes([
                                style({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
                                style({ opacity: 1, transform: 'translateX(-15px)', offset: 0.7 }),
                                style({ opacity: 0, transform: 'translateX(100%)', offset: 1.0 })
                            ]))
                        ])
                    ])
                ], template: "<div class=\"form-field form-field-is-filled\" [ngClass]=\"{ 'form-field-is-disabled': isDisabled }\">\n    <div class=\"form-field-control\">\n        <label [for]=\"elementId\" class=\"form-field-label\">\n            {{label}}\n        </label>\n\n        <!-- Following is a copy of the ngx-chips tag-input component template -->\n        <div\n            [ngClass]=\"theme\"\n            class=\"ng2-tag-input\"\n            (click)=\"focus(true, false)\"\n            [attr.tabindex]=\"-1\"\n            (drop)=\"dragZone ? onTagDropped($event, undefined) : undefined\"\n            (dragenter)=\"dragZone ? onDragOver($event) : undefined\"\n            (dragover)=\"dragZone ? onDragOver($event) : undefined\"\n            (dragend)=\"dragZone ? dragProvider.onDragEnd() : undefined\"\n            [class.ng2-tag-input--dropping]=\"isDropping()\"\n            [class.ng2-tag-input--disabled]=\"disable\"\n            [class.ng2-tag-input--loading]=\"isLoading\"\n            [class.ng2-tag-input--invalid]=\"hasErrors()\"\n            [class.ng2-tag-input--focused]=\"isInputFocused()\"\n        >\n            <!-- TAGS -->\n            <div class=\"ng2-tags-container\">\n                <tag\n                    *ngFor=\"let item of items; let i = index; trackBy: trackBy\"\n                    (onSelect)=\"selectItem(item)\"\n                    (onRemove)=\"onRemoveRequested(item, i)\"\n                    (onKeyDown)=\"handleKeydown($event)\"\n                    (onTagEdited)=\"updateEditedTag($event)\"\n                    (onBlur)=\"onTagBlurred($event, i)\"\n                    draggable=\"{{ editable }}\"\n                    (dragstart)=\"dragZone ? onDragStarted($event, item, i) : undefined\"\n                    (drop)=\"dragZone ? onTagDropped($event, i) : undefined\"\n                    (dragenter)=\"dragZone ? onDragOver($event) : undefined\"\n                    (dragover)=\"dragZone ? onDragOver($event, i) : undefined\"\n                    (dragleave)=\"dragZone ? dragProvider.onDragEnd() : undefined\"\n                    [canAddTag]=\"isTagValid\"\n                    [attr.tabindex]=\"0\"\n                    [disabled]=\"disable\"\n                    [@animation]=\"animationMetadata\"\n                    [hasRipple]=\"ripple\"\n                    [index]=\"i\"\n                    [removable]=\"removable\"\n                    [editable]=\"editable\"\n                    [displayBy]=\"displayBy\"\n                    [identifyBy]=\"identifyBy\"\n                    [template]=\"!!hasCustomTemplate() ? templates.first : undefined\"\n                    [draggable]=\"dragZone\"\n                    [model]=\"item\"\n                >\n                </tag>\n                <tag-input-form\n                    (onSubmit)=\"onFormSubmit()\"\n                    (onBlur)=\"blur()\"\n                    (click)=\"dropdown ? dropdown.show() : undefined\"\n                    (onKeydown)=\"fireEvents('keydown', $event)\"\n                    (onKeyup)=\"fireEvents('keyup', $event)\"\n                    [inputText]=\"inputText\"\n                    [disabled]=\"disable\"\n                    [validators]=\"validators\"\n                    [asyncValidators]=\"asyncValidators\"\n                    [hidden]=\"maxItemsReached\"\n                    [placeholder]=\"items.length ? placeholder : secondaryPlaceholder\"\n                    [inputClass]=\"inputClass\"\n                    [inputId]=\"inputId\"\n                    [tabindex]=\"tabindex\"\n                >\n                </tag-input-form>\n            </div>\n            <div\n                class=\"progress-bar\"\n                *ngIf=\"isProgressBarVisible$ | async\"\n            ></div>\n        </div>\n        <!-- ERRORS -->\n        <div\n            *ngIf=\"hasErrors()\"\n            [ngClass]=\"theme\"\n            class=\"error-messages\">\n            <p\n                *ngFor=\"let error of errors\"\n                class=\"error-message\"\n            >\n            <span>{{ error }}</span>\n            </p>\n        </div>\n        <ng-content></ng-content>\n    </div>\n</div>" }]
    }], null, { label: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], elementId: [{
            type: Input
        }] }); })();

class TagsInputModule {
}
TagsInputModule.ɵfac = function TagsInputModule_Factory(t) { return new (t || TagsInputModule)(); };
TagsInputModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TagsInputModule });
TagsInputModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        TagInputModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagsInputModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TagsInputComponent,
                ],
                exports: [
                    TagsInputComponent,
                ],
                imports: [
                    CommonModule,
                    TagInputModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TagsInputModule, { declarations: [TagsInputComponent], imports: [CommonModule,
        TagInputModule], exports: [TagsInputComponent] }); })();

function ToggleSwitchComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", ctx_r0.requiredText)("placement", ctx_r0.placement)("container", ctx_r0.container);
} }
function ToggleSwitchComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 11);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", ctx_r1.tooltip)("placement", ctx_r1.placement)("container", ctx_r1.container);
} }
function ToggleSwitchComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("for", ctx_r2.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.label, " ");
} }
function ToggleSwitchComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.onLabel, "");
} }
function ToggleSwitchComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.offLabel);
} }
function ToggleSwitchComponent_i_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("icon icon-", ctx_r5.icon, "");
} }
const _c0$1 = function (a0, a1) { return { "disabled": a0, "side-by-side": a1 }; };
const _c1 = function (a0, a1) { return { "disabled": a0, "checked": a1 }; };
class ToggleSwitchComponent {
    constructor() {
        this.id = '';
        this.isChecked = false;
        this.isDisabled = false;
        this.label = '';
        this.name = '';
        this.icon = '';
        this.sideBySide = true;
        this.showRequiredText = true;
        this.requiredText = '';
        this.tooltip = '';
        this.onLabel = '';
        this.offLabel = '';
        this.container = 'body';
        this.placement = 'right';
        this.isCheckedChange = new EventEmitter();
    }
    ngOnInit() {
        if (!this.id) {
            this.id = v4();
        }
    }
    onClick() {
        if (!this.isDisabled) {
            this.isChecked = !this.isChecked;
            this.isCheckedChange.emit(this.isChecked);
        }
    }
}
ToggleSwitchComponent.ɵfac = function ToggleSwitchComponent_Factory(t) { return new (t || ToggleSwitchComponent)(); };
ToggleSwitchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToggleSwitchComponent, selectors: [["toggle-switch"]], inputs: { id: "id", isChecked: "isChecked", isDisabled: "isDisabled", label: "label", name: "name", icon: "icon", sideBySide: "sideBySide", showRequiredText: "showRequiredText", requiredText: "requiredText", tooltip: "tooltip", ngModel: "ngModel", onLabel: "onLabel", offLabel: "offLabel", container: "container", placement: "placement" }, outputs: { isCheckedChange: "isCheckedChange" }, features: [i0.ɵɵProvidersFeature([])], decls: 12, vars: 17, consts: [[1, "form-field", "form-toggle", "toggle-switch", 3, "ngClass"], [1, "form-field-control"], ["class", "icon icon-exclamation-circle text-danger", 3, "ngbTooltip", "placement", "container", 4, "ngIf"], ["class", "icon icon-info-circle", "aria-hidden", "true", 3, "ngbTooltip", "placement", "container", 4, "ngIf"], ["class", "form-field-label", 3, "for", 4, "ngIf"], [1, "form-field-input"], [1, "switch", 3, "ngClass", "click"], ["type", "checkbox", 2, "display", "none", 3, "name", "ngModel", "id", "ngModelChange"], ["class", "status-label", 4, "ngIf"], ["style", "padding-right: 10px;", 3, "class", 4, "ngIf"], [1, "icon", "icon-exclamation-circle", "text-danger", 3, "ngbTooltip", "placement", "container"], ["aria-hidden", "true", 1, "icon", "icon-info-circle", 3, "ngbTooltip", "placement", "container"], [1, "form-field-label", 3, "for"], [1, "status-label"], [2, "padding-right", "10px"]], template: function ToggleSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, ToggleSwitchComponent_i_2_Template, 1, 3, "i", 2);
        i0.ɵɵtemplate(3, ToggleSwitchComponent_i_3_Template, 1, 3, "i", 3);
        i0.ɵɵtemplate(4, ToggleSwitchComponent_label_4_Template, 2, 2, "label", 4);
        i0.ɵɵelementStart(5, "div", 5)(6, "span", 6);
        i0.ɵɵlistener("click", function ToggleSwitchComponent_Template_span_click_6_listener() { return ctx.onClick(); });
        i0.ɵɵelement(7, "small");
        i0.ɵɵelementStart(8, "input", 7);
        i0.ɵɵlistener("ngModelChange", function ToggleSwitchComponent_Template_input_ngModelChange_8_listener($event) { return ctx.isChecked = $event; })("ngModelChange", function ToggleSwitchComponent_Template_input_ngModelChange_8_listener() { return ctx.isCheckedChange.emit(ctx.isChecked); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, ToggleSwitchComponent_span_9_Template, 2, 1, "span", 8);
        i0.ɵɵtemplate(10, ToggleSwitchComponent_span_10_Template, 2, 1, "span", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(11, ToggleSwitchComponent_i_11_Template, 1, 3, "i", 9);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c0$1, ctx.isDisabled, ctx.sideBySide));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showRequiredText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.tooltip);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.label !== undefined);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c1, ctx.isDisabled, ctx.isChecked));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", ctx.name)("ngModel", ctx.isChecked)("id", ctx.id);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.ngModel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.ngModel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.icon !== undefined);
    } }, dependencies: [i1.NgClass, i1.NgIf, i2$1.NgbTooltip, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel], styles: [".tooltip-inner{max-width:400px;text-align:left;white-space:normal}.toggle-switch[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:default}.toggle-switch[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-left:5px;cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleSwitchComponent, [{
        type: Component,
        args: [{ selector: 'toggle-switch', providers: [], template: "<div class=\"form-field form-toggle toggle-switch\" [ngClass]=\"{ 'disabled': isDisabled, 'side-by-side': sideBySide }\">\n\t<div class=\"form-field-control\">\n\t\t<i *ngIf=\"showRequiredText\" class=\"icon icon-exclamation-circle text-danger\" [ngbTooltip]=\"requiredText\"\n\t\t   [placement]=\"placement\" [container]=\"container\"></i>\n\n\t\t<i *ngIf=\"tooltip\" class=\"icon icon-info-circle\" aria-hidden=\"true\" [ngbTooltip]=\"tooltip\"\n\t\t   [placement]=\"placement\" [container]=\"container\"></i>\n\n\t\t<label class=\"form-field-label\" for=\"{{id}}\" *ngIf=\"label !== undefined\">\n\t\t\t{{label}}\n\t\t</label>\n\n\t\t<div class=\"form-field-input\">\n            <span class=\"switch\"\n\t\t\t\t  [ngClass]=\"{ 'disabled': isDisabled, 'checked': isChecked }\"\n\t\t\t\t  (click)=\"onClick()\">\n                <small></small>\n                <input type=\"checkbox\"\n\t\t\t\t\t   [name]=\"name\"\n\t\t\t\t\t   [(ngModel)]=\"isChecked\"\n\t\t\t\t\t   (ngModelChange)=\"isCheckedChange.emit(isChecked)\"\n\t\t\t\t\t   style=\"display: none\"\n\t\t\t\t\t   [id]=\"id\"/>\n                <span *ngIf=\"ngModel\" class=\"status-label\"> {{onLabel}}</span>\n                <span *ngIf=\"!ngModel\" class=\"status-label\">{{offLabel}}</span>\n            </span>\n\t\t</div>\n\n\t\t<i *ngIf=\"icon !== undefined\" class=\"icon icon-{{icon}}\" style=\"padding-right: 10px;\"></i>\n\t</div>\n</div>\n", styles: ["::ng-deep .tooltip-inner{max-width:400px;text-align:left;white-space:normal}.toggle-switch label{cursor:default}.toggle-switch .icon{margin-left:5px;cursor:pointer}\n"] }]
    }], function () { return []; }, { id: [{
            type: Input
        }], isChecked: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], icon: [{
            type: Input
        }], sideBySide: [{
            type: Input
        }], showRequiredText: [{
            type: Input
        }], requiredText: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], onLabel: [{
            type: Input
        }], offLabel: [{
            type: Input
        }], container: [{
            type: Input
        }], placement: [{
            type: Input
        }], isCheckedChange: [{
            type: Output
        }] }); })();

class ToggleSwitchModule {
}
ToggleSwitchModule.ɵfac = function ToggleSwitchModule_Factory(t) { return new (t || ToggleSwitchModule)(); };
ToggleSwitchModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ToggleSwitchModule });
ToggleSwitchModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        NgbTooltipModule,
        FormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleSwitchModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ToggleSwitchComponent
                ],
                exports: [
                    ToggleSwitchComponent
                ],
                imports: [
                    CommonModule,
                    NgbTooltipModule,
                    FormsModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ToggleSwitchModule, { declarations: [ToggleSwitchComponent], imports: [CommonModule,
        NgbTooltipModule,
        FormsModule], exports: [ToggleSwitchComponent] }); })();

const _c0 = ["*"];
class ToolbarComponent {
}
ToolbarComponent.ɵfac = function ToolbarComponent_Factory(t) { return new (t || ToolbarComponent)(); };
ToolbarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToolbarComponent, selectors: [["toolbar"]], ngContentSelectors: _c0, decls: 2, vars: 0, consts: [[1, "toolbar"]], template: function ToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
    } }, styles: [".toolbar[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:50px;background-color:#f9f9f9;height:calc(100% - 50px);box-shadow:#00000014 2px 0 2px}.toolbar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:none;margin:0;height:50px;width:100%;color:#727272}.toolbar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:18px}.button-active[_ngcontent-%COMP%]{background-color:#ccc}.theme-default[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--default-primary),.9)}.theme-x-pick[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--xpick-primary),.9)}.theme-ai-studio[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--aistudio-primary),.9)}.theme-frontline-creator[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--creator-primary),.9)}.theme-x-make[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--xmake-primary),.9)}.theme-spatial[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--spatial-primary),.9)}.theme-admin[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--admin-secondary),.9)}.theme-x-assist[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--xassist-secondary),.9)}.theme-x-inspect[_ngcontent-%COMP%]   .button-active[_ngcontent-%COMP%]{color:rgba(var(--xinspect-primary),.9)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToolbarComponent, [{
        type: Component,
        args: [{ selector: 'toolbar', template: `<div class="toolbar"><ng-content></ng-content></div>`, styles: [".toolbar{display:flex;flex-direction:column;width:50px;background-color:#f9f9f9;height:calc(100% - 50px);box-shadow:#00000014 2px 0 2px}.toolbar button{border:none;margin:0;height:50px;width:100%;color:#727272}.toolbar button i{font-size:18px}.button-active{background-color:#ccc}.theme-default .button-active{color:rgba(var(--default-primary),.9)}.theme-x-pick .button-active{color:rgba(var(--xpick-primary),.9)}.theme-ai-studio .button-active{color:rgba(var(--aistudio-primary),.9)}.theme-frontline-creator .button-active{color:rgba(var(--creator-primary),.9)}.theme-x-make .button-active{color:rgba(var(--xmake-primary),.9)}.theme-spatial .button-active{color:rgba(var(--spatial-primary),.9)}.theme-admin .button-active{color:rgba(var(--admin-secondary),.9)}.theme-x-assist .button-active{color:rgba(var(--xassist-secondary),.9)}.theme-x-inspect .button-active{color:rgba(var(--xinspect-primary),.9)}\n"] }]
    }], null, null); })();

class ToolbarModule {
}
ToolbarModule.ɵfac = function ToolbarModule_Factory(t) { return new (t || ToolbarModule)(); };
ToolbarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ToolbarModule });
ToolbarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToolbarModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ToolbarComponent,
                ],
                exports: [
                    ToolbarComponent,
                ],
                imports: [
                    CommonModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ToolbarModule, { declarations: [ToolbarComponent], imports: [CommonModule], exports: [ToolbarComponent] }); })();

function ToolComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("icon icon-" + ctx_r0.icon);
} }
class ToolComponent {
    constructor() {
        this.icon = "";
        this.tooltip = "";
        this.toolClass = "";
        this.action = new EventEmitter();
    }
}
ToolComponent.ɵfac = function ToolComponent_Factory(t) { return new (t || ToolComponent)(); };
ToolComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToolComponent, selectors: [["tool"]], inputs: { icon: "icon", tooltip: "tooltip", toolClass: "toolClass" }, outputs: { action: "action" }, decls: 2, vars: 3, consts: [[1, "tool", 3, "ngClass", "ngbTooltip", "click"], ["class", "icon", 3, "class", 4, "ngIf"], [1, "icon"]], template: function ToolComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function ToolComponent_Template_button_click_0_listener() { return ctx.action.next(); });
        i0.ɵɵtemplate(1, ToolComponent_i_1_Template, 1, 2, "i", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.toolClass)("ngbTooltip", ctx.tooltip);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.icon);
    } }, dependencies: [i1.NgClass, i1.NgIf, i2$1.NgbTooltip], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToolComponent, [{
        type: Component,
        args: [{ selector: 'tool', template: "<button\n    class=\"tool\"\n    (click)=\"action.next()\"\n    [ngClass]=\"toolClass\"\n    [ngbTooltip]=\"tooltip\"\n>\n    <i class=\"icon\" *ngIf=\"icon\" [class]=\"'icon icon-' + icon\"></i>\n</button>\n" }]
    }], null, { icon: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], toolClass: [{
            type: Input
        }], action: [{
            type: Output
        }] }); })();

class ToolModule {
}
ToolModule.ɵfac = function ToolModule_Factory(t) { return new (t || ToolModule)(); };
ToolModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ToolModule });
ToolModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        NgbTooltipModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToolModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ToolComponent,
                ],
                exports: [
                    ToolComponent,
                ],
                imports: [
                    CommonModule,
                    NgbTooltipModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ToolModule, { declarations: [ToolComponent], imports: [CommonModule,
        NgbTooltipModule], exports: [ToolComponent] }); })();

function SingleEditableTextareaComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 5)(2, "a", 6);
    i0.ɵɵlistener("click", function SingleEditableTextareaComponent_div_3_Template_a_click_2_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.acceptEdit($event, ctx_r2.editableText)); });
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 8);
    i0.ɵɵlistener("click", function SingleEditableTextareaComponent_div_3_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.cancelEdit(ctx_r4.editableText)); });
    i0.ɵɵelement(5, "i", 9);
    i0.ɵɵelementEnd()()();
} }
function SingleEditableTextareaComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "a", 11);
    i0.ɵɵlistener("click", function SingleEditableTextareaComponent_div_4_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.editText(ctx_r5.editableText)); });
    i0.ɵɵelement(2, "i", 12);
    i0.ɵɵelementEnd()();
} }
class SingleEditableTextareaComponent {
    constructor(element) {
        this.element = element;
        this.text = null;
        this.canBeEdited = false;
        this.editOnClick = false;
        this.label = '';
        this.maxLength = 255;
        this.maxRows = 10;
        this.rows = 1;
        this.placeholder = '';
        this.xOnly = false;
        this.yOnly = false;
        this.resizeTextArea = true;
        this.textChanged = new EventEmitter();
        this.editableText = { text: "", isEdited: false, originalText: "" };
    }
    ngOnInit() {
        this.editableText.text = this.text ? this.text : "";
        this.editableText.originalText = this.text ? this.text : "";
    }
    ngOnChanges(changes) {
        if (changes.text) {
            this.text = changes.text.currentValue;
            this.editableText.text = changes.text.currentValue;
        }
        if (changes.canBeEdited !== undefined) {
            this.canBeEdited = changes.canBeEdited.currentValue;
        }
    }
    editText(editableText) {
        editableText.originalText = editableText.text ? editableText.text : "";
        editableText.isEdited = true;
        window.setTimeout(() => {
            this.element.nativeElement.getElementsByTagName("textarea").item(0).focus();
        }, 100);
    }
    cancelEdit(editableText) {
        editableText.isEdited = false;
        editableText.text = editableText.originalText;
    }
    acceptEdit($event, editableText) {
        if ($event instanceof KeyboardEvent && ($event.code === "Enter" || $event.code === "NumpadEnter")) {
            $event.preventDefault();
            return;
        }
        this.textChanged.next(editableText.text);
        editableText.isEdited = false;
    }
    toggleEdit() {
        if (this.editOnClick) {
            this.editText(this.editableText);
        }
    }
}
SingleEditableTextareaComponent.ɵfac = function SingleEditableTextareaComponent_Factory(t) { return new (t || SingleEditableTextareaComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
SingleEditableTextareaComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleEditableTextareaComponent, selectors: [["single-editable-textarea"]], inputs: { text: "text", canBeEdited: "canBeEdited", editOnClick: "editOnClick", label: "label", maxLength: "maxLength", maxRows: "maxRows", rows: "rows", placeholder: "placeholder", xOnly: "xOnly", yOnly: "yOnly", resizeTextArea: "resizeTextArea" }, outputs: { textChanged: "textChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 12, consts: [[1, "row"], [1, "col", "col-sm-12", "editable-text"], [1, "editable-caption-text", 3, "disabled", "label", "ngModel", "maxLength", "placeholder", "maxRows", "rows", "resizeTextArea", "xOnly", "yOnly", "click", "ngModelChange", "keyup.enter"], ["class", "editable-text-input-buttons", 4, "ngIf"], ["class", "editable-caption-button", 4, "ngIf"], [1, "editable-text-input-buttons"], ["id", "acceptEdit", 3, "click"], [1, "icon", "icon-check"], ["id", "cancelEdit", 3, "click"], [1, "icon", "icon-times"], [1, "editable-caption-button"], ["id", "editText", 3, "click"], [1, "icon", "icon-pen", "editable-caption-buttons"]], template: function SingleEditableTextareaComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "form-field-textarea", 2);
        i0.ɵɵlistener("click", function SingleEditableTextareaComponent_Template_form_field_textarea_click_2_listener() { return ctx.toggleEdit(); })("ngModelChange", function SingleEditableTextareaComponent_Template_form_field_textarea_ngModelChange_2_listener($event) { return ctx.editableText.text = $event; })("keyup.enter", function SingleEditableTextareaComponent_Template_form_field_textarea_keyup_enter_2_listener($event) { return ctx.acceptEdit($event, ctx.editableText); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, SingleEditableTextareaComponent_div_3_Template, 6, 0, "div", 3);
        i0.ɵɵtemplate(4, SingleEditableTextareaComponent_div_4_Template, 3, 0, "div", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", !ctx.editableText.isEdited)("label", ctx.label)("ngModel", ctx.editableText.text)("maxLength", ctx.maxLength)("placeholder", ctx.placeholder)("maxRows", ctx.maxRows)("rows", ctx.rows)("resizeTextArea", ctx.resizeTextArea)("xOnly", ctx.xOnly)("yOnly", ctx.yOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.editableText.isEdited);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.canBeEdited && !ctx.editableText.isEdited);
    } }, dependencies: [i1.NgIf, FormFieldTextareaComponent], styles: [".editable-text[_ngcontent-%COMP%]{display:flex}.editable-text[_ngcontent-%COMP%]   .editable-text-label-input[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:95%;font-size:15px;padding-right:10px;flex-grow:1;flex-basis:auto;margin-top:0}.editable-text-input-buttons[_ngcontent-%COMP%]{display:flex}.editable-text-input-buttons[_ngcontent-%COMP%]   .editable-text-input-buttons[_ngcontent-%COMP%]{display:inline-block;align-self:flex-end}.editable-caption-text[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:95%;font-size:15px;padding-right:10px;flex-grow:1;flex-basis:auto}.editable-caption-button[_ngcontent-%COMP%]{padding:3px 5px 0 0;display:flex;height:100%}.editable-caption-button[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;align-self:flex-end}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SingleEditableTextareaComponent, [{
        type: Component,
        args: [{ selector: 'single-editable-textarea', template: "<div class=\"row\">\n\t<div class=\"col col-sm-12 editable-text\">\n\t\t<form-field-textarea class=\"editable-caption-text\"\n\t\t\t\t\t\t\t (click)=\"toggleEdit()\"\n\t\t\t\t\t\t\t [disabled]=\"!editableText.isEdited\"\n\t\t\t\t\t\t\t [label]=\"label\"\n\t\t\t\t\t\t\t [(ngModel)]=\"editableText.text\"\n\t\t\t\t\t\t\t (keyup.enter)=\"acceptEdit($event, editableText)\"\n\t\t\t\t\t\t\t [maxLength]=\"maxLength\"\n\t\t\t\t\t\t\t [placeholder]=\"placeholder\"\n\t\t\t\t\t\t\t [maxRows]=\"maxRows\"\n\t\t\t\t\t\t\t [rows]=\"rows\"\n\t\t\t\t\t\t\t [resizeTextArea]=\"resizeTextArea\"\n\t\t\t\t\t\t\t [xOnly]=\"xOnly\"\n\t\t\t\t\t\t\t [yOnly]=\"yOnly\">\n\t\t</form-field-textarea>\n\t\t<div *ngIf=\"editableText.isEdited\"\n\t\t\t class=\"editable-text-input-buttons\">\n\t\t\t<div class=\"editable-text-input-buttons\">\n\t\t\t\t<a (click)=\"acceptEdit($event, editableText)\" id=\"acceptEdit\"><i class=\"icon icon-check\"></i></a>\n\t\t\t\t<a (click)=\"cancelEdit(editableText)\" id=\"cancelEdit\"><i class=\"icon icon-times\"></i></a>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div *ngIf=\"canBeEdited && !editableText.isEdited\" class=\"editable-caption-button\">\n\t\t\t<a id=\"editText\" (click)=\"editText(editableText)\"><i class=\"icon icon-pen editable-caption-buttons\"></i></a>\n\t\t</div>\n\t</div>\n</div>\n", styles: [".editable-text{display:flex}.editable-text .editable-text-label-input{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:95%;font-size:15px;padding-right:10px;flex-grow:1;flex-basis:auto;margin-top:0}.editable-text-input-buttons{display:flex}.editable-text-input-buttons .editable-text-input-buttons{display:inline-block;align-self:flex-end}.editable-caption-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:95%;font-size:15px;padding-right:10px;flex-grow:1;flex-basis:auto}.editable-caption-button{padding:3px 5px 0 0;display:flex;height:100%}.editable-caption-button a{display:inline-block;align-self:flex-end}\n"] }]
    }], function () { return [{ type: i0.ElementRef }]; }, { text: [{
            type: Input
        }], canBeEdited: [{
            type: Input
        }], editOnClick: [{
            type: Input
        }], label: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], maxRows: [{
            type: Input
        }], rows: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], xOnly: [{
            type: Input
        }], yOnly: [{
            type: Input
        }], resizeTextArea: [{
            type: Input
        }], textChanged: [{
            type: Output
        }] }); })();

class SingleEditableTextareaModule {
}
SingleEditableTextareaModule.ɵfac = function SingleEditableTextareaModule_Factory(t) { return new (t || SingleEditableTextareaModule)(); };
SingleEditableTextareaModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SingleEditableTextareaModule });
SingleEditableTextareaModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormFieldTextareaModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SingleEditableTextareaModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SingleEditableTextareaComponent,
                ],
                exports: [
                    SingleEditableTextareaComponent,
                ],
                imports: [
                    CommonModule,
                    FormFieldTextareaModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SingleEditableTextareaModule, { declarations: [SingleEditableTextareaComponent], imports: [CommonModule,
        FormFieldTextareaModule], exports: [SingleEditableTextareaComponent] }); })();

class ComponentsModule {
}
ComponentsModule.ɵfac = function ComponentsModule_Factory(t) { return new (t || ComponentsModule)(); };
ComponentsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ComponentsModule });
ComponentsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ApplicationMenuModule,
        ButtonPrimaryModule,
        ButtonQuaternaryModule,
        ButtonSecondaryModule,
        ButtonSecondaryDropdownModule,
        CheckboxModule,
        DatasetSliderModule,
        DateRangeModule,
        DateTimeModule,
        DirectivesModule,
        ImageTileModule,
        MenuItemModule,
        MenuItemDropdownModule,
        MultiselectDropdownModule,
        PageHeaderModule,
        ShareButtonModule,
        SubMenuItemModule,
        SubMenuItemTileModule,
        TagsInputModule,
        TagCellRendererModule,
        ToggleSwitchModule,
        ToolbarModule,
        ToolModule,
        SingleEditableTextModule,
        SingleEditableTextareaModule,
        FileUploadButtonModule,
        TagsInputModule,
        TextInputsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [CommonModule],
                exports: [
                    ApplicationMenuModule,
                    ButtonPrimaryModule,
                    ButtonQuaternaryModule,
                    ButtonSecondaryModule,
                    ButtonSecondaryDropdownModule,
                    CheckboxModule,
                    DatasetSliderModule,
                    DateRangeModule,
                    DateTimeModule,
                    DirectivesModule,
                    ImageTileModule,
                    MenuItemModule,
                    MenuItemDropdownModule,
                    MultiselectDropdownModule,
                    PageHeaderModule,
                    ShareButtonModule,
                    SubMenuItemModule,
                    SubMenuItemTileModule,
                    TagsInputModule,
                    TagCellRendererModule,
                    ToggleSwitchModule,
                    ToolbarModule,
                    ToolModule,
                    SingleEditableTextModule,
                    SingleEditableTextareaModule,
                    FileUploadButtonModule,
                    TagsInputModule,
                    TextInputsModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ComponentsModule, { imports: [CommonModule], exports: [ApplicationMenuModule,
        ButtonPrimaryModule,
        ButtonQuaternaryModule,
        ButtonSecondaryModule,
        ButtonSecondaryDropdownModule,
        CheckboxModule,
        DatasetSliderModule,
        DateRangeModule,
        DateTimeModule,
        DirectivesModule,
        ImageTileModule,
        MenuItemModule,
        MenuItemDropdownModule,
        MultiselectDropdownModule,
        PageHeaderModule,
        ShareButtonModule,
        SubMenuItemModule,
        SubMenuItemTileModule,
        TagsInputModule,
        TagCellRendererModule,
        ToggleSwitchModule,
        ToolbarModule,
        ToolModule,
        SingleEditableTextModule,
        SingleEditableTextareaModule,
        FileUploadButtonModule,
        TagsInputModule,
        TextInputsModule] }); })();

/// generated by: scripts/generatePublicApi.js

/**
 * Generated bundle index. Do not edit.
 */

export { ApplicationMenuComponent, ApplicationMenuModule, ButtonPrimaryComponent, ButtonPrimaryModule, ButtonQuaternaryComponent, ButtonQuaternaryModule, ButtonSecondaryComponent, ButtonSecondaryDropdownComponent, ButtonSecondaryDropdownModule, ButtonSecondaryModule, CheckBoxComponent, CheckboxModule, ComponentsModule, DatasetSliderComponent, DatasetSliderModule, DateRangeComponent, DateRangeModule, DateTimeComponent, DateTimeModule, DirectivesModule, FileUploadButtonComponent, FileUploadButtonModule, FormFieldInputDirective, FormFieldInputModule, FormFieldTextInputComponent, FormFieldTextInputModule, FormFieldTextareaComponent, FormFieldTextareaModule, ImageTileComponent, ImageTileModule, LightboxComponent, LightboxDirective, LightboxModule, MenuItemComponent, MenuItemDropdownComponent, MenuItemDropdownModule, MenuItemModule, MultiselectDropdownComponent, MultiselectDropdownModule, PageHeaderComponent, PageHeaderModule, ShareButtonComponent, ShareButtonModule, SingleEditableTextComponent, SingleEditableTextModule, SingleEditableTextareaComponent, SingleEditableTextareaModule, SubMenuItemComponent, SubMenuItemModule, SubMenuItemTileComponent, SubMenuItemTileModule, TableScrollDirective, TablescrollModule, TagCellRendererComponent, TagCellRendererModule, TagsInputComponent, TagsInputModule, TextInputsModule, ToggleSwitchComponent, ToggleSwitchModule, ToolComponent, ToolModule, ToolbarComponent, ToolbarModule, UploadDirective, UploadModule };
